import Alert from './bootstrap/alert';
import Carousel from './bootstrap/carousel';
import Collapse from './bootstrap/collapse';
import Dropdown from './bootstrap/dropdown';
import Modal from './bootstrap/modal';
import Tab from './bootstrap/tab';
import Tooltip from './bootstrap/tooltip';
import Sortable from 'sortablejs';

let bootstrap = {
    Alert,
    Carousel,
    Collapse,
    Dropdown,
    Modal,
    Tab,
    Tooltip
};

global.PallasartUrl = {
    templates: '',

    register: '',
    login: '',
    customer_status: '',
    customer_login: '',
    customer_info: '',
    save_home: '',

    flyer: '',
    plan_details: '',
    lots: '',
    lot: '',
    slsord: '',
    communities: '',
};

global.PallasartUtils = {
    loading: '<svg viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg"><circle class="circle" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle></svg>',

    templateRowAdd: function(target, selector) {
        let element = document.querySelector(target);
        let template = document.querySelector(selector);

        if (element) {
            let numChildren = element.children.length;
            element.insertAdjacentHTML('beforeend', template.innerHTML.trim().replaceAll('$INDEX', numChildren + 1));
        }
    },

    templateRowRemove: function(source, selector) {
        let element = source.closest(selector);

        if (element) {
            element.remove();
        }

        return false;
    },

    sortable: function(selector) {
        let elements = document.querySelectorAll(selector);

        if (elements) {
            for (const element of elements) {
                new Sortable(element, {
                    handle: '.drag-handle',
                    draggable: '.drag-item'
                });
            }
        }
    },

    currentUrl: function() {
        return (window.location.protocol + '//' + window.location.hostname + window.location.pathname + (window.location.search ? window.location.search : ''));
    },

    currentPath: function() {
        return (window.location.pathname + (window.location.search ? window.location.search : ''));
    },

    formatPhone: function(element) {
        const value = element.value;

        if (value.length) {
            const number = value.replace(/[^\d]/g, "");
            const length = number.length;

            if (length < 4) {
                element.value = number;
            } else if (length < 7) {
                element.value = '(' + number.slice(0, 3) + ') ' + number.slice(3);
            } else {
                element.value = '(' + number.slice(0, 3) + ') ' + number.slice(3, 6) + '-' + number.slice(6, 10);
            }
        }
    },

    formatNumber: function(element) {
        const value = element.value;

        if (value.length) {
            element.value = value.replace(/[^\d]/g, "");
        }
    },

    formatPrice: function(value) {
        if ((value - Math.floor(value)) > 0) {
            return value.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });
        } else {
            return value.toLocaleString('en-US', {
                minimumFractionDigits: 0,
                maximumFractionDigits: 0
            });
        }
    },

    isNumeric: function(n) {
        return !isNaN(parseFloat(n)) && isFinite(n);
    },

    parseNumeric: function (value) {
        if (!PallasartUtils.isNumeric(value)) {
            return Number(value.replace(/(\D)*/i, '').replace(',', ''));
        } else {
            return Number(value);
        }
    },

    preventEnter: function(e) {
        e = e || window.event;

        return e.keyCode !== 13;
    },

    objectPropertyExists: function(obj, prop) {
        return (obj !== null) && (typeof obj === 'object') && obj.hasOwnProperty(prop);
    },

    isElement: function(obj) {
        try {
            return obj instanceof HTMLElement;
        } catch(e) {
            return (typeof obj === "object") && (obj.nodeType === 1) && (typeof obj.style === "object") && (typeof obj.ownerDocument === "object");
        }
    },

    isMobileView: function() {
        return (window.innerWidth < 992);
    },

    plaintext: function(str) {
        return encodeURIComponent(str);
    },

    validateInput: function(element) {
        let parent = element.closest('.bs-form-group');

        PallasartUtils.clearChildren(parent, '.bs-text-danger');
        element.classList.remove('is-valid');
        element.classList.remove('is-invalid');

        if (element.validity.valueMissing && element.getAttribute('data-value-missing')) {
            let error = PallasartUtils.createErrorNote(element.getAttribute('data-value-missing'));
            parent.append(error);
            element.classList.add('is-invalid');
        } else if (element.validity.patternMismatch && element.getAttribute('data-pattern-mismatch')) {
            let error = PallasartUtils.createErrorNote(element.getAttribute('data-pattern-mismatch'));
            parent.append(error);
            element.classList.add('is-invalid');
        } else if (element.validity.typeMismatch && element.getAttribute('data-type-mismatch')) {
            let error = PallasartUtils.createErrorNote(element.getAttribute('data-type-mismatch'));
            parent.append(error);
            element.classList.add('is-invalid');
        } else {
            element.classList.add('is-valid');
        }
    },

    clearChildren: function(container, selector) {
        if (container) {
            let errors = container.querySelectorAll(selector);
            for (const error of errors) {
                error.remove();
            }
        }
    },

    getRoot: function() {
        let root = document.getElementById('bs-root');

        if (root) {
            return root;
        } else {
            root = document.createElement('div');
            root.setAttribute('id', 'bs-root');
            root.classList.add('bs-root');
            // document.getElementsByTagName('body')[0].append(root);
            document.getElementById('app').append(root);

            return root;
        }
    },

    toggleLoading: function(on) {
        let root = PallasartUtils.getRoot();

        if (on !== false) {
            let spinner = document.createElement('div');
            spinner.classList.add('bs-widget-spinner');
            spinner.setAttribute('title', 'Loading...');
            spinner.innerHTML = PallasartUtils.loading;
            root.append(spinner);
        } else {
            let spinner = root.querySelector('.bs-widget-spinner');
            if (spinner) {
                spinner.remove();
            }
        }
    },

    createSpinner: function(dark, center) {
        let spinner = document.createElement('span');
        spinner.classList.add('bs-widget-spin');

        if (dark === true) {
            spinner.classList.add('bs-dark');
        }

        if (center === true) {
            spinner.classList.add('bs-center');
        }

        spinner.setAttribute('title', 'Loading...');
        spinner.innerHTML = PallasartUtils.loading;
        return spinner;
    },

    destroySpinner: function(target) {
        let spinners = target.querySelectorAll('.bs-widget-spin');

        for (const spinner of spinners) {
            spinner.remove();
        }
    },

    showModal: function(selector) {
        let popup = Modal.getOrCreateInstance(document.querySelector(selector));

        if (popup) {
            popup.show();
            return popup;
        }

        return false;
    },

    hideModal: function(selector) {
        let popup = Modal.getOrCreateInstance(document.querySelector(selector));

        if (popup) {
            popup.hide();
        }
    },

    destroyModal: function(id) {
        if ((typeof id === 'undefined') || (id === false) || (id === null)) {
            id = 'bs-modal-popup';
        }

        let modal = document.getElementById('bs-modal-popup');
        if (modal) {
            let popup = Modal.getOrCreateInstance(modal);
            popup.hide();

            let backdrops = document.querySelectorAll('.bs-modal-backdrop');

            if (backdrops.length) {
                for (const backdrop of backdrops) {
                    backdrop.remove();
                }
            }

            modal.remove();
        }
    },

    createModal: function(message, headline, reload, cleanLoad, modalClass, dialogClass, buttonText, id) {
        if ((typeof id === 'undefined') || (id === false) || (id === null)) {
            id = 'bs-modal-popup';
        }

        PallasartUtils.destroyModal(id);

        let modal = document.createElement('div'),
            dialog = document.createElement('div'),
            content = document.createElement('div'),
            body = document.createElement('div');

        modal.classList.add('bs-modal');
        modal.classList.add('bs-fade');

        if ((typeof modalClass !== 'undefined') && (modalClass !== false)) {
            let tokens = modalClass.split(' ');

            for (const token of tokens) {
                modal.classList.add(token);
            }
        } else {
            modal.classList.add('bs-popup');
        }

        modal.setAttribute('id', id);
        modal.setAttribute('tabindex', '-1');
        modal.setAttribute('aria-hidden', 'true');
        modal.setAttribute('data-bs-backdrop', 'static');
        modal.setAttribute('data-bs-keyboard', 'false');

        dialog.classList.add('bs-modal-dialog');
        dialog.classList.add('bs-modal-dialog-centered');

        if ((typeof dialogClass !== 'undefined') && (dialogClass !== false)) {
            dialog.classList.add(dialogClass);
        } else {
            dialog.classList.add('bs-modal-lg');
        }

        content.classList.add('bs-modal-content');

        body.classList.add('bs-modal-body');

        if (PallasartUtils.isElement(message)) {
            body.append(message);
        } else {
            body.innerHTML = message;
        }

        if ((typeof headline !== 'undefined') && (headline !== false)) {
            let header = document.createElement('div'),
                action = document.createElement('button');

            header.classList.add('bs-modal-header');

            action.classList.add('bs-btn-close');
            action.setAttribute('type', 'button');
            action.setAttribute('aria-label', 'Close');
            action.setAttribute('data-bs-dismiss', 'bs-modal');

            if (reload === true) {
                action.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    window.location.reload();
                });
            } else if (cleanLoad === true) {
                action.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    window.location.href = PallasartUtils.currentUrl();
                });
            } else if (PallasartV2.cache.get_started === true) {
                action.addEventListener('click', function(e) {
                    PallasartV2.getStarted();
                });
            }

            if (headline !== true) {
                let title = document.createElement('h3');
                title.classList.add('bs-modal-title');
                title.innerHTML = headline;
                header.append(title);
            }

            header.append(action);
            content.append(header);
        } else {
            let paragraph = document.createElement('p'),
                button = document.createElement('button');

            paragraph.classList.add('bs-text-center');
            paragraph.classList.add('bs-mt-3');
            paragraph.classList.add('bs-mb-0');

            button.classList.add('bs-btn');
            button.classList.add('bs-btn-lg');
            button.classList.add('bs-btn-modal');
            button.setAttribute('type', 'button');
            button.setAttribute('aria-label', 'Close');
            button.setAttribute('data-bs-dismiss', 'bs-modal');

            if ((typeof buttonText !== 'undefined') && (buttonText !== false)) {
                button.innerText = buttonText;
            } else {
                button.innerText = 'Close';
            }

            if (reload === true) {
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    window.location.reload();
                });
            } else if (cleanLoad === true) {
                button.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    window.location.href = PallasartUtils.currentUrl();
                });
            }

            paragraph.append(button);
            body.append(paragraph);
        }

        content.append(body);
        dialog.append(content);
        modal.append(dialog);

        let root = PallasartUtils.getRoot();
        root.append(modal);

        let popup = new bootstrap.Modal(document.getElementById(id));
        popup.show();

        return popup;
    },

    createModalFromElement: function(element, hasClose) {
        PallasartUtils.destroyModal();

        let modal = document.createElement('div'),
            dialog = document.createElement('div'),
            content = document.createElement('div'),
            body = document.createElement('div');

        modal.classList.add('bs-modal');
        modal.classList.add('bs-fade');

        if (hasClose !== true) {
            modal.classList.add('bs-slideshow');
        }

        modal.setAttribute('id', 'bs-modal-popup');
        modal.setAttribute('tabindex', '-1');
        modal.setAttribute('aria-hidden', 'true');
        modal.setAttribute('data-bs-backdrop', 'static');
        modal.setAttribute('data-bs-keyboard', 'false');

        dialog.classList.add('bs-modal-dialog');
        dialog.classList.add('bs-modal-dialog-centered');
        dialog.classList.add('bs-modal-xl');

        content.classList.add('bs-modal-content');

        body.classList.add('bs-modal-body');

        if (hasClose !== true) {
            let action = document.createElement('button');
            action.classList.add('bs-btn-close');
            action.setAttribute('type', 'button');
            action.setAttribute('aria-label', 'Close');
            action.setAttribute('data-bs-dismiss', 'bs-modal');

            body.append(action);
        }

        body.append(element);

        if (hasClose === true) {
            let paragraph = document.createElement('p'),
                button = document.createElement('button');

            paragraph.classList.add('bs-text-center');
            paragraph.classList.add('bs-mt-3');
            paragraph.classList.add('bs-mb-0');

            button.classList.add('bs-btn');
            button.classList.add('bs-btn-outline-orange');
            button.setAttribute('type', 'button');
            button.setAttribute('aria-label', 'Close');
            button.setAttribute('data-bs-dismiss', 'bs-modal');
            button.innerText = 'Close';

            paragraph.append(button);
            body.append(paragraph);
        }

        content.append(body);
        dialog.append(content);
        modal.append(dialog);

        let root = PallasartUtils.getRoot();
        root.append(modal);

        let popup = new bootstrap.Modal(document.getElementById('bs-modal-popup'));
        popup.show();

        return popup;
    },

    destroyBanner: function() {
        let banner = document.getElementById('bs-banner');
        if (banner) {
            banner.remove();
        }
    },

    createBanner: function(message, toast) {
        if (PallasartParadigm.wrapper) {
            PallasartUtils.destroyBanner();

            let banner = document.createElement('div');

            banner.classList.add('bs-widget-banner');

            if (toast === true) {
                banner.classList.add('bs-banner-toast')
            }

            banner.setAttribute('id', 'bs-banner');
            banner.setAttribute('tabindex', '-1');
            banner.setAttribute('aria-hidden', 'true');
            banner.innerHTML = message;

            PallasartParadigm.wrapper.parentElement.append(banner);
        }
    },

    createErrorAlert: function(message) {
        let error = document.createElement('div');
        error.classList.add('bs-alert');
        error.classList.add('bs-alert-danger');
        error.setAttribute('role', 'alert');
        error.innerHTML = message;

        return error;
    },

    createErrorNote: function(message) {
        let error = document.createElement('div');
        error.classList.add('bs-text-danger');
        error.innerHTML = message;

        return error;
    },

    toggleClass: function(element, classes) {
        for (const cls of classes) {
            if (element.classList.contains(cls)) {
                element.classList.remove(cls);
            } else {
                element.classList.add(cls);
            }
        }
    },

    slideshow: function(images, index) {
        let carousel = document.createElement('div'),
            inner = document.createElement('div'),
            actions = document.createElement('div'),
            // caption = document.createElement('div'),
            buttons = document.createElement('div'),
            prev = document.createElement('a'),
            next = document.createElement('a'),
            progress = document.createElement('span'),
            counter = document.createElement('span'),
            total = document.createElement('span');

        if ((index < 0) || (index >= images.length)) {
            index = 0;
        }

        carousel.setAttribute('id', 'slideshowCarousel');
        carousel.setAttribute('data-bs-ride', 'false');
        carousel.classList.add('bs-carousel');
        carousel.classList.add('bs-slide');
        carousel.classList.add('bs-carousel-fade');
        inner.classList.add('bs-carousel-inner');

        let i = 0;

        for (const image of images) {
            let item = document.createElement('div'),
                img = document.createElement('img');

            item.classList.add('bs-carousel-item');

            if (i === index) {
                item.classList.add('bs-active');
            }

            img.classList.add('bs-d-block');
            img.classList.add('bs-w-100');
            img.setAttribute('src', image['src']);
            img.setAttribute('alt', image['alt']);

            item.append(img);
            inner.append(item);

            i++;
        }

        carousel.append(inner);

        carousel.addEventListener('slide.bs.carousel', function(e) {
            // caption.innerText = images[e.to]['alt'];
            counter.innerText = e.to + 1;
        });

        actions.classList.add('bs-actions');
        // caption.classList.add('bs-caption');
        buttons.classList.add('bs-buttons');

        // caption.innerText = images[index]['alt'];

        prev.setAttribute('role', 'button');
        next.setAttribute('role', 'button');
        prev.innerText = '⟵';
        next.innerText = '⟶';

        prev.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            let instance = Carousel.getOrCreateInstance(carousel);
            instance.prev();
        });

        next.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();

            let instance = Carousel.getOrCreateInstance(carousel);
            instance.next();
        });

        counter.innerText = index + 1;
        total.innerText = '/' + images.length + ' Image' + (images.length > 1 ? 's' : '');

        buttons.append(prev);
        buttons.append(counter);
        buttons.append(total);
        buttons.append(next);
        // actions.append(caption);
        actions.append(buttons);
        carousel.append(actions);

        PallasartUtils.createModalFromElement(carousel);
    },

    lotName: function(name) {
        let tokens = name.split(',');
        let lotCaption = name;

        if (tokens.length > 1) {
            tokens.shift();
            lotCaption = tokens.join(',').trim();
        }

        return lotCaption;
    },

    hideTooltips: function(selector) {
        let tooltips = document.querySelectorAll(selector);
        for (const tooltip of tooltips) {
            let instance = Tooltip.getInstance(tooltip);
            if (instance) {
                instance.dispose();
            }
        }

        tooltips = document.querySelectorAll('.bs-tooltip');
        for (const tooltip of tooltips) {
            tooltip.remove();
        }
    },

    showTooltips: function(wrapper, selector) {
        PallasartUtils.hideTooltips(selector);
        wrapper = document.querySelector(wrapper);

        if (wrapper) {
            let tooltips = wrapper.querySelectorAll(selector);
            for (const tooltip of tooltips) {
                let instance = Tooltip.getOrCreateInstance(tooltip);
                if (instance) {
                    instance.show();
                }
            }
        }
    }
};

global.PallasartParadigm = {
    endpoint: null,
    builderId: null,
    clientId: null,

    wrapper: null,
    instance: null,
    key: null,
    config: null,
    state: null,
    autoload: null,
    stage_home: null,

    cache: {
        options: {},
        answered: [],
        yaw: false,
        pitch: false,
        hfov: false,
        scene: false,
    },

    setNewCredentials: function() {
        // LIVE
        PallasartParadigm.endpoint = 'https://visualize.mybuild.wtsparadigm.com/omnibuilder/api/v1/';
        PallasartParadigm.builderId = '5c499cf8-6483-4454-b531-b4111ed00326';
        PallasartParadigm.clientId = 'f41bd135-fa4e-4eca-8255-98cbe9e8d0ec';

        // DEV
        // PallasartParadigm.endpoint = 'https://visualize.mybuild-cdev.wtsparadigm.com/omnibuilder/api/v1/';
        // PallasartParadigm.builderId = '90da2c9e-f674-4556-ba9b-bacb8fea450c';
        // PallasartParadigm.clientId = '0e9467d6-6705-4feb-a846-c5dcaeeba917';

        PallasartParadigm.resetInstance();
    },

    setOldCredentials: function() {
        // LIVE
        PallasartParadigm.endpoint = 'https://visualize.mybuild.wtsparadigm.com/omnibuilder/api/v1/';
        PallasartParadigm.builderId = '90da2c9e-f674-4556-ba9b-bacb8fea450c';
        PallasartParadigm.clientId = 'f41bd135-fa4e-4eca-8255-98cbe9e8d0ec';

        // DEV
        // PallasartParadigm.endpoint = 'https://visualize.mybuild-cdev.wtsparadigm.com/omnibuilder/api/v1/';
        // PallasartParadigm.builderId = '5197a9d1-0d6b-4f66-960e-49753db744b9';
        // PallasartParadigm.clientId = '0e9467d6-6705-4feb-a846-c5dcaeeba917';

        PallasartParadigm.resetInstance();
    },

    resetInstance: function() {
        PallasartParadigm.instance = null;
        PallasartParadigm.key = null;
        PallasartParadigm.config = null;
        PallasartParadigm.state = null;
        PallasartParadigm.autoload = null;
        PallasartParadigm.stage_home = null;
        PallasartParadigm.cache.options = {};
        PallasartParadigm.cache.answered = [];
        PallasartParadigm.cache.yaw = false;
        PallasartParadigm.cache.pitch = false;
        PallasartParadigm.cache.hfov = false;
        PallasartParadigm.cache.scene = false;

        PallasartParadigm.wrapper.classList.remove('pnlm-container')
        PallasartParadigm.wrapper.innerHTML = '';
    },

    getStep: function() {
        if (!PallasartParadigm.config) {
            return false;
        }

        for (const step of PallasartParadigm.state.steps) {
            if (step.name === 'apiQuestions') {
                return step.id;
            }
        }

        return false;
    },

    getQuestion: function() {
        if (!PallasartParadigm.state) {
            return false;
        }

        if (PallasartUtils.objectPropertyExists(PallasartParadigm.state, 'currentStepData') && PallasartParadigm.state.currentStepData) {
            for (const question of PallasartParadigm.state.currentStepData.questions) {
                if (question.questionText === 'SuperQuestion') {
                    return question;
                }
            }
        } else if (PallasartUtils.objectPropertyExists(PallasartParadigm.state, 'questions') && PallasartParadigm.state.questions) {
            for (const question of PallasartParadigm.state.questions) {
                if (question.questionText === 'SuperQuestion') {
                    return question;
                }
            }
        }

        return false;
    },

    answer: function(options) {
        let cache = PallasartParadigm.cache.answered;
        let selected = {};
        let deselected = [];
        PallasartParadigm.cache.answered = [];

        let kitchenColor = '';
        let blackMatte = false;
        let resetBlackMatte = false;

        if (options) {
            for (const optionId of Object.keys(options)) {
                if (options[optionId].Type === 'SingleChoice') {
                    if ((optionId in cache) && !options[optionId].Selected) {
                        delete cache[optionId];
                        deselected.push(optionId);
                    }

                    if (options[optionId].Selected) {
                        PallasartParadigm.cache.answered[optionId] = options[optionId];

                        if (!(optionId in cache)) {
                            selected[optionId] = options[optionId].ID + '||';
                        }
                    } else if (!options[optionId].Enabled && (optionId in cache)) {
                        deselected.push(optionId);
                    }
                } else if (options[optionId].Type === 'MultiChoice') {
                    let isDeselected = false;

                    if (optionId in cache) {
                        for (const choice of options[optionId].Choices) {
                            if ((choice.ID === cache[optionId]) && !choice.Selected) {
                                isDeselected = true;
                            }
                        }
                    }

                    if (isDeselected) {
                        delete cache[optionId];
                        deselected.push(optionId);

                        if (optionId === 'PB-KITFC') {
                            resetBlackMatte = true;
                        }
                    }

                    for (const choice of options[optionId].Choices) {
                        if (choice.Enabled && choice.Selected) {
                            if (optionId === 'FL-KITDIN') {
                                let tokens = choice.ID.split('|');
                                if (tokens.length > 2) {
                                    kitchenColor = tokens[2];
                                }
                            }

                            if ((optionId === 'PB-KITFC') && (choice.ID == 'plkitslebm||Black Matte')) {
                                blackMatte = true;
                            }

                            PallasartParadigm.cache.answered[optionId] = choice;

                            if (!(optionId in cache) || (cache[optionId].ID !== choice.ID)) {
                                if ((choice.ID.substring(choice.ID.length - 2) == '||') && ((choice.Color.toLowerCase() == 'not selected') || (choice.Style.toLowerCase() == 'not selected') || (choice.Text.toLowerCase() == 'not selected'))) {
                                    deselected.push(optionId);
                                }

                                selected[optionId] = choice.ID;
                            }
                        }
                    }
                } else if (options[optionId].Type === 'QuantityChoice') {
                    if ((optionId in cache) && !options[optionId].Selected) {
                        delete cache[optionId];
                        deselected.push(optionId);
                    }

                    if (options[optionId].Selected && parseInt(options[optionId].Value)) {
                        PallasartParadigm.cache.answered[optionId] = options[optionId];

                        if (!(optionId in cache) || (parseInt(options[optionId].Value) !== parseInt(PallasartParadigm.cache.answered[optionId].Value))) {
                            selected[optionId] = options[optionId].Value;
                        }
                    } else if (!options[optionId].Enabled && (optionId in cache)) {
                        deselected.push(optionId);
                    }
                }
            }

            for (const oldOptionId of Object.keys(cache)) {
                let found = false;

                for (const newOptionId of Object.keys(PallasartParadigm.cache.answered)) {
                    if (oldOptionId === newOptionId) {
                        found = true;
                    }
                }

                if (!found && (deselected.indexOf(oldOptionId) === -1)) {
                    deselected.push(oldOptionId);
                }
            }
        }

        if (PallasartParadigm.stage_home === true) {
            selected['Home Decor Staging'] = 'Yes';
        } else if (PallasartParadigm.stage_home === false) {
            PallasartParadigm.stage_home = null;
            deselected.push('Home Decor Staging');
        }

        if (PallasartUtils.objectPropertyExists(selected, 'PT-EXT')) {
            if (!PallasartUtils.objectPropertyExists(selected, 'EX-MAS')) {
                let masonry = PallasartOptions.selectedMasonry();

                if (masonry !== false) {
                    selected['EX-MAS'] = masonry;
                } else if (deselected.indexOf('EX-MAS') === -1) {
                    deselected.push('EX-MAS');
                }
            } else if (deselected.indexOf('EX-MAS') === -1) {
                deselected.push('EX-MAS');
            }
        } else if (PallasartUtils.objectPropertyExists(PallasartParadigm.cache.answered, 'EX-MAS') && (PallasartParadigm.cache.answered['EX-MAS']['ID'] === 'rr000||') && (deselected.indexOf('EX-MAS') === -1)) {
            deselected.push('EX-MAS');
        }

        if (PallasartUtils.objectPropertyExists(PallasartParadigm.cache.answered, 'FL-FORMAL') && (PallasartParadigm.cache.answered['FL-FORMAL']['ID'] === 'hd000||') && (deselected.indexOf('FL-FORMAL') === -1)) {
            deselected.push('FL-FORMAL');
        }

        if (PallasartUtils.objectPropertyExists(selected, 'luxury2') && (deselected.indexOf('sdsign') === -1)) {
            deselected.push('sdsign');
        }

        if (PallasartUtils.objectPropertyExists(selected, 'sdsign') && (deselected.indexOf('luxury2') === -1)) {
            deselected.push('luxury2');
        }

        if (kitchenColor.length) {
            for (const key of Object.keys(selected)) {
                if ((key !== 'FL-KITDIN') && (key.substring(0, 3) === 'FL-')) {
                    if (selected[key].indexOf('Matches Kitchen') !== -1) {
                        selected[key] = selected[key].replace('Matches Kitchen', kitchenColor);
                    }
                }
            }
        }

        if (blackMatte === true) {
            selected['PB-BTHFC'] = 'plbthgibbm||Black Matte';
        } else if ((resetBlackMatte === true) && (deselected.indexOf('PB-BTHFC') === -1)) {
            deselected.push('PB-BTHFC');
        }

        for (const extra of deselected) {
            if (extra in selected) {
                delete selected[extra];
            }
        }

        let selectedCopy = {};
        let deselectedCopy = [];

        for (const optionId of Object.keys(selected)) {
            let option = PallasartOptions.getAssembledOption(optionId);

            if (option && option.Override) {
                selectedCopy[option.Override] = selected[optionId];
            } else {
                selectedCopy[optionId] = selected[optionId];
            }
        }

        for (const optionId of deselected) {
            let option = PallasartOptions.getAssembledOption(optionId);

            if (option && option.Override) {
                deselectedCopy.push(option.Override);
            } else {
                deselectedCopy.push(optionId);
            }
        }

        return {
            'AnsweredQuestions': selectedCopy,
            'UnansweredQuestions': deselectedCopy.join(',')
        };
    },

    loading: function() {
        let overlay = PallasartParadigm.wrapper.querySelector('.bs-loading-overlay');
        if (!overlay) {
            let loading = document.createElement('div');
            loading.classList.add('bs-loading-overlay');
            loading.innerHTML = PallasartUtils.loading;

            PallasartParadigm.wrapper.append(loading);

            setTimeout(function () {
                loading.style.opacity = '1';
            }, 250);
        }
    },

    unloading: function() {
        let overlay = PallasartParadigm.wrapper.querySelector('.bs-loading-overlay');
        if (overlay) {
            overlay.style.opacity = '0';
            setTimeout(function() {
                overlay.remove();
            }, 500);
        }

        PallasartUtils.toggleLoading(false);
    },

    disable: function() {
        PallasartParadigm.unloading();
        PallasartV2.placeholderImage();

        let stagehomes = PallasartV2.wrapper.querySelectorAll('.stage_home');
        for (const stagehome of stagehomes) {
            stagehome.classList.add('bs-d-none');
        }
    },

    alternatives: async function(options) {
        const url = new URL(PallasartParadigm.endpoint + 'alternatives/list/builder/' + PallasartParadigm.builderId),
            query = {
                clientId: PallasartParadigm.clientId
            };

        Object.keys(query).forEach(key => url.searchParams.append(key, query[key]));

        await fetch(
            url,
            {
                method: 'get',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }
        ).then((response) => {
            if (response.ok) {
                return response.json();
            }

            return Promise.reject(response);
        }).then((response) => {
            let found = false;

            if (Array.isArray(response)) {
                for (const elevation of response) {
                    if ((elevation.template.name === PallasartV2.kova.Plan.Name) && (elevation.template.internalName === PallasartV2.kova.Plan.Name)) {
                        found = true;
                        PallasartParadigm.setup(elevation.id, options);

                        let stagehomes = PallasartV2.wrapper.querySelectorAll('.stage_home');
                        for (const stagehome of stagehomes) {
                            stagehome.classList.remove('bs-d-none');
                        }
                        break;
                    }
                }
            }

            if (!found) {
                // return Promise.reject(response);
                PallasartParadigm.disable();
                PallasartV2.renderingMissing();
            }
        }).catch((reason) => {
            // console.log(reason);
            PallasartParadigm.disable();
            PallasartV2.renderingUnavailable();
        });
    },

    setup: async function(id, options) {
        await fetch(
            PallasartParadigm.endpoint + 'configurator',
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify({
                    builderId: PallasartParadigm.builderId,
                    clientId: PallasartParadigm.clientId,
                    alternativeId: id,
                    savedDesignInput: null,
                    communityId: null,
                    lotNumber: null
                })
            }
        ).then((response) => {
            if (response.ok) {
                return response.json();
            }

            return Promise.reject(response);
        }).then((response) => {
            PallasartParadigm.key = response.configuratorKey;
            PallasartParadigm.config = response.panellumConfiguration;
            PallasartParadigm.state = response.configuratorState;
            PallasartParadigm.select(options);
        }).catch((reason) => {
            // console.log(reason);
            PallasartParadigm.disable();
            PallasartV2.renderingUnavailable();
        });
    },

    select: async function(options, camera) {
        let step = PallasartParadigm.getStep();
        if (step === false) {
            PallasartParadigm.response(camera);
            return false;
        }

        await fetch(
            PallasartParadigm.endpoint + 'configuration/' + PallasartParadigm.key  + '/steps/' + step + '/select',
            {
                method: 'put',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json; charset=utf-8'
                }
            }
        ).then((response) => {
            if (response.ok) {
                return response.json();
            }

            return Promise.reject(response);
        }).then((response) => {
            PallasartParadigm.state = response;

            if (options) {
                PallasartParadigm.question(options, camera);
            } else {
                PallasartParadigm.response(camera);
            }
        }).catch((reason) => {
            // console.log(reason);
            PallasartParadigm.disable();
            PallasartV2.renderingUnavailable();
        });
    },

    question: async function(options, camera) {
        let question = PallasartParadigm.getQuestion();

        if (!question) {
            return false;
        }

        let answer = PallasartParadigm.answer(options);
        question.selectedAnswerId = window.btoa(unescape(encodeURIComponent(JSON.stringify(answer))));

        await fetch(
            PallasartParadigm.endpoint + 'configuration/' + PallasartParadigm.key  + '/questions',
            {
                method: 'put',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify(question)
            }
        ).then((response) => {
            if (response.ok) {
                return response.json();
            }

            return Promise.reject(response);
        }).then((response) => {
            PallasartParadigm.state = response;
            PallasartParadigm.response(camera);
        }).catch((reason) => {
            // console.log(reason);
            PallasartParadigm.disable();
            PallasartV2.renderingUnavailable();
        });
    },

    settings: async function(settings) {
        await fetch(
            PallasartParadigm.endpoint + 'configuration/' + PallasartParadigm.key  + '/scenesettings',
            {
                method: 'put',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/json; charset=utf-8'
                },
                body: JSON.stringify(settings)
            }
        ).then((response) => {
            if (response.ok) {
                return response.json();
            }

            return Promise.reject(response);
        }).then((response) => {
            PallasartParadigm.state = response;
            PallasartParadigm.response();
        }).catch((reason) => {
            // console.log(reason);
            PallasartParadigm.disable();
            PallasartV2.renderingUnavailable();
        });
    },

    scene: async function(label, camera) {
        if (label === 'Garage') {
            label = 'Exterior';
        } else if (label === 'Great Room and Entry') {
            label = 'Entryway';
        } else if (label === 'Kitchen and Dining') {
            label = 'Kitchen';
        } else if (label === 'Interior') {
            label = 'Dining Room';
        } else if (label === 'Bathroom and Laundry') {
            label = 'Primary Bathroom';
        } else if (label === 'Bedrooms') {
            label = 'Primary Bedroom';
        }

        if (!PallasartParadigm.state) {
            PallasartParadigm.autoload = label;
            return false;
        }

        for (const scene of PallasartParadigm.state.scenes) {
            if (scene.displayName === label) {
                PallasartParadigm.loading();

                await fetch(
                    PallasartParadigm.endpoint + 'configuration/' + PallasartParadigm.key  + '/scenes/' + scene.id + '/select',
                    {
                        method: 'put',
                        headers: {
                            'Accept': 'application/json, text/plain, */*',
                            'Content-Type': 'application/json; charset=utf-8'
                        }
                    }
                ).then((response) => {
                    if (response.ok) {
                        return response.json();
                    }

                    return Promise.reject(response);
                }).then((response) => {
                    PallasartParadigm.config = response.panellumConfiguration;
                    PallasartParadigm.state = response.configuratorState;
                    PallasartParadigm.select(false, camera);
                }).catch((reason) => {
                    // console.log(reason);
                    PallasartParadigm.disable();
                    PallasartV2.renderingUnavailable();
                });
            }
        }

        return false;
    },

    response: function(camera) {
        let root = PallasartUtils.getRoot();

        let config = PallasartParadigm.config.config,
            state = PallasartParadigm.state;

        config.type = 'cubemap';
        config.keyboardZoom = false;
        config.mouseZoom = false;
        config.draggable = true;
        config.showZoomCtrl = false;
        config.showFullscreenCtrl = false;
        config.showControls = true;
        config.autoLoad = true;
        config.backgroundColor = [208, 211, 212];

        for (const scene in config.scenes) {
            if (PallasartUtils.objectPropertyExists(config.scenes, scene)) {
                for (const hotSpot in config.scenes[scene].hotSpots) {
                    if (PallasartUtils.objectPropertyExists(config.scenes[scene].hotSpots, hotSpot)) {
                        config.scenes[scene].hotSpots[hotSpot].cssClass = 'bs-custom-scene-hotspot bs-custom-scene-hotspot-int';
                        // config.scenes[scene].hotSpots[hotSpot].text = scene;
                        // config.scenes[scene].hotSpots[hotSpot].createTooltipArgs = scene;
                        // config.scenes[scene].hotSpots[hotSpot].createTooltipFunc = function(element, args) {
                        //     element.setAttribute('data-bs-toggle', 'bs-tooltip');
                        //     element.setAttribute('data-bs-title', args);
                        //
                        //     new bootstrap.Tooltip(element, {
                        //         container: root
                        //     });
                        // };

                        if ((scene.toLowerCase().indexOf('exterior') >= 0) || (scene.toLowerCase().indexOf('front') >= 0) || (scene.toLowerCase().indexOf('back') >= 0) || (scene.toLowerCase().indexOf('garage') >= 0)) {
                            config.scenes[scene].hotSpots[hotSpot].cssClass = 'bs-custom-scene-hotspot bs-custom-scene-hotspot-ext';
                        }

                        if (config.scenes[scene].hotSpots[hotSpot].sceneLinkId && (config.scenes[scene].hotSpots[hotSpot].sceneLinkId != PallasartParadigm.state.currentScene.displayName)) {
                            config.scenes[scene].hotSpots[hotSpot].cssClass += ' bs-custom-scene-has-link';
                            // config.scenes[scene].hotSpots[hotSpot].createTooltipArgs = config.scenes[scene].hotSpots[hotSpot].sceneLinkId;
                            config.scenes[scene].hotSpots[hotSpot].clickHandlerArgs = {
                                sectionId: config.scenes[scene].hotSpots[hotSpot].sectionId,
                                sceneLinkId: config.scenes[scene].hotSpots[hotSpot].sceneLinkId,
                                sceneId: config.scenes[scene].hotSpots[hotSpot].sceneId,
                            };
                            config.scenes[scene].hotSpots[hotSpot].clickHandlerFunc = function(e, args) {
                                let daynight = root.querySelector('.bs-day-night');

                                if (daynight) {
                                    daynight.classList.add('bs-d-none');
                                }

                                PallasartParadigm.scene(args.sceneLinkId, args.sceneId);
                            }
                        } /*else {
                            config.scenes[scene].hotSpots[hotSpot].clickHandlerFunc = function(e, args) {
                                let tooltips = PallasartParadigm.wrapper.querySelectorAll('[data-bs-toggle]');
                                for (const tooltip of tooltips) {
                                    const instance = Tooltip.getInstance(tooltip);
                                    if (instance) {
                                        instance.hide();
                                    }
                                }
                            }
                        }*/
                    }
                }

                config.scenes[scene].type = 'cubemap';
                config.scenes[scene].cubeMap = [];

                if (state.disabledCameraList.includes(scene)) {
                    delete config.scenes[scene];
                }
            }
        }

        for (const image in state.renderedImages) {
            if (PallasartUtils.objectPropertyExists(config.scenes, state.renderedImages[image].cameraName)) {
                config.scenes[state.renderedImages[image].cameraName].cubeMap.push(
                    state.renderedImages[image].frontUrl ? state.renderedImages[image].frontUrl : 'null'
                );
                config.scenes[state.renderedImages[image].cameraName].cubeMap.push(
                    state.renderedImages[image].rightUrl ? state.renderedImages[image].rightUrl : 'null'
                );
                config.scenes[state.renderedImages[image].cameraName].cubeMap.push(
                    state.renderedImages[image].backUrl ? state.renderedImages[image].backUrl : 'null'
                );
                config.scenes[state.renderedImages[image].cameraName].cubeMap.push(
                    state.renderedImages[image].leftUrl ? state.renderedImages[image].leftUrl : 'null'
                );
                config.scenes[state.renderedImages[image].cameraName].cubeMap.push(
                    state.renderedImages[image].upUrl ? state.renderedImages[image].upUrl : 'null'
                );
                config.scenes[state.renderedImages[image].cameraName].cubeMap.push(
                    state.renderedImages[image].downUrl ? state.renderedImages[image].downUrl : 'null'
                );

                if ((state.renderedImages[image].cameraName.toLowerCase() === 'front') && PallasartV2.cache.plan) {
                    PallasartV2.cache.plan.picture = state.renderedImages[image].frontUrl;
                }
            }
        }

        PallasartParadigm.unloading();

        // let tooltips = PallasartParadigm.wrapper.querySelectorAll('[data-bs-toggle]');
        // for (const tooltip of tooltips) {
        //     const instance = Tooltip.getInstance(tooltip);
        //     if (instance) {
        //         instance.dispose();
        //     }
        // }

        if (!PallasartParadigm.wrapper.classList.contains('pnlm-container')) {
            PallasartParadigm.instance = pannellum.viewer('kova-panellum', config);
            PallasartParadigm.instance.on('load', function() {
                setTimeout(function() {
                    PallasartParadigm.resizeViewer();
                }, 1000);

                let hotspots = PallasartParadigm.wrapper.querySelectorAll('.bs-custom-scene-hotspot');

                for (const hotspot of hotspots) {
                    hotspot.innerHTML = '<div class="bs-custom-scene-hotspot-icon"></div>';

                    if (hotspot.classList.contains('bs-custom-scene-has-link') && hotspot.onclick) {
                        hotspot.onclick = null;
                        hotspot.ontouchend = null;
                    }
                }

                let daynight = PallasartParadigm.wrapper.querySelector('.bs-day-night');
                if (!daynight) {
                    daynight = document.createElement('div');
                    daynight.classList.add('bs-day-night');

                    let day = document.createElement('a');
                    day.classList.add('bs-day');
                    day.addEventListener('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();

                        PallasartParadigm.settings({
                            sceneSettings: 'Day'
                        });

                        PallasartParadigm.loading();
                    });

                    let night = document.createElement('a');
                    night.classList.add('bs-night');
                    night.addEventListener('click', function(e) {
                        e.preventDefault();
                        e.stopPropagation();

                        PallasartParadigm.settings({
                            sceneSettings: 'Evening'
                        });

                        PallasartParadigm.loading();
                    });

                    daynight.append(day);
                    daynight.append(night);

                    PallasartParadigm.wrapper.append(daynight);
                    PallasartParadigm.toggleDayNight(state, daynight);
                }
            });

            window.addEventListener('resize', function() {
                PallasartParadigm.resizeViewer();
            });

            screen.orientation.addEventListener('change', function() {
                PallasartParadigm.resizeViewer();
            });
        } else {
            let defaultScene = false;
            for (const scene of Object.keys(config.scenes)) {
                if (((typeof camera === 'undefined') && ((config.default.firstScene === scene) || (!config.default.firstScene && (defaultScene === false)))) || ((typeof camera !== 'undefined') && (camera === scene))) {
                    defaultScene = scene;
                }

                PallasartParadigm.instance.addScene(scene, config.scenes[scene]);
            }

            if (defaultScene) {
                if (PallasartParadigm.cache.scene && (PallasartParadigm.cache.scene === PallasartParadigm.state.currentScene.displayName)) {
                    PallasartParadigm.instance.loadScene(
                        defaultScene,
                        PallasartParadigm.cache.pitch,
                        PallasartParadigm.cache.yaw,
                        PallasartParadigm.cache.hfov
                    );
                } else {
                    PallasartParadigm.instance.loadScene(defaultScene);
                }
            }

            let hotspots = PallasartParadigm.wrapper.querySelectorAll('.bs-custom-scene-hotspot');

            for (const hotspot of hotspots) {
                hotspot.innerHTML = '<div class="bs-custom-scene-hotspot-icon"></div>';

                if (hotspot.classList.contains('bs-custom-scene-has-link') && hotspot.onclick) {
                    hotspot.onclick = null;
                    hotspot.ontouchend = null;
                }
            }

            let daynight = root.querySelector('.bs-day-night');

            if (daynight) {
                PallasartParadigm.toggleDayNight(state, daynight);
            }
        }

        if ((PallasartParadigm.autoload !== false) && (PallasartParadigm.autoload !== null)) {
            PallasartParadigm.scene(PallasartParadigm.autoload);
            PallasartParadigm.autoload = false;
        }
    },

    toggleDayNight: function(state, daynight) {
        if (state.availableSceneSettings.length > 1) {
            daynight.classList.remove('bs-d-none');

            if (state.currentSceneSettings === 'Evening') {
                daynight.querySelector('.bs-day').classList.remove('bs-active');
                daynight.querySelector('.bs-night').classList.add('bs-active');
            } else {
                daynight.querySelector('.bs-night').classList.remove('bs-active');
                daynight.querySelector('.bs-day').classList.add('bs-active');
            }
        } else {
            daynight.classList.add('bs-d-none');
        }
    },

    resizeViewer: function() {
        if (PallasartParadigm.instance) {
            PallasartParadigm.instance.setUpdate(true);
        }
    },

    scenes: function() {
        let scenes = [];

        if (PallasartParadigm.state !== null) {
            for (const scene of PallasartParadigm.state.scenes) {
                if (scene.displayName === 'Primary Bathroom') {
                    scenes.push('Bathroom 1');
                } else if (scene.displayName === 'Primary Bedroom') {
                    scenes.push('Bedroom 1');
                } else {
                    scenes.push(scene.displayName);
                }
            }
        }

        return scenes;
    },

    cachePosition: function() {
        if (PallasartParadigm.instance) {
            PallasartParadigm.cache.yaw = PallasartParadigm.instance.getYaw();
            PallasartParadigm.cache.pitch = PallasartParadigm.instance.getPitch();
            PallasartParadigm.cache.hfov = PallasartParadigm.instance.getHfov();
            PallasartParadigm.cache.scene = PallasartParadigm.state.currentScene.displayName;
        }
    }
};

global.PallasartOptions = {
    options: false,

    cache: {
        assembled: false,
        quantities: {},
        quantitiesCopy: {},
    },

    isVisible: function(option) {
        if (!PallasartUtils.objectPropertyExists(option, 'ID')) {
            return false;
        }

        if (option['ID'] === 'defcolors') {
            return false;
        }

        if ((option['Type'] === 'SingleChoice') || (option['Type'] === 'QuantityChoice')) {
            if ((!PallasartV2.kova.slsordrid && option['Enabled']) || option['Selected']) {
                return true;
            }
        } else if (option['Type'] === 'MultiChoice') {
            if (!PallasartV2.kova.slsordrid && option['Enabled']) {
                return true;
            }

            for (let choice of Object.keys(option['Choices'])) {
                if (option['Choices'][choice]['Selected']) {
                    return true;
                }
            }
        }

        return false;
    },

    assemble: function(data, skipCache) {
        let map = {};

        for (let optionId of Object.keys(data.Options)) {
            let option = data.Options[optionId];

            if (PallasartOptions.isVisible(option)) {
                if (!PallasartUtils.objectPropertyExists(PallasartOptions.options['ids'], optionId)) {
                    let categoryId = option['CategoryID'];

                    if (PallasartUtils.objectPropertyExists(data.Categories, categoryId)) {
                        let sectionName = 'Other';
                        let locationName = option['LocationID'] ? data.Locations[option['LocationID']]['Text'] : '';
                        let categoryName = data.Categories[categoryId]['WebGroupName'];

                        if (!PallasartUtils.objectPropertyExists(map, sectionName)) {
                            map[sectionName] = {};
                        }

                        if (!PallasartUtils.objectPropertyExists(map[sectionName], locationName)) {
                            map[sectionName][locationName] = {};
                        }

                        if (!PallasartUtils.objectPropertyExists(map[sectionName][locationName], categoryName)) {
                            map[sectionName][locationName][categoryName] = {};
                        }

                        map[sectionName][locationName][categoryName][optionId] = {
                            Text: option['Text'],
                            Type: option['Type'],
                            Enabled: option['Enabled'],
                            Override: '',
                            Choices: {}
                        };

                        if (option['Type'] === 'MultiChoice') {
                            for (const choice of option['Choices']) {
                                let candidate = choice;
                                candidate['Tooltip'] = '';
                                candidate['Qty'] = 0;
                                candidate['Thumbnail'] = '';
                                candidate['InfoHeadline'] = '';
                                candidate['InfoImage'] = '';
                                candidate['InfoText'] = '';
                                candidate['InfoMore'] = '';
                                candidate['AllRooms'] = '';
                                candidate['Vizualize'] = 1;
                                candidate['Paradigm'] = 0;
                                candidate['LotHighlight'] = 0;
                                candidate['PopupText'] = '';
                                candidate['SubstitutionText'] = '';
                                candidate['SubstitutionImage'] = '';
                                candidate['Unit'] = '';
                                candidate['Hide'] = 0;

                                if (!PallasartUtils.objectPropertyExists(candidate, 'Style')) {
                                    candidate['Style'] = '';
                                }

                                if (!PallasartUtils.objectPropertyExists(candidate, 'Color')) {
                                    candidate['Color'] = '';
                                }

                                map[sectionName][locationName][categoryName][optionId]['Choices'][choice['ID']] = candidate;
                            }
                        } else {
                            let candidate = option;
                            candidate['Tooltip'] = '';
                            candidate['Qty'] = 0;
                            candidate['Thumbnail'] = '';
                            candidate['InfoHeadline'] = '';
                            candidate['InfoImage'] = '';
                            candidate['InfoText'] = '';
                            candidate['InfoMore'] = '';
                            candidate['AllRooms'] = '';
                            candidate['Vizualize'] = 1;
                            candidate['Paradigm'] = 0;
                            candidate['LotHighlight'] = 0;
                            candidate['PopupText'] = '';
                            candidate['SubstitutionText'] = '';
                            candidate['SubstitutionImage'] = '';
                            candidate['Unit'] = '';
                            candidate['Hide'] = 0;

                            if (!PallasartUtils.objectPropertyExists(candidate, 'Style')) {
                                candidate['Style'] = '';
                            }

                            if (!PallasartUtils.objectPropertyExists(candidate, 'Color')) {
                                candidate['Color'] = '';
                            }

                            map[sectionName][locationName][categoryName][optionId]['Choices'][option['ID']] = candidate;
                        }

                        if (Object.keys(map[sectionName][locationName][categoryName][optionId]['Choices']).length === 0) {
                            delete map[sectionName][locationName][categoryName][optionId];

                            if (Object.keys(map[sectionName][locationName][categoryName]).length === 0) {
                                delete map[sectionName][locationName][categoryName];
                            }

                            if (Object.keys(map[sectionName][locationName]).length === 0) {
                                delete map[sectionName][locationName];
                            }

                            if (Object.keys(map[sectionName]).length === 0) {
                                delete map[sectionName];
                            }
                        }
                    }
                } else {
                    for (let section of Object.keys(PallasartOptions.options['map'])) {
                        for (let location of Object.keys(PallasartOptions.options['map'][section])) {
                            for (let category of Object.keys(PallasartOptions.options['map'][section][location])) {
                                for (let opt_sel_id of Object.keys(PallasartOptions.options['map'][section][location][category])) {
                                    if (opt_sel_id === optionId) {
                                        if (!PallasartUtils.objectPropertyExists(map, section)) {
                                            map[section] = {};
                                        }

                                        if (!PallasartUtils.objectPropertyExists(map[section], location)) {
                                            map[section][location] = {};
                                        }

                                        if (!PallasartUtils.objectPropertyExists(map[section][location], category)) {
                                            map[section][location][category] = {};
                                        }

                                        if (!PallasartUtils.objectPropertyExists(map[section][location][category], opt_sel_id)) {
                                            map[section][location][category][opt_sel_id] = {
                                                Text: PallasartOptions.options['map'][section][location][category][opt_sel_id]['text'],
                                                Type: PallasartOptions.options['map'][section][location][category][opt_sel_id]['type'],
                                                Enabled: option['Enabled'],
                                                Override: PallasartOptions.options['map'][section][location][category][opt_sel_id]['override'],
                                                Choices: {}
                                            };
                                        }

                                        if (option['Type'] === 'MultiChoice') {
                                            for (const choice of option['Choices']) {
                                                if (PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'], choice['ID'])) {
                                                    let candidate = choice;
                                                    candidate['Style'] = '';
                                                    candidate['Color'] = '';

                                                    if (PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['choice']) {
                                                        candidate['Text'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['choice'];
                                                        candidate['Title'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['choice'];
                                                    }

                                                    if (PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['style']) {
                                                        candidate['Style'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['style'];
                                                    }

                                                    if (PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['color']) {
                                                        candidate['Color'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['color'];
                                                    }

                                                    candidate['Tooltip'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['tooltip'];
                                                    candidate['Qty'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['qty'];
                                                    candidate['Thumbnail'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['thumbnail'];
                                                    candidate['InfoHeadline'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['info_headline'];
                                                    candidate['InfoImage'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['info_image'];
                                                    candidate['InfoText'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['info_text'];
                                                    candidate['InfoMore'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['info_more'];
                                                    candidate['AllRooms'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['all_rooms'];
                                                    candidate['Vizualize'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['vizualize'];
                                                    candidate['LotHighlight'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['lot_highlight'];
                                                    candidate['PopupText'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['popup_text'];
                                                    candidate['SubstitutionImage'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['substitution_image'];
                                                    candidate['SubstitutionText'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['substitution_text'];
                                                    candidate['Unit'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['unit'];
                                                    candidate['Hide'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['hide'];

                                                    if (PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']], 'paradigm')) {
                                                        candidate['Paradigm'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['paradigm'];
                                                    }

                                                    if (candidate['Text'] && ((candidate['Text'].toLowerCase() === 'not selected') || (candidate['Text'].toLowerCase() === '"not selected"') || (candidate['Text'].toLowerCase() === 'please select') || (candidate['Text'].toLowerCase() === '"please select"'))) {
                                                        candidate['Text'] = 'Not Selected';
                                                    }

                                                    if (candidate['Style'] && ((candidate['Style'].toLowerCase() === 'not selected') || (candidate['Style'].toLowerCase() === '"not selected"') || (candidate['Style'].toLowerCase() === 'please select') || (candidate['Style'].toLowerCase() === '"please select"'))) {
                                                        candidate['Style'] = 'Not Selected';
                                                    }

                                                    if (candidate['Color'] && ((candidate['Color'].toLowerCase() === 'not selected') || (candidate['Color'].toLowerCase() === '"not selected"') || (candidate['Color'].toLowerCase() === 'please select') || (candidate['Color'].toLowerCase() === '"please select"'))) {
                                                        candidate['Color'] = 'Not Selected';
                                                    }

                                                    if (PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['use_kova']) {
                                                        candidate['Text'] = choice['Text'];
                                                        candidate['Title'] = choice['Title'];
                                                        map[section][category][opt_sel_id]['Text'] = option['Text'];
                                                    }

                                                    if (!PallasartUtils.objectPropertyExists(candidate, 'Style')) {
                                                        candidate['Style'] = '';
                                                    }

                                                    if (!PallasartUtils.objectPropertyExists(candidate, 'Color')) {
                                                        candidate['Color'] = '';
                                                    }

                                                    if (PallasartV2.kova.Plan['ID'] && PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['customizations']) {
                                                        if (PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['customizations'], 'info_headline') && PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['customizations']['info_headline'], PallasartV2.kova.Plan['ID'])) {
                                                            candidate['InfoHeadline'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['customizations']['info_headline'][PallasartV2.kova.Plan['ID']];
                                                        }

                                                        if (PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['customizations'], 'info_text') && PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['customizations']['info_text'], PallasartV2.kova.Plan['ID'])) {
                                                            candidate['InfoText'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['customizations']['info_text'][PallasartV2.kova.Plan['ID']];
                                                        }

                                                        if (PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['customizations'], 'info_image') && PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['customizations']['info_image'], PallasartV2.kova.Plan['ID'])) {
                                                            candidate['InfoImage'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][choice['ID']]['customizations']['info_image'][PallasartV2.kova.Plan['ID']];
                                                        }
                                                    }

                                                    map[section][location][category][opt_sel_id]['Choices'][choice['ID']] = candidate;
                                                } else {
                                                    let candidate = choice;
                                                    candidate['Tooltip'] = '';
                                                    candidate['Qty'] = 0;
                                                    candidate['Thumbnail'] = '';
                                                    candidate['InfoHeadline'] = '';
                                                    candidate['InfoImage'] = '';
                                                    candidate['InfoText'] = '';
                                                    candidate['InfoMore'] = '';
                                                    candidate['AllRooms'] = '';
                                                    candidate['Vizualize'] = 1;
                                                    candidate['Paradigm'] = 0;
                                                    candidate['LotHighlight'] = 0;
                                                    candidate['PopupText'] = '';
                                                    candidate['SubstitutionText'] = '';
                                                    candidate['SubstitutionImage'] = '';
                                                    candidate['Unit'] = '';
                                                    candidate['Hide'] = 0;

                                                    if (!PallasartUtils.objectPropertyExists(candidate, 'Style')) {
                                                        candidate['Style'] = '';
                                                    }

                                                    if (!PallasartUtils.objectPropertyExists(candidate, 'Color')) {
                                                        candidate['Color'] = '';
                                                    }

                                                    map[section][location][category][opt_sel_id]['Choices'][choice['ID']] = candidate;
                                                }
                                            }
                                        } else {
                                            let candidate = option;

                                            if (PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['choice']) {
                                                candidate['Text'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['choice'];
                                                candidate['Title'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['choice'];
                                            } else if (PallasartOptions.options['map'][section][location][category][opt_sel_id]['text']) {
                                                candidate['Text'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['text'];
                                                candidate['Title'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['text'];
                                            }

                                            if (PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['style']) {
                                                candidate['Style'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['style'];
                                            }

                                            if (PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['color']) {
                                                candidate['Color'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['color'];
                                            }

                                            candidate['Tooltip'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['tooltip'];
                                            candidate['Qty'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['qty'];
                                            candidate['Thumbnail'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['thumbnail'];
                                            candidate['InfoHeadline'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['info_headline'];
                                            candidate['InfoImage'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['info_image'];
                                            candidate['InfoText'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['info_text'];
                                            candidate['InfoMore'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['info_more'];
                                            candidate['AllRooms'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['all_rooms'];
                                            candidate['Vizualize'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['vizualize'];
                                            candidate['LotHighlight'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['lot_highlight'];
                                            candidate['PopupText'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['popup_text'];
                                            candidate['SubstitutionImage'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['substitution_image'];
                                            candidate['SubstitutionText'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['substitution_text'];
                                            candidate['Unit'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['unit'];
                                            candidate['Hide'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['hide'];

                                            if (PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']], 'paradigm')) {
                                                candidate['Paradigm'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['paradigm'];
                                            }

                                            if (candidate['Text'] && ((candidate['Text'].toLowerCase() === 'not selected') || (candidate['Text'].toLowerCase() === '"not selected"') || (candidate['Text'].toLowerCase() === 'please select') || (candidate['Text'].toLowerCase() === '"please select"'))) {
                                                candidate['Text'] = 'Not Selected';
                                            }

                                            if (candidate['Style'] && ((candidate['Style'].toLowerCase() === 'not selected') || (candidate['Style'].toLowerCase() === '"not selected"') || (candidate['Style'].toLowerCase() === 'please select') || (candidate['Style'].toLowerCase() === '"please select"'))) {
                                                candidate['Style'] = 'Not Selected';
                                            }

                                            if (candidate['Color'] && ((candidate['Color'].toLowerCase() === 'not selected') || (candidate['Color'].toLowerCase() === '"not selected"') || (candidate['Color'].toLowerCase() === 'please select') || (candidate['Color'].toLowerCase() === '"please select"'))) {
                                                candidate['Color'] = 'Not Selected';
                                            }

                                            if (PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['use_kova']) {
                                                candidate['Text'] = option['Text'];
                                                candidate['Title'] = option['Title'];
                                                map[section][location][category][opt_sel_id]['Text'] = option['Text'];
                                            }

                                            if (!PallasartUtils.objectPropertyExists(candidate, 'Style')) {
                                                candidate['Style'] = '';
                                            }

                                            if (!PallasartUtils.objectPropertyExists(candidate, 'Color')) {
                                                candidate['Color'] = '';
                                            }

                                            if (PallasartV2.kova.Plan['ID'] && PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['customizations']) {
                                                if (PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['customizations'], 'info_headline') && PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['customizations']['info_headline'], PallasartV2.kova.Plan['ID'])) {
                                                    candidate['InfoHeadline'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['customizations']['info_headline'][PallasartV2.kova.Plan['ID']];
                                                }

                                                if (PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['customizations'], 'info_text') && PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['customizations']['info_text'], PallasartV2.kova.Plan['ID'])) {
                                                    candidate['InfoText'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['customizations']['info_text'][PallasartV2.kova.Plan['ID']];
                                                }

                                                if (PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['customizations'], 'info_image') && PallasartUtils.objectPropertyExists(PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['customizations']['info_image'], PallasartV2.kova.Plan['ID'])) {
                                                    candidate['InfoImage'] = PallasartOptions.options['map'][section][location][category][opt_sel_id]['choices'][option['ID']]['customizations']['info_image'][PallasartV2.kova.Plan['ID']];
                                                }
                                            }

                                            map[section][location][category][opt_sel_id]['Choices'][option['ID']] = candidate;
                                        }

                                        if (Object.keys(map[section][location][category][opt_sel_id]['Choices']).length === 0) {
                                            delete map[section][location][category][opt_sel_id];

                                            if (Object.keys(map[section][location][category]).length === 0) {
                                                delete map[section][location][category];
                                            }

                                            if (Object.keys(map[section][location]).length === 0) {
                                                delete map[section][location];
                                            }

                                            if (Object.keys(map[section]).length === 0) {
                                                delete map[section];
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        for (const section in map) {
            for (const location in map[section]) {
                for (const category in map[section][location]) {
                    for (const opt_sel_id in map[section][location][category]) {
                        if ((map[section][location][category][opt_sel_id]['Type'] === 'MultiChoice') && (opt_sel_id !== 'EX-MAS')) {
                            let enabled = 0;
                            let has_included = false;
                            let price_selected = false;

                            for (const choice_id in map[section][location][category][opt_sel_id]['Choices']) {
                                if (map[section][location][category][opt_sel_id]['Choices'][choice_id]['Enabled'] && !map[section][location][category][opt_sel_id]['Choices'][choice_id]['Hide']) {
                                    enabled++;

                                    if ((map[section][location][category][opt_sel_id]['Choices'][choice_id]['Text'] !== 'Not Selected') && (map[section][location][category][opt_sel_id]['Choices'][choice_id]['Color'] !== 'Not Selected')) {
                                        let price = PallasartUtils.parseNumeric(map[section][location][category][opt_sel_id]['Choices'][choice_id]['Price']);

                                        if (!price) {
                                            has_included = true;
                                        } else if (map[section][location][category][opt_sel_id]['Choices'][choice_id]['Selected']) {
                                            price_selected = true;
                                        }
                                    }
                                }
                            }

                            for (const choice_id in map[section][location][category][opt_sel_id]['Choices']) {
                                if (((enabled <= 1) || !price_selected || (price_selected && has_included)) &&
                                    ((map[section][location][category][opt_sel_id]['Choices'][choice_id]['Text'] === 'Not Selected') || (map[section][location][category][opt_sel_id]['Choices'][choice_id]['Color'] === 'Not Selected'))
                                ) {
                                    delete map[section][location][category][opt_sel_id]['Choices'][choice_id];

                                    if (Object.keys(map[section][location][category][opt_sel_id]['Choices']).length === 0) {
                                        delete map[section][location][category][opt_sel_id];
                                    }

                                    if (Object.keys(map[section][location][category]).length === 0) {
                                        delete map[section][location][category];
                                    }

                                    if (Object.keys(map[section][location]).length === 0) {
                                        delete map[section][location];
                                    }

                                    if (Object.keys(map[section]).length === 0) {
                                        delete map[section];
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        for (const section in map) {
            for (const location in map[section]) {
                for (const category in map[section][location]) {
                    for (const opt_sel_id in map[section][location][category]) {
                        map[section][location][category][opt_sel_id]['Mode'] = PallasartOptions.detectMode(opt_sel_id, map[section][location][category][opt_sel_id]);
                    }
                }
            }
        }

        if (skipCache !== true) {
            PallasartOptions.cache.assembled = map;
            PallasartOptions.preloadQuantities();
        }

        return map;
    },

    selected: function(data) {
        let options = [];

        if (data) {
            for (const section in data) {
                for (const location in data[section]) {
                    for (const category in data[section][location]) {
                        for (const optionId in data[section][location][category]) {
                            if (data[section][location][category][optionId].Type === 'SingleChoice') {
                                for (const choice_id in data[section][location][category][optionId]['Choices']) {
                                    if (data[section][location][category][optionId]['Choices'][choice_id].Selected) {
                                        options[optionId] = data[section][location][category][optionId]['Choices'][choice_id];
                                    }
                                }
                            } else if (data[section][location][category][optionId].Type === 'MultiChoice') {
                                for (const choice_id in data[section][location][category][optionId]['Choices']) {
                                    if (data[section][location][category][optionId]['Choices'][choice_id].Selected) {
                                        options[optionId] = data[section][location][category][optionId]['Choices'][choice_id];
                                    }
                                }
                            } else if (data[section][location][category][optionId].Type === 'QuantityChoice') {
                                for (const choice_id in data[section][location][category][optionId]['Choices']) {
                                    if (data[section][location][category][optionId]['Choices'][choice_id].Selected || parseInt(data[section][location][category][optionId]['Choices'][choice_id].Value)) {
                                        options[optionId] = data[section][location][category][optionId]['Choices'][choice_id];
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return options;
    },

    detectMode: function(id, option) {
        if (option['Type'] === 'SingleChoice') {
            return 'SINGLE';
        } else if (option['Type'] === 'QuantityChoice') {
            return 'QUANTITY';
        } else if (id === 'EX-MAS') {
            return 'MULTI_EX_MAS';
        } else {
            let buffer = {};

            let num_groups = 0;
            let num_colors = 0;
            let one_color = true;

            for (const choice_id in option['Choices']) {
                let choice = option['Choices'][choice_id];

                if (!(choice['Text'] in buffer)) {
                    buffer[choice['Text']] = {};

                    if (choice['Text']) {
                        num_groups++;
                    }
                }

                if (!(choice['Style'] in buffer[choice['Text']])) {
                    buffer[choice['Text']][choice['Style']] = [];
                }

                if (!(choice['Color'] in buffer[choice['Text']][choice['Style']])) {
                    buffer[choice['Text']][choice['Style']].push(choice['Color']);

                    if (one_color && (buffer[choice['Text']][choice['Style']].length > 1)) {
                        one_color = false;
                    }

                    if (choice['Color']) {
                        num_colors++;
                    }
                }
            }

            if (num_colors === 0) {
                return 'MULTI_NO_COLORS';
            } else if (num_groups === 1) {
                return 'MULTI_ONE_TEXT';
            } else if (one_color) {
                return 'MULTI_ONE_COLOR';
            } else {
                return 'MULTI';
            }
        }
    },

    locationSort: function(arr) {
        arr.sort(function(a, b) {
            if (!(a in PallasartOptions.options['locations']) || !(b in PallasartOptions.options['locations'])) {
                return -1;
            }

            if (PallasartOptions.options['locations'][a]['weight'] < PallasartOptions.options['locations'][b]['weight']) {
                return -1;
            }

            if (PallasartOptions.options['locations'][a]['weight'] > PallasartOptions.options['locations'][b]['weight']) {
                return 1;
            }

            return 0;
        });

        return arr;
    },

    locationScenes: function(location) {
        if (location in PallasartOptions.options['locations']) {
            return PallasartOptions.options['locations'][location]['scenes'];
        }

        return false;
    },

    categorySort: function(arr) {
        arr.sort(function(a, b) {
            if (!(a in PallasartOptions.options['categories']) || !(b in PallasartOptions.options['categories'])) {
                return -1;
            }

            if (PallasartOptions.options['categories'][a]['weight'] < PallasartOptions.options['categories'][b]['weight']) {
                return -1;
            }

            if (PallasartOptions.options['categories'][a]['weight'] > PallasartOptions.options['categories'][b]['weight']) {
                return 1;
            }

            return 0;
        });

        return arr;
    },

    categoryScene: function(category) {
        if (category in PallasartOptions.options['categories']) {
            return PallasartOptions.options['categories'][category]['scene'];
        }

        return false;
    },

    extra: function(includeDefault) {
        let found = {};

        if (PallasartOptions.cache.assembled) {
            for (const section of Object.keys(PallasartOptions.cache.assembled)) {
                for (const location of Object.keys(PallasartOptions.cache.assembled[section])) {
                    for (const category of Object.keys(PallasartOptions.cache.assembled[section][location])) {
                        for (const optionId of Object.keys(PallasartOptions.cache.assembled[section][location][category])) {
                            if ((optionId.toLowerCase() !== 'cs-colors') && PallasartOptions.cache.assembled[section][location][category][optionId]['Enabled']) {
                                if ((PallasartOptions.cache.assembled[section][location][category][optionId]['Type'] === 'QuantityChoice') && !PallasartOptions.isQuantityChosen(section, location, category, optionId)) {
                                    continue;
                                }

                                for (const choiceId of Object.keys(PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'])) {
                                    if ((optionId.toLowerCase() === 'ex-mas') && ((PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['Text'].toLowerCase() === 'not selected') || (PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['Text'].toLowerCase() === '"not selected"'))) {
                                        continue;
                                    }

                                    let isQty = (PallasartOptions.cache.assembled[section][location][category][optionId]['Type'] === 'QuantityChoice') && parseInt(PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['Value']);

                                    if (PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['Enabled'] && (PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['Selected'] || isQty)) {
                                        let price = PallasartUtils.parseNumeric(PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['Price']);

                                        if (isQty) {
                                            let quantity = PallasartOptions.getQuantity(section, location, category, optionId);
                                            let min = PallasartOptions.getQuantityMin(section, location, category, optionId);
                                            price = (quantity - min) * PallasartUtils.parseNumeric(PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['UnitPrice']);
                                        }

                                        if (price || (includeDefault === true)) {
                                            if (!PallasartUtils.objectPropertyExists(found, section)) {
                                                found[section] = {};
                                            }

                                            if (!PallasartUtils.objectPropertyExists(found[section], location)) {
                                                found[section][location] = {};
                                            }

                                            if (!PallasartUtils.objectPropertyExists(found[section][location], category)) {
                                                found[section][location][category] = [];
                                            }

                                            found[section][location][category].push({
                                                option_id: optionId,
                                                choice_id: choiceId,
                                                type: PallasartOptions.cache.assembled[section][location][category][optionId]['Type'],
                                                text: PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['Text'],
                                                style: PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['Style'],
                                                InfoHeadline: PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['InfoHeadline'],
                                                InfoText: PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['InfoText'],
                                                InfoImage: PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['InfoImage'],
                                                Thumbnail: PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['Thumbnail'],
                                                SubstitutionText: PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['SubstitutionText'],
                                                SubstitutionImage: PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['SubstitutionImage'],
                                                Unit: PallasartOptions.cache.assembled[section][location][category][optionId]['Choices'][choiceId]['Unit'],
                                                price: price,
                                            })
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return Object.keys(found).length ? found : false;
    },

    extraTotal: function() {
        let extrasTotal = 0;
        let extras = PallasartOptions.extra();

        if (extras) {
            for (const section in extras) {
                for (const location in extras[section]) {
                    for (const category in extras[section][location]) {
                        for (const choice of extras[section][location][category]) {
                            extrasTotal += choice['price'];
                        }
                    }
                }
            }
        }

        return extrasTotal;
    },

    styles: function() {
        let styles = false,
            found = {};

        if (PallasartOptions.cache.assembled) {
            for (const section in PallasartOptions.cache.assembled) {
                for (const location in PallasartOptions.cache.assembled[section]) {
                    for (const category in PallasartOptions.cache.assembled[section][location]) {
                        for (const optionId in PallasartOptions.cache.assembled[section][location][category]) {
                            if (optionId.toLowerCase() === 'cs-colors') {
                                styles = PallasartOptions.cache.assembled[section][location][category][optionId];
                                break;
                            }
                        }
                    }
                }
            }
        }

        if (styles && styles['Enabled']) {
            let buffer = [];

            for (const choice_id in styles['Choices']) {
                let style = styles['Choices'][choice_id];

                if (styles['Choices'][choice_id]['ID'] in PallasartOptions.options['styles']) {
                    style['custom'] = PallasartOptions.options['styles'][choice_id];
                    buffer.push(style);
                } /*else {
                    style['custom'] = {
                        name: style.Text,
                        summary: '',
                        description: '',
                        images: [],
                        weight: 0
                    };
                }*/
            }

            buffer.sort(function(a, b) {
                if (a['custom']['weight'] < b['custom']['weight']) {
                    return -1;
                }

                if (a['custom']['weight'] > b['custom']['weight']) {
                    return 1;
                }

                return 0;
            });

            for (const style of buffer) {
                found[style['ID']] = style;
            }

            return found;
        }

        return false;
    },

    getSelectedStyle: function() {
        let styles = PallasartOptions.styles();

        if (styles) {
            for (const choice_id in styles) {
                if (styles[choice_id]['Selected']) {
                    return styles[choice_id];
                }
            }
        }

        return false;
    },

    getStyle: function(id) {
        let styles = PallasartOptions.styles();

        if (styles && (id in styles)) {
            return styles[id];
        }

        return false;
    },

    locations: function() {
        let buffer = {};

        if (PallasartOptions.cache.assembled && PallasartOptions.options) {
            let found = {};

            for (const section of Object.keys(PallasartOptions.cache.assembled)) {
                for (const location of Object.keys(PallasartOptions.cache.assembled[section])) {
                    for (const category of Object.keys(PallasartOptions.cache.assembled[section][location])) {
                        for (const optionId of Object.keys(PallasartOptions.cache.assembled[section][location][category])) {
                            if ((optionId.toLowerCase() !== 'cs-colors') && PallasartOptions.cache.assembled[section][location][category][optionId]['Enabled']) {
                                if (!PallasartUtils.objectPropertyExists(found, section)) {
                                    found[section] = [];
                                }

                                if (found[section].indexOf(location) === -1) {
                                    found[section].push(location);
                                }
                            }
                        }
                    }
                }
            }

            for (const section of Object.keys(found)) {
                let locations = PallasartOptions.locationSort(found[section]);

                for (const location of locations) {
                    if (PallasartUtils.objectPropertyExists(PallasartOptions.options['locations'], location) && PallasartOptions.options['locations'][location]['scenes'].length) {
                        if (!PallasartUtils.objectPropertyExists(buffer, section)) {
                            buffer[section] = {};
                        }

                        buffer[section][location] = PallasartOptions.options['locations'][location]['scenes'];
                    }
                }
            }
        }

        return buffer;
    },

    preloadQuantities: function() {
        if (Object.keys(PallasartOptions.cache.quantities).length || (PallasartOptions.cache.assembled === false)) {
            return false;
        }

        for (const section in PallasartOptions.cache.assembled) {
            for (const location in PallasartOptions.cache.assembled[section]) {
                for (const category in PallasartOptions.cache.assembled[section][location]) {
                    for (const option in PallasartOptions.cache.assembled[section][location][category]) {
                        if (PallasartOptions.cache.assembled[section][location][category][option].Type === 'QuantityChoice') {
                            for (const choice_id in PallasartOptions.cache.assembled[section][location][category][option]['Choices']) {
                                if (!PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities, section)) {
                                    PallasartOptions.cache.quantities[section] = {};
                                }

                                if (!PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section], location)) {
                                    PallasartOptions.cache.quantities[section][location] = {};
                                }

                                if (!PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section][location], category)) {
                                    PallasartOptions.cache.quantities[section][location][category] = {};
                                }

                                PallasartOptions.cache.quantities[section][location][category][option] = {
                                    min: PallasartOptions.cache.assembled[section][location][category][option]['Choices'][choice_id].Value,
                                    value: PallasartOptions.cache.assembled[section][location][category][option]['Choices'][choice_id].Value
                                };

                                if (PallasartOptions.cache.quantitiesCopy &&
                                    PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantitiesCopy, section) &&
                                    PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantitiesCopy[section], location) &&
                                    PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantitiesCopy[section][location], category) &&
                                    PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantitiesCopy[section][location][category], option) &&
                                    PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantitiesCopy[section][location][category][option], 'value')
                                ) {
                                    PallasartOptions.cache.quantities[section][location][category][option].value = PallasartOptions.cache.quantitiesCopy[section][location][category][option].value;
                                }
                            }
                        }
                    }
                }
            }
        }

        PallasartOptions.cache.quantitiesCopy = {};
    },

    setQuantity: function(section, location, category, option, value) {
        if (!PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities, section)) {
            PallasartOptions.cache.quantities[section] = {};
        }

        if (!PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section], location)) {
            PallasartOptions.cache.quantities[section][location] = {};
        }

        if (!PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section][location], category)) {
            PallasartOptions.cache.quantities[section][location][category] = {};
        }

        if (!PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section][location][category], option)) {
            PallasartOptions.cache.quantities[section][location][category][option] = {
                min: 0,
                value: value
            };
        }

        if (parseInt(value) >= parseInt(PallasartOptions.cache.quantities[section][location][category][option].min)) {
            PallasartOptions.cache.quantities[section][location][category][option].value = value;
        } else {
            PallasartOptions.cache.quantities[section][location][category][option].value = PallasartOptions.cache.quantities[section][location][category][option].min;
        }
    },

    getQuantity: function(section, location, category, option) {
        if (PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities, section) &&
            PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section], location) &&
            PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section][location], category) &&
            PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section][location][category], option)) {
            return parseInt(PallasartOptions.cache.quantities[section][location][category][option].value);
        }

        return 0;
    },

    resetQuantity: function(section, location, category, option) {
        if (PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities, section) &&
            PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section], location) &&
            PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section][location], category) &&
            PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section][location][category], option)) {
            PallasartOptions.cache.quantities[section][location][category][option].value = PallasartOptions.cache.quantities[section][location][category][option].min;
        }
    },

    getQuantityMin: function(section, location, category, option) {
        if (PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities, section) &&
            PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section], location) &&
            PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section][location], category) &&
            PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section][location][category], option)) {
            return parseInt(PallasartOptions.cache.quantities[section][location][category][option].min);
        }

        return 0;
    },

    isQuantityChosen(section, location, category, option) {
        if (PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities, section) &&
            PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section], location) &&
            PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section][location], category) &&
            PallasartUtils.objectPropertyExists(PallasartOptions.cache.quantities[section][location][category], option)) {
            return (PallasartOptions.cache.quantities[section][location][category][option].value > PallasartOptions.cache.quantities[section][location][category][option].min);
        }

        return false;
    },

    sumQuantity: function(option) {
        let qty = 0;

        if (Object.keys(PallasartOptions.cache.quantities)) {
            for (const section in PallasartOptions.cache.quantities) {
                for (const location in PallasartOptions.cache.quantities[section]) {
                    for (const category in PallasartOptions.cache.quantities[section][location]) {
                        for (const optionId in PallasartOptions.cache.quantities[section][location][category]) {
                            if (optionId === option) {
                                qty += parseInt(PallasartOptions.cache.quantities[section][location][category][optionId].value);
                            }
                        }
                    }
                }
            }
        }

        return qty;
    },

    getAssembledOption: function(id) {
        if (PallasartOptions.cache.assembled) {
            for (const section in PallasartOptions.cache.assembled) {
                for (const location in PallasartOptions.cache.assembled[section]) {
                    for (const category in PallasartOptions.cache.assembled[section][location]) {
                        for (const optionId in PallasartOptions.cache.assembled[section][location][category]) {
                            if (optionId.toLowerCase() === id.toLowerCase()) {
                                return PallasartOptions.cache.assembled[section][location][category][optionId];
                            }
                        }
                    }
                }
            }
        }

        return false;
    },

    colors: function() {
        let colors = PallasartOptions.getAssembledOption('pt-ext'),
            found = [];

        if (colors && colors['Enabled']) {
            let choices = Object.keys(colors['Choices']);

            for (let group of PallasartOptions.options['colors']) {
                if (Object.keys(group['choices']).length) {
                    let selected = {};

                    for (let choice_index in group['choices']) {
                        if (choices.indexOf(group['choices'][choice_index]) !== -1) {
                            selected[group['choices'][choice_index]] = colors['Choices'][group['choices'][choice_index]];
                        }
                    }

                    let cloned = structuredClone(group);
                    // let cloned = JSON.parse(JSON.stringify(group));
                    cloned['choices'] = selected;
                    found.push(cloned);
                }
            }

            found = found.sort(function(a, b) {
                if (a['weight'] < b['weight']) {
                    return -1;
                }

                if (a['weight'] > b['weight']) {
                    return 1;
                }

                return 0;
            });
        }

        return found;
    },

    selectedMasonry: function() {
        let masonry = PallasartOptions.getAssembledOption('ex-mas');

        if (masonry) {
            for (let choice_id in masonry['Choices']) {
                if (masonry['Choices'][choice_id]['Selected'] && !((masonry['Choices'][choice_id]['Text'] === 'Not Selected') || (masonry['Choices'][choice_id]['Color'] === 'Not Selected'))) {
                    return choice_id;
                }
            }
        }

        return false;
    },

    isOptionVisible: function(option, optionId) {
        let visible = false;

        if ((option['Type'] === 'SingleChoice') || (option['Type'] === 'MultiChoice')) {
            if (!PallasartV2.kova.slsordrid && option['Enabled']) {
                visible = true;
            }

            for (let choice of Object.keys(option['Choices'])) {
                if (option['Choices'][choice]['Selected'] && !option['Choices'][choice]['Hide']) {
                    visible = true;
                }
            }
        }  else if (option['Type'] === 'QuantityChoice') {
            if (!PallasartV2.kova.slsordrid && option['Enabled']) {
                visible = true;
            }

            for (let choice of Object.keys(option['Choices'])) {
                if ((option['Choices'][choice]['Selected'] || (PallasartUtils.parseNumeric(option['Choices'][choice]['UnitPrice']) > 0) && (option['Choices'][choice]['Qty'] > 0)) && !option['Choices'][choice]['Hide']) {
                    visible = true;
                }
            }
        }

        return visible;
    },

    isLocationVisible: function(options) {
        let visible = false;

        for (const category of Object.keys(options)) {
            for (const optionId of Object.keys(options[category])) {
                if (PallasartOptions.isOptionVisible(options[category][optionId], optionId)) {
                    visible = true;
                }
            }
        }

        return visible;
    },

    isCategoryVisible: function(options) {
        let visible = false;

        for (const optionId of Object.keys(options)) {
            if (PallasartOptions.isOptionVisible(options[optionId], optionId)) {
                visible = true;
            }
        }

        return visible;
    },

    isGroupVisible: function(styles) {
        let visible = false;

        for (const style of Object.keys(styles)) {
            for (const color of Object.keys(styles[style])) {
                for (const choice of styles[style][color]) {
                    if (!choice['Hide']) {
                        if (!PallasartV2.kova.slsordrid) {
                            visible = true;
                            break;
                        } else if (choice['Selected']) {
                            visible = true;
                            break;
                        }
                    }
                }
            }
        }

        return visible;
    },

    hasGroupImages: function(groups) {
        let images = false;

        for (const group of Object.keys(groups)) {
            for (const style of Object.keys(groups[group])) {
                for (const color of Object.keys(groups[group][style])) {
                    for (const choice of groups[group][style][color]) {
                        if (choice['Thumbnail']) {
                            images = true;
                            break;
                        }
                    }
                }
            }
        }

        return images;
    },

    getLocationCity: function() {
        let option = PallasartOptions.getAssembledOption('LOCATION');

        if (option) {
            for (let choice_id in option['Choices']) {
                if (option['Choices'][choice_id]['Selected'] && !((option['Choices'][choice_id]['Text'] === 'Not Selected') || (option['Choices'][choice_id]['Color'] === 'Not Selected'))) {
                    return option['Choices'][choice_id]['Text'].replaceAll('City of ', '');
                }
            }
        }

        return false;
    }
};

global.Pallasart = {
    loaded: false,

    endpoint: function(url, username, password) {
        PallasartV1.endpoint(url, username, password);
        PallasartV2.endpoint(url, username, password);
    },

    configurator: function(config, skip, oncomplete, preventAutoload) {
        if (Pallasart.loaded) {
            return true;
        }

        config = PallasartV2.prepareConfigObject(config);

        if (config) {
            PallasartUtils.toggleLoading();

            fetch(
                PallasartUrl.templates + '?community=' + config.communityRID,
                {
                    method: 'get',
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/x-www-form-urlencoded'
                    }
                }
            ).then((response) => {
                if (response.ok) {
                    return response.json();
                }

                return Promise.reject(response);
            }).then((response) => {
                PallasartUtils.toggleLoading(false);

                if ((preventAutoload === true) && (response.version === 2)) {
                    return true;
                } else {
                    Pallasart.loaded = true;
                }

                if (response.content) {
                    document.querySelector('head').insertAdjacentHTML('beforeend', response.content);
                }

                if (response.version === 1) {
                    PallasartV1.configurator(config, skip);
                } else if (response.version === 2) {
                    window.location.hash = '#visualizer';

                    if ((typeof oncomplete != 'undefined') && (oncomplete != null) && (oncomplete !== false)) {
                        PallasartV2.prepareStage();

                        oncomplete();
                    } else {
                        PallasartV2.configurator(config, skip);
                    }
                }
            }).catch((e) => {
                PallasartUtils.toggleLoading(false);
            });
        }
    },

    pseudoConfirmation: function(action) {
        const pseudoIframe = document.createElement('iframe');
        let pseudoIframeSrc = '/forms/pseudo-confirmation/' + action;
        pseudoIframe.referrerPolicy = 'same-origin';
        Object.assign(pseudoIframe.style, {
            pointerEvents: 'none',
            position: 'fixed',
            top: '0',
            left: '0',
            width: '1px',
            height: '1px',
            margin: '-1px',
            padding: '0',
            border: '0',
            overflow: 'hidden',
            clip: 'rect(0 0 0 0)',
            zIndex: '-1',
            tabIndex: '-1',
        });

        pseudoIframe.src = pseudoIframeSrc;
        document.body.appendChild(pseudoIframe);
    }
};

global.PallasartV1 = {
    endpointUrl: null,
    endpointUsername: null,
    endpointPassword: null,

    community: 0,
    model: 0,
    lot: 0,
    slsord: 0,
    city: false,
    kova: false,

    wrapper: null,

    cache: {
        webgroup: '',
        option: '',
        images: [],
        floorplans: ''
    },

    endpoint: function(url, username, password) {
        PallasartV1.endpointUrl = url;
        PallasartV1.endpointUsername = username;
        PallasartV1.endpointPassword = password;
    },

    configurator: function(config, skip, oncomplete, preventAutoload) {
        config = PallasartV2.prepareConfigObject(config);

        if (config) {
            if (preventAutoload === true) {
                return true;
            }

            if ((typeof oncomplete !== 'undefined') && (oncomplete !== null) && (oncomplete !== false)) {
                oncomplete();
            } else {
                PallasartV1.init(config);
            }
        }
    },

    prepareStage: function() {
        let stage = document.querySelector('#pallasart-configurator');
        if (!stage) {
            stage = document.createElement('div');
            stage.setAttribute('id', 'pallasart-configurator');
            document.querySelector('body').append(stage);
        } else {
            stage.innerText = '';
        }

        stage.classList.add('bs-root');

        let configurator = stage.querySelector('#kova-configurator');
        if (!configurator) {
            configurator = document.createElement('div');
            configurator.setAttribute('id', 'kova-configurator');
            stage.append(configurator);
        } else {
            configurator.innerText = '';
        }

        PallasartV1.wrapper = configurator;
    },

    init: function(config, options) {
        config = PallasartV2.prepareConfigObject(config);

        if (config) {
            PallasartV1.community = config.communityRID;
            PallasartV1.model = config.modelRID;

            if (PallasartUtils.objectPropertyExists(config, 'lotRID') && (config.lotRID !== false) && (config.lotRID !== null) && (config.lotRID !== 0) && (config.lotRID !== '0')) {
                PallasartV1.lot = config.lotRID;
            }

            if (PallasartUtils.objectPropertyExists(config, 'salesOrderRID') && (config.salesOrderRID !== false) && (config.salesOrderRID !== null) && (config.salesOrderRID !== 0) && (config.salesOrderRID !== '0')) {
                PallasartV1.slsord = config.salesOrderRID;
            }

            if (PallasartUtils.objectPropertyExists(config, 'cityID') && (config.cityID !== false) && (config.cityID !== null) && (config.cityID !== 0) && (config.cityID !== '0')) {
                PallasartV1.city = config.cityID;
            }

            PallasartV1.prepareStage();

            PallasartV1.kovaInit(
                PallasartV1.community,
                PallasartV1.model,
                PallasartV1.lot,
                PallasartV1.slsord,
                PallasartV1.city,
                ((typeof options !== undefined) ? options : false)
            );

            if (PallasartUtils.objectPropertyExists(config, 'communityID')) {
                PallasartV1.community = config.communityID;
                PallasartV1.lot = 0;
                PallasartV1.slsord = 0;
            }

            if (PallasartUtils.objectPropertyExists(config, 'modelID')) {
                PallasartV1.model = config.modelID;
                PallasartV1.lot = 0;
                PallasartV1.slsord = 0;
            }

            if (PallasartUtils.objectPropertyExists(config, 'lotID')) {
                PallasartV1.lot = config.lotID;
            }

            if (PallasartUtils.objectPropertyExists(config, 'salesOrderID')) {
                PallasartV1.slsord = config.salesOrderID;
            }

            PallasartV1.triggerKova();
        }
    },

    kovaInit: function(community, model, lot, slsord, city, options) {
        PallasartV1.kova = new Kova.WC.OptionConfigurator(-1);
        PallasartV1.kova.setApiUrl(PallasartV1.endpointUrl);
        PallasartV1.kova.setApiUsername(PallasartV1.endpointUsername);
        PallasartV1.kova.setApiKey(PallasartV1.endpointPassword);

        PallasartV1.kova.communityrid = community;
        PallasartV1.kova.modelrid = model;
        PallasartV1.kova.lotrid = (lot ? lot : 0);
        PallasartV1.kova.slsordrid = (slsord ? slsord : 0);

        if (city) {
            PallasartV1.kova.SelectedOptions = {
                'LOCATION': city
            };
        } else {
            PallasartV1.kova.SelectedOptions = {};
        }

        if (options) {
            PallasartV1.kova.setDefaultRequestParams(JSON.parse(options));
        }
    },

    triggerKova: function() {
        PallasartUtils.toggleLoading();
        PallasartV1.kova.getInitialSelections();
        PallasartV1.kova.addOptionListFeature(
            'kova-configurator',
            'kova-template',
            {},
            function(data) {
                PallasartUtils.toggleLoading(false);
                PallasartV1.handleOptions();
                PallasartV1.wrapper.querySelector('.bs-v1-widget-floorplans').innerHTML = PallasartV1.cache.floorplans;

                let floorplans = [];
                let totalFloorplans = 0;

                for (const floorId of Object.keys(data.Plan.Floors)) {
                    if (data.Plan.Floors[floorId].Description.toLowerCase().indexOf('exterior') === -1) {
                        totalFloorplans++;
                    }
                }

                for (const floorId of Object.keys(data.Plan.Floors)) {
                    if (data.Plan.Floors[floorId].Description.toLowerCase().indexOf('exterior') === -1) {
                        PallasartV1.kova.postGenerateFloorPlan(data.Plan.Floors[floorId].Index, 800, 800, function(floorindex, response) {
                            if (PallasartUtils.objectPropertyExists(response, 'Url')) {
                                floorplans.push({
                                    index: data.Plan.Floors[floorId].Index,
                                    caption: data.Plan.Floors[floorId].Description,
                                    url: response.Url
                                });
                            } else if (PallasartUtils.objectPropertyExists(response, 'FloorPlan')) {
                                floorplans.push({
                                    index: data.Plan.Floors[floorId].Index,
                                    caption: data.Plan.Floors[floorId].Description,
                                    url: response.FloorPlan.Url
                                });
                            }

                            if (floorplans.length === totalFloorplans) {
                                floorplans = floorplans.sort(function(a, b) {
                                    if (parseInt(a.index) === parseInt(b.index)) {
                                        return 0;
                                    }

                                    return parseInt(a.index) > parseInt(b.index) ? 1 : -1;
                                });

                                let existing = PallasartV1.wrapper.querySelectorAll('.bs-v1-widget-floorplans img'),
                                    existingTotal = existing ? existing.length : 0;

                                for (let i = 0; i < floorplans.length; i++) {
                                    if (i < existingTotal) {
                                        existing[i].setAttribute('src', floorplans[i].url);
                                        existing[i].setAttribute('alt', floorplans[i].caption);
                                    } else {
                                        let image = document.createElement('img');
                                        image.setAttribute('src', floorplans[i].url);
                                        image.setAttribute('alt', floorplans[i].caption);

                                        let parent = PallasartV1.wrapper.querySelector('.bs-v1-widget-floorplans');
                                        parent.append(image);
                                    }
                                }
                            }
                        });
                    }
                }
            }
        );
    },

    handleOptions: function() {
        let singles = PallasartV1.wrapper.querySelectorAll('.single_choice input');
        for (const single of singles) {
            single.addEventListener('click', function(e) {
                e.stopPropagation();

                if (single.hasAttribute('data-optionid')) {
                    PallasartUtils.toggleLoading();
                    PallasartV1.cache.webgroup = single.getAttribute('data-webgroup');
                    PallasartV1.cache.option = single.getAttribute('data-optionid');
                    PallasartV1.cache.floorplans = PallasartV1.wrapper.querySelector('.bs-v1-widget-floorplans').innerHTML;

                    PallasartV1.kova.optionOnChange(single, function () {
                        PallasartUtils.toggleLoading(false);
                        PallasartV1.showPane(PallasartV1.cache.webgroup);
                    }, function() {
                        PallasartUtils.toggleLoading(false);
                        PallasartV1.showPane(PallasartV1.cache.webgroup);
                    });
                }
            });
        }

        let multis = PallasartV1.wrapper.querySelectorAll('.multi_choice input');
        for (const multi of multis) {
            multi.addEventListener('click', function(e) {
                e.stopPropagation();

                if (multi.hasAttribute('data-optionid')) {
                    PallasartUtils.toggleLoading();
                    PallasartV1.cache.webgroup = multi.getAttribute('data-webgroup');
                    PallasartV1.cache.option = multi.getAttribute('data-optionid');
                    PallasartV1.cache.floorplans = PallasartV1.wrapper.querySelector('.bs-v1-widget-floorplans').innerHTML;

                    PallasartV1.kova.choiceOnChange(multi, multi, function () {
                        PallasartUtils.toggleLoading(false);
                        PallasartV1.showPane(PallasartV1.cache.webgroup);
                    }, function() {
                        PallasartUtils.toggleLoading(false);
                        PallasartV1.showPane(PallasartV1.cache.webgroup);
                    });
                }
            });
        }

        let quantities = PallasartV1.wrapper.querySelectorAll('.quantity_choice input');
        for (const quantity of quantities) {
            quantity.addEventListener('change', function(e) {
                e.stopPropagation();

                if (e.target.getAttribute('max') && (e.target.value > e.target.getAttribute('max'))) {
                    e.target.value = e.target.getAttribute('max');
                    PallasartUtils.createModal('The maximum allowed is ' + e.target.getAttribute('max'), false);
                } else if (quantity.hasAttribute('data-optionid')) {
                    PallasartUtils.toggleLoading();
                    PallasartV1.cache.webgroup = quantity.getAttribute('data-webgroup');
                    PallasartV1.cache.option = quantity.getAttribute('data-optionid');
                    PallasartV1.cache.floorplans = PallasartV1.wrapper.querySelector('.bs-v1-widget-floorplans').innerHTML;

                    PallasartV1.kova.qtyOnChange(quantity, quantity.value, function () {
                        PallasartUtils.toggleLoading(false);
                        PallasartV1.showPane(PallasartV1.cache.webgroup);
                    });
                }
            });
        }

        let singleimages = PallasartV1.wrapper.querySelectorAll('.single_image');
        for (const image of singleimages) {
            image.addEventListener('click', function(e) {
                e.stopPropagation();
                e.preventDefault();

                const option = image.getAttribute('data-optionid');
                if (option) {
                    const url = new URL(PallasartV1.endpointUrl + 'api/v4/optmenus/getimage/options/' + option + '?customerid=1.1.0000&auth=' + PallasartV1.endpointPassword);
                    PallasartV1.fetchOptionImage(e, option, url);
                }
            });

            image.addEventListener('mouseover', function(e) {
                const option = image.getAttribute('data-optionid');
                if (option) {
                    const url = new URL(PallasartV1.endpointUrl + 'api/v4/optmenus/getimage/options/' + option + '?customerid=1.1.0000&auth=' + PallasartV1.endpointPassword);
                    PallasartV1.fetchOptionImage(e, option, url);
                }
            });

            image.addEventListener('mouseout', function() {
                PallasartV1.hideOptionImage();
            });
        }

        let multiimages = PallasartV1.wrapper.querySelectorAll('.multi_image');
        for (const image of multiimages) {
            image.addEventListener('click', function(e) {
                e.stopPropagation();
                e.preventDefault();

                const option = image.getAttribute('data-optionid');
                if (option) {
                    const choice = image.getAttribute('data-choiceid');

                    if (choice) {
                        const style = image.getAttribute('data-style');
                        const color = image.getAttribute('data-color');
                        let choiceId = choice.substring(0, choice.indexOf('|'));

                        if (option !== 'PT-EXT') {
                            if (style !== "") {
                                choiceId += "~" + style;
                            }
                            if (color !== "") {
                                choiceId += "~" + color;
                            }
                        }

                        const url = new URL(PallasartV1.endpointUrl + 'api/v4/optmenus/getimage/values/' + choiceId + '?customerid=1.1.0000&auth=' + PallasartV1.endpointPassword);
                        PallasartV1.fetchOptionImage(e, choiceId, url);
                    } else {
                        const url = new URL(PallasartV1.endpointUrl + 'api/v4/optmenus/getimage/options/' + option + '?customerid=1.1.0000&auth=' + PallasartV1.endpointPassword);
                        PallasartV1.fetchOptionImage(e, option, url);
                    }
                }
            });

            image.addEventListener('mouseover', function(e) {
                const option = image.getAttribute('data-optionid');
                if (option) {
                    const choice = image.getAttribute('data-choiceid');

                    if (choice) {
                        const style = image.getAttribute('data-style');
                        const color = image.getAttribute('data-color');
                        let choiceId = choice.substring(0, choice.indexOf('|'));

                        if (option !== 'PT-EXT') {
                            if (style !== "") {
                                choiceId += "~" + style;
                            }
                            if (color !== "") {
                                choiceId += "~" + color;
                            }
                        }

                        const url = new URL(PallasartV1.endpointUrl + 'api/v4/optmenus/getimage/values/' + choiceId + '?customerid=1.1.0000&auth=' + PallasartV1.endpointPassword);
                        PallasartV1.fetchOptionImage(e, choiceId, url);
                    } else {
                        const url = new URL(PallasartV1.endpointUrl + 'api/v4/optmenus/getimage/options/' + option + '?customerid=1.1.0000&auth=' + PallasartV1.endpointPassword);
                        PallasartV1.fetchOptionImage(e, option, url);
                    }
                }
            });

            image.addEventListener('mouseout', function() {
                PallasartV1.hideOptionImage();
            });
        }
    },

    showPane: function(id) {
        if (id) {
            const trigger = PallasartV1.wrapper.querySelector('.bs-nav button[data-bs-target="#pane-' + id + '"]');
            if (trigger) {
                Tab.getOrCreateInstance(trigger).show();
            }
        }
    },

    fetchOptionImage: async function(event, option, url) {
        if (option in PallasartV1.cache.images) {
            PallasartV1.showOptionImage(event, PallasartV1.cache.images[option]);
        } else {
            await fetch(
                url,
                {
                    method: 'get',
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json; charset=utf-8'
                    }
                }
            ).then((response) => {
                if (response.ok) {
                    return response.blob();
                }

                return Promise.reject(response);
            }).then((response) => {
                let url = URL.createObjectURL(response);
                PallasartV1.cache.images[option] = url;
                PallasartV1.showOptionImage(event, url);
            }).catch((reason) => {
                // console.log(reason);
            });
        }
    },

    showOptionImage: function(event, url) {
        let wrapper = PallasartV1.wrapper.querySelector('.bs-v1-widget-option-image');
        if (!wrapper) {
            return false;
        }

        PallasartV1.hideOptionImage();

        let image = document.createElement('img');
        image.setAttribute('src', url);

        wrapper.style.top = (event.pageY - PallasartV1.wrapper.offsetTop) + 'px';

        if (window.innerWidth >= 768) {
            wrapper.style.left = (event.target.closest('.bs-tab-content').offsetWidth + 30) + 'px';
            wrapper.style.right = 'auto';
        } else {
            wrapper.style.left = 'auto';
            wrapper.style.right = '45px';
        }

        wrapper.append(image);
    },

    hideOptionImage: function() {
        let image = PallasartV1.wrapper.querySelector('.bs-v1-widget-option-image img');
        if (!image) {
            return false;
        }

        image.remove();
    },

    quotePopup: function(url) {
        PallasartUtils.toggleLoading();

        fetch(
            url,
            {
                method: 'get',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        ).then((response) => {
            PallasartUtils.toggleLoading(false);
            window.scrollTo(0, 0);

            if (response.ok) {
                return response.json();
            }

            return Promise.reject(response);
        }).then((response) => {
            if (PallasartUtils.objectPropertyExists(response, 'error')) {
                PallasartUtils.createModal(
                    response.error,
                    'Error',
                    false,
                    false
                );
            }

            if (PallasartUtils.objectPropertyExists(response, 'html')) {
                PallasartUtils.createModal(
                    response.html,
                    (PallasartUtils.objectPropertyExists(response, 'headline') ? response.headline : false),
                    PallasartUtils.objectPropertyExists(response, 'reload'),
                    PallasartUtils.objectPropertyExists(response, 'cleanload'),
                    (PallasartUtils.objectPropertyExists(response, 'modalClass') ? response.modalClass : false),
                    (PallasartUtils.objectPropertyExists(response, 'dialogClass') ? response.dialogClass : false),
                );
            } else if (PallasartUtils.objectPropertyExists(response, 'reload')) {
                window.location.reload();
            } else if (PallasartUtils.objectPropertyExists(response, 'cleanload')) {
                window.location.href = PallasartUtils.currentUrl();
            }
        }).catch((reason) => {
            // console.log(reason);
        });
    },

    submitQuote: function(form) {
        if (form.classList.contains('submitting')) {
            return false;
        }

        PallasartUtils.clearChildren(form, '.bs-alert');
        PallasartUtils.clearChildren(form, '.bs-text-danger');

        form.classList.add('bs-was-validated');

        let validity = form.checkValidity();
        let elements = form.querySelectorAll('.needs-validation');
        for (const element of elements) {
            PallasartUtils.validateInput(element);
        }

        if (!validity) {
            let error = PallasartUtils.createErrorAlert(
                'There was an input error, please fill in all required fields and carefully review the values you entered.'
            );
            form.prepend(error);

            return false;
        }

        form.classList.add('submitting');
        let button = form.querySelector('button.submit');
        button.setAttribute('data-title', button.innerText);
        button.innerText = 'Submitting...';

        let data = new FormData(form);
        data.append('url', PallasartUtils.currentUrl());
        let params = new URLSearchParams(data);

        let lead = {},
            fields = [],
            interestedField = {},
            formField = {},
            communityField = {},
            extra = {
                comments: '',
                land: '',
            };

        lead['NameFirst'] = params.get('quote[fname]');
        lead['NameLast'] = params.get('quote[lname]');
        lead['EmailHome'] = params.get('quote[email]');
        lead['PhoneHome'] = params.get('quote[phone]');
        lead['PrefContactType'] = 'Email';
        lead['Notes'] = (params.get('quote[land]') ? "DO YOU CURRENTLY OWN LAND? \n" + params.get('quote[land]') + "\n\n" : '') + (params.get('quote[comments]') ? params.get('quote[comments]') : '');

        interestedField['ID'] = 'Text_LeadRating';
        interestedField['Value'] = params.get('quote[interested]');
        fields.push(interestedField);

        formField['ID'] = 'Text_WebForm';
        formField['Value'] = 'Form - Instant Quote';
        fields.push(formField);

        communityField['ID'] = 'Int_CommunityRID';
        communityField['Value'] = PallasartV1.kova.communityrid;
        fields.push(communityField);

        lead['CustomFields'] = fields;

        if (PallasartV1.kova.lotrid) {
            lead['LotRID'] = PallasartV1.kova.lotrid;
        }

        if (params.get('quote[land]')) {
            extra['land'] = params.get('quote[land]');
        }

        if (params.get('quote[comments]')) {
            extra['comments'] = params.get('quote[comments]');
        }

        PallasartV1.kova.saveLead(lead, async function (result) {
            if(result && result.Url && (result.Url !== null)) {
                let data = new FormData();
                data.append('quote[version]', '1');
                data.append('quote[fname]', lead['NameFirst']);
                data.append('quote[lname]', lead['NameLast']);
                data.append('quote[email]', lead['EmailHome']);
                data.append('quote[message]', extra['comments']);
                data.append('quote[land]', extra['land']);
                data.append('quote[phone]', lead['PhoneHome']);
                data.append('quote[interested]', interestedField['Value']);
                data.append('quote[communityrid]', PallasartV1.kova.communityrid);
                data.append('quote[modelrid]', PallasartV1.kova.modelrid);
                data.append('quote[lotrid]', PallasartV1.kova.lotrid);
                data.append('quote[slsordrid]', PallasartV1.kova.slsordrid);
                data.append('quote[url]', result.Url);
                data.append('quote[leadrid]', result.Lead.LeadRID);
                data.append('quote[options]', window.btoa(unescape(encodeURIComponent(JSON.stringify(PallasartV1.kova.getDefaultRequestParams(true))))));
                let params = new URLSearchParams(data);

                fetch(
                    PallasartUrl.flyer,
                    {
                        method: 'post',
                        headers: {
                            'Accept': 'application/json, text/plain, */*',
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                        },
                        body: params
                    }
                ).then((response) => {
                    PallasartUtils.clearChildren(form, '.bs-alert');
                    PallasartUtils.clearChildren(form, '.bs-text-danger');

                    form.classList.remove('submitting');
                    form.classList.remove('bs-was-validated');
                    button.innerText = button.getAttribute('data-title');

                    if (response.ok) {
                        return response.json();
                    }

                    return Promise.reject(response);
                }).then((response) => {
                    if (PallasartUtils.objectPropertyExists(response, 'errors')) {
                        for (const key of Object.keys(response.errors)) {
                            if (key === '#') {
                                let error = PallasartUtils.createErrorAlert(response.errors[key]);
                                form.prepend(error);
                            } else {
                                let error = PallasartUtils.createErrorNote(response.errors[key]);
                                let element = form.querySelector(key);
                                if (element) {
                                    element.classList.add('is-invalid');
                                    element.closest('.bs-form-group').append(error);
                                }
                            }
                        }
                    }

                    if (PallasartUtils.objectPropertyExists(response, 'error')) {
                        let error = PallasartUtils.createErrorAlert(response.error);
                        form.prepend(error);
                    }

                    if (PallasartUtils.objectPropertyExists(response, 'success')) {
                        Pallasart.pseudoConfirmation('instant-quote-thank-you');
                        form.reset();

                        if (('flyer' in PallasartV2.messages) && PallasartV2.messages.flyer) {
                            PallasartUtils.createModal(
                                PallasartV2.messages.flyer.content,
                                '',
                                false,
                                false,
                                'bs-popup-light bs-popup-header-margin',
                                'bs-modal-dialog'
                            );
                        }
                    }
                }).catch((reason) => {
                    // console.log(reason);
                });
            } else {
                PallasartUtils.createModal(
                    'Cannot generate flyer!',
                    '',
                    false,
                    false,
                    'bs-popup-light bs-popup-header-margin',
                    'bs-modal-dialog'
                );
            }
        });

        return false;
    }
};

global.PallasartV2 = {
    endpointUrl: null,
    endpointUsername: null,
    endpointPassword: null,

    community: 0,
    model: 0,
    lot: 0,
    slsord: 0,
    city: false,
    kova: false,

    wrapper: null,
    toolbar: null,
    disclaimer: null,
    styles: null,

    messages: {},

    cache: {
        counter: 0,
        customer: false,
        home: false,
        plan: false,
        lot: false,
        slsord: false,
        section: '',
        completed: {},
        popups: [],
        current: {
            section: 'exterior',
            location: 0,
            category: -1,
            option: ''
        },
        loan: 0,
        rate: 0,
        interest: 0,
        remember_save: false,
        save: '',
        style: false,
        get_started: false,
        highlight_option: false,
        lead: {
            rid: null,
            hist: null
        },
        vizualize: 1,
        impersonate: false,
        floorplans: []
    },

    working: false,
    skip_to_review: false,
    disable_back: false,
    latest_options: false,

    configurator: function(config, skip, oncomplete, preventAutoload) {
        PallasartV2.skip_to_review = (skip === true);

        config = PallasartV2.prepareConfigObject(config);

        if (config) {
            if (preventAutoload === true) {
                return true;
            }

            PallasartV2.prepareStage();

            if ((typeof oncomplete !== 'undefined') && (oncomplete !== null) && (oncomplete !== false)) {
                oncomplete();
            } else {
                PallasartV2.init(config);
            }
        }
    },

    endpoint: function(url, username, password) {
        PallasartV2.endpointUrl = url;
        PallasartV2.endpointUsername = username;
        PallasartV2.endpointPassword = password;
    },

    resetCache: function() {
        PallasartV2.cache.counter  = 0;
        PallasartV2.cache.plan  = false;
        PallasartV2.cache.lot  = false;
        PallasartV2.cache.completed  = {};
        PallasartV2.cache.popups  = [];
        PallasartV2.cache.current = {
            section: 'exterior',
            location: 0,
            category: -1,
            option: ''
        };
        PallasartV2.cache.loan = 0;
        PallasartV2.cache.rate = 0;
        PallasartV2.cache.interest = 0;
        PallasartV2.cache.remember_save = false;
        PallasartV2.cache.save = '';
        PallasartV2.cache.style = false;
        PallasartV2.cache.get_started = false;
        PallasartV2.cache.highlight_option = false;
        PallasartV2.cache.lead = {
            rid: null,
            hist: null,
            url: null
        };
        PallasartV2.cache.vizualize = 1;
        PallasartV2.cache.impersonate = false;
        PallasartV2.cache.floorplans = [];
    },

    customerStatus: function() {
        fetch(
            PallasartUrl.customer_status,
            {
                method: 'get',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        ).then((response) => {
            if (response.ok) {
                return response.json();
            }

            return Promise.reject(response);
        }).then((response) => {
            if (PallasartUtils.objectPropertyExists(response, 'found')) {
                PallasartV2.cache.customer = response.found;
            }

            if (PallasartUtils.objectPropertyExists(response, 'html')) {
                let menu = document.querySelector('.global-pre-header');
                if (menu) {
                    let existing = menu.querySelectorAll('.bs-custom-navlink');
                    if (existing) {
                        for (const option of existing) {
                            option.remove();
                        }
                    }

                    menu.innerHTML += response.html;
                }
            }
        }).catch((reason) => {
            // console.log(reason);
        });
    },

    customerPopup: function(url, get_started) {
        PallasartUtils.toggleLoading();

        fetch(
            url,
            {
                method: 'get',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        ).then((response) => {
            PallasartUtils.toggleLoading(false);
            window.scrollTo(0, 0);

            if (response.ok) {
                return response.json();
            }

            return Promise.reject(response);
        }).then((response) => {
            if (PallasartUtils.objectPropertyExists(response, 'error')) {
                PallasartUtils.createModal(
                    response.error,
                    'Error',
                    false,
                    false
                );
            }

            if (PallasartUtils.objectPropertyExists(response, 'html')) {
                if (get_started === true) {
                    PallasartV2.cache.get_started = true;
                }

                PallasartUtils.createModal(
                    response.html,
                    (PallasartUtils.objectPropertyExists(response, 'headline') ? response.headline : false),
                    PallasartUtils.objectPropertyExists(response, 'reload'),
                    PallasartUtils.objectPropertyExists(response, 'cleanload'),
                    (PallasartUtils.objectPropertyExists(response, 'modalClass') ? response.modalClass : false),
                    (PallasartUtils.objectPropertyExists(response, 'dialogClass') ? response.dialogClass : false),
                );
            } else if (PallasartUtils.objectPropertyExists(response, 'reload')) {
                window.location.reload();
            } else if (PallasartUtils.objectPropertyExists(response, 'cleanload')) {
                window.location.href = PallasartUtils.currentUrl();
            }
        }).catch((reason) => {
            // console.log(reason);

            if (get_started === true) {
                PallasartV2.getStarted();
            }
        });
    },

    submitCustomerPopup: function(form, url) {
        if (form.classList.contains('submitting')) {
            return false;
        }

        PallasartUtils.clearChildren(form, '.bs-alert');
        PallasartUtils.clearChildren(form, '.bs-text-danger');

        form.classList.add('bs-was-validated');

        let validity = form.checkValidity();
        let elements = form.querySelectorAll('.needs-validation');
        for (const element of elements) {
            PallasartUtils.validateInput(element);
        }

        if (!validity) {
            let error = PallasartUtils.createErrorAlert(
                'There was an input error, please fill in all required fields and carefully review the values you entered.'
            );
            form.prepend(error);

            return false;
        }

        form.classList.add('submitting');
        let button = form.querySelector('button.submit');
        button.setAttribute('data-title', button.innerText);
        button.innerText = 'Submitting...';

        let data = new FormData(form);
        data.append('url', PallasartUtils.currentUrl());
        let params = new URLSearchParams(data);

        fetch(
            url,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/x-www-form-urlencoded'
                },
                body: params
            }
        ).then((response) => {
            PallasartUtils.clearChildren(form, '.bs-alert');
            PallasartUtils.clearChildren(form, '.bs-text-danger');

            form.classList.remove('submitting');
            form.classList.remove('bs-was-validated');
            button.innerText = button.getAttribute('data-title');

            if (response.ok) {
                return response.json();
            }

            return Promise.reject(response);
        }).then((response) => {
            if (PallasartUtils.objectPropertyExists(response, 'errors')) {
                for (const key of Object.keys(response.errors)) {
                    if (key === '#') {
                        let error = PallasartUtils.createErrorAlert(response.errors[key]);
                        form.prepend(error);
                    } else {
                        let error = PallasartUtils.createErrorNote(response.errors[key]);
                        let element = form.querySelector(key);
                        if (element) {
                            element.classList.add('is-invalid');
                            element.closest('.bs-form-group').append(error);
                        }
                    }
                }
            }

            if (PallasartUtils.objectPropertyExists(response, 'error')) {
                let error = PallasartUtils.createErrorAlert(response.error);
                form.prepend(error);
            }

            if (PallasartUtils.objectPropertyExists(response, 'success')) {
                form.reset();

                if (PallasartUtils.objectPropertyExists(response, 'login') && (response.login === 1)) {
                    PallasartV2.cache.customer = true;
                    PallasartUtils.destroyModal();
                    PallasartV2.refreshToolbar();

                    if (PallasartV2.cache.get_started === true) {
                        PallasartV2.getStarted();
                    }
                }

                if (PallasartUtils.objectPropertyExists(response, 'menu')) {
                    let menu = document.querySelector('.global-pre-header');
                    if (menu) {
                        let existing = menu.querySelectorAll('.bs-custom-navlink');
                        if (existing) {
                            for (const option of existing) {
                                option.remove();
                            }
                        }

                        menu.innerHTML = menu.innerHTML + response.menu;
                    }
                }

                if (PallasartUtils.objectPropertyExists(response, 'context')) {
                    let contexts = document.querySelectorAll('.bs-contexts');
                    if (contexts) {
                        for (const context of contexts) {
                            context.innerHTML = response.context;
                        }
                    }
                }

                if (PallasartUtils.objectPropertyExists(response, 'save_progress') && (response.save_progress === 1)) {
                    PallasartV2.saveProgress(false);
                } else if (PallasartUtils.objectPropertyExists(response, 'save_home') && (response.save_home === 1)) {
                    PallasartV2.saveHome(false);
                } else if (PallasartUtils.objectPropertyExists(response, 'quote') && (response.quote === 1)) {
                    PallasartUtils.destroyModal();
                    PallasartV2.review();
                } else if (!(PallasartUtils.objectPropertyExists(response, 'login') && (response.login === 1))) {
                    PallasartUtils.createModal(
                        response.success,
                        false,
                        PallasartUtils.objectPropertyExists(response, 'reload'),
                        PallasartUtils.objectPropertyExists(response, 'cleanload'),
                        (PallasartUtils.objectPropertyExists(response, 'modalClass') ? response.modalClass : false),
                        (PallasartUtils.objectPropertyExists(response, 'dialogClass') ? response.dialogClass : false)
                    );
                }
            } else if (PallasartUtils.objectPropertyExists(response, 'reload')) {
                window.location.reload();
            } else if (PallasartUtils.objectPropertyExists(response, 'cleanload')) {
                window.location.href = PallasartUtils.currentUrl();
            }
        }).catch((reason) => {
            // console.log(reason);

            if (PallasartV2.cache.get_started === true) {
                PallasartV2.getStarted();
            }
        });

        return false;
    },

    customerHomesPopup: function(url) {
        if (PallasartV2.cache.home) {
            url = url + '?current=' + PallasartV2.cache.home;
        }

        return PallasartV2.customerPopup(url);
    },

    fetchPlanDetails: function(enforce, onComplete) {
        if ((PallasartV2.cache.plan === false) || (enforce === true)) {
            const url = new URL(PallasartUrl.plan_details, window.location.origin),
                query = {
                    communityrid: PallasartV2.kova.communityrid,
                    modelrid: PallasartV2.kova.modelrid,
                    lotrid: PallasartV2.kova.lotrid,
                    slsordrid: PallasartV2.kova.slsordrid
                };

            Object.keys(query).forEach(key => url.searchParams.append(key, query[key]));

            fetch(
                url,
                {
                    method: 'get',
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json; charset=utf-8'
                    }
                }
            ).then((response) => {
                if (response.ok) {
                    return response.json();
                }

                return Promise.reject(response);
            }).then((response) => {
                if (PallasartUtils.objectPropertyExists(response, 'plan')) {
                    PallasartV2.cache.plan = response.plan ? response.plan : false;
                }

                PallasartV2.refreshToolbar();

                if ((typeof onComplete != 'undefined') && (onComplete != null)) {
                    onComplete();
                }
            }).catch((reason) => {
                // console.log(reason);
            });
        }
    },

    fetchLotDetails: function(lot, onComplete, enforce) {
        if ((PallasartV2.cache.lot === false) || (enforce === true)) {
            fetch(
                PallasartUrl.lot + '?lotrid=' + lot,
                {
                    method: 'get',
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json; charset=utf-8'
                    }
                }
            ).then((response) => {
                if (response.ok) {
                    return response.json();
                }

                return Promise.reject(response);
            }).then((response) => {
                if (PallasartUtils.objectPropertyExists(response, 'lot')) {
                    PallasartV2.cache.lot = response.lot ? response.lot : false;
                }

                if ((typeof onComplete !== 'undefined') && (onComplete !== false)) {
                    onComplete();
                }
            }).catch((reason) => {
                // console.log(reason);
            });
        } else if ((typeof onComplete !== 'undefined') && (onComplete !== false)) {
            onComplete();
        }
    },

    fetchSlsOrdDetails: function(slsord, onComplete, enforce) {
        if ((PallasartV2.cache.slsord === false) || (enforce === true)) {
            fetch(
                PallasartUrl.slsord + '?slsordrid=' + slsord,
                {
                    method: 'get',
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/json; charset=utf-8'
                    }
                }
            ).then((response) => {
                if (response.ok) {
                    return response.json();
                }

                return Promise.reject(response);
            }).then((response) => {
                if (PallasartUtils.objectPropertyExists(response, 'slsord')) {
                    PallasartV2.cache.slsord = response.slsord ? response.slsord : false;
                }

                if ((typeof onComplete !== 'undefined') && (onComplete !== false)) {
                    onComplete();
                }
            }).catch((reason) => {
                // console.log(reason);
            });
        } else if ((typeof onComplete !== 'undefined') && (onComplete !== false)) {
            onComplete();
        }
    },

    kovaInit: function(community, model, lot, slsord, city, options) {
        PallasartV2.kova = new Kova.WC.OptionConfigurator(-1);
        PallasartV2.kova.setApiUrl(PallasartV2.endpointUrl);
        PallasartV2.kova.setApiUsername(PallasartV2.endpointUsername);
        PallasartV2.kova.setApiKey(PallasartV2.endpointPassword);

        PallasartV2.kova.communityrid = community;
        PallasartV2.kova.modelrid = model;
        PallasartV2.kova.lotrid = (lot ? lot : 0);
        PallasartV2.kova.slsordrid = (slsord ? slsord : 0);
        if (city) {
            PallasartV2.kova.SelectedOptions = {
                'LOCATION': city
            };
        } else {
            PallasartV2.kova.SelectedOptions = {};
        }

        if (options) {
            PallasartV2.kova.setDefaultRequestParams(JSON.parse(options));
        }
    },

    kovaChange: function(community, model, lot, slsord, options, onComplete) {
        PallasartV2.kova.communityrid = community;
        PallasartV2.kova.modelrid = model;
        PallasartV2.kova.lotrid = (lot ? lot : 0);
        PallasartV2.kova.slsordrid = (slsord ? slsord : 0);
        PallasartV2.kova.setDefaultRequestParams(options);

        PallasartUtils.toggleLoading();
        PallasartV2.kova.postStateChange(PallasartV2.kova.selectedFloorIndex, function (data) {
            PallasartUtils.toggleLoading(false);

            if ((typeof onComplete != 'undefined') && (onComplete != null)) {
                onComplete();
            }
        });
    },

    kovaReset: function(options, onComplete) {
        PallasartV2.kova.communityrid = PallasartV2.community;
        PallasartV2.kova.modelrid = PallasartV2.model;
        PallasartV2.kova.lotrid = (PallasartV2.lot ? PallasartV2.lot : 0);
        PallasartV2.kova.slsordrid = (PallasartV2.slsord ? PallasartV2.slsord : 0);
        PallasartV2.kova.setDefaultRequestParams(options);

        PallasartUtils.toggleLoading();
        PallasartV2.kova.postStateChange(PallasartV2.kova.selectedFloorIndex, function (data) {
            PallasartUtils.toggleLoading(false);

            if ((typeof onComplete != 'undefined') && (onComplete != null)) {
                onComplete();
            }
        });
    },

    prepareConfigObject: function(config) {
        if ((Object.prototype.toString.call(config) === '[object Object]') &&
            (config.config !== false) && (config.config !== null) && (config.config !== 0) &&
            (Object.prototype.toString.call(config.config) === '[object Object]')
        ) {
            config = config.config;
        }

        if ((Object.prototype.toString.call(config) === '[object Object]') &&
            (!PallasartUtils.objectPropertyExists(config, 'communityRID') || (config.communityRID === false) || (config.communityRID === null) || (config.communityRID === 0))
        ) {
            config.communityRID = 620;
        }

        if ((Object.prototype.toString.call(config) === '[object Object]') &&
            (config.communityRID !== false) && (config.communityRID !== null) && (config.communityRID !== 0) &&
            (config.modelRID !== false) && (config.modelRID !== null) && (config.modelRID !== 0)
        ) {
            return config;
        }

        return false;
    },

    init: function(config, options, skip_welcome) {
        config = PallasartV2.prepareConfigObject(config);

        if (config) {
            PallasartV2.community = config.communityRID;
            PallasartV2.model = config.modelRID;

            if (PallasartUtils.objectPropertyExists(config, 'lotRID') && (config.lotRID !== false) && (config.lotRID !== null) && (config.lotRID !== 0) && (config.lotRID !== '0')) {
                PallasartV2.lot = config.lotRID;
            }

            if (PallasartUtils.objectPropertyExists(config, 'salesOrderRID') && (config.salesOrderRID !== false) && (config.salesOrderRID !== null) && (config.salesOrderRID !== 0) && (config.salesOrderRID !== '0')) {
                PallasartV2.slsord = config.salesOrderRID;
            }

            if (PallasartUtils.objectPropertyExists(config, 'cityID') && (config.cityID !== false) && (config.cityID !== null) && (config.cityID !== 0) && (config.cityID !== '0')) {
                PallasartV2.city = config.cityID;
            }

            PallasartV2.kovaInit(
                PallasartV2.community,
                PallasartV2.model,
                PallasartV2.lot,
                PallasartV2.slsord,
                PallasartV2.city,
                ((typeof options !== undefined) ? options : false)
            );

            PallasartV2.fetchPlanDetails();

            if (PallasartUtils.objectPropertyExists(config, 'communityID')) {
                PallasartV2.community = config.communityID;
                PallasartV2.lot = 0;
                PallasartV2.slsord = 0;
            }

            if (PallasartUtils.objectPropertyExists(config, 'modelID')) {
                PallasartV2.model = config.modelID;
                PallasartV2.lot = 0;
                PallasartV2.slsord = 0;
            }

            if (PallasartUtils.objectPropertyExists(config, 'lotID')) {
                PallasartV2.lot = config.lotID;
            }

            if (PallasartUtils.objectPropertyExists(config, 'salesOrderID')) {
                PallasartV2.slsord = config.salesOrderID;
            }

            if ((typeof options !== 'undefined') && (options !== null)) {
                options = JSON.parse(options);

                if (PallasartUtils.objectPropertyExists(options, 'SelectedOptions') && PallasartUtils.objectPropertyExists(options['SelectedOptions'], 'CS-COLORS')) {
                    PallasartV2.cache.style = options['SelectedOptions']['CS-COLORS'];
                }
            }

            PallasartV2.setupStage();

            if (skip_welcome !== true) {
                PallasartV2.welcome();

                let root = PallasartUtils.getRoot();
                let submit = root.querySelector('#welcome-submit');

                if (submit) {
                    submit.setAttribute('disabled', 'disabled');

                    let existing = submit.querySelectorAll('.bs-widget-spin');
                    if (existing.length === 0) {
                        submit.prepend(PallasartUtils.createSpinner(true));
                    }

                    submit.addEventListener('click', function() {
                        if (submit.getAttribute('disabled') !== 'disabled') {
                            PallasartV2.promoteAccount('#welcomeModal');
                        }
                    });
                }

                return false;
            } else {
                PallasartV2.promoteAccount();
            }
        }
    },

    welcome: function() {
        let key = 'design_start';

        if (PallasartV2.slsord) {
            key = 'design_start_market';
        }

        if ((key in PallasartV2.messages) && PallasartV2.messages[key]) {
            let root = PallasartUtils.getRoot();
            root.insertAdjacentHTML('beforeend', PallasartV2.messages[key]);

            PallasartUtils.showModal('#welcomeModal');
        } else {
            PallasartV2.promoteAccount();
        }
    },

    promoteAccount: function(selector) {
        // document.getElementById('app').classList.add('hidden');
        document.querySelector('#app > .global-header-wrap').classList.add('hidden');
        document.querySelector('#app > #main').classList.add('hidden');
        document.querySelector('#app > .global-footer').classList.add('hidden');

        let root = PallasartUtils.getRoot();
        root.classList.remove('bs-preparing');
        root.classList.add('bs-prepared');

        if (typeof selector !== 'undefined') {
            PallasartUtils.hideModal(selector);
        }

        if ((PallasartV2.cache.customer === false) && ('account_start' in PallasartV2.messages) && PallasartV2.messages.account_start) {
            let root = PallasartUtils.getRoot();
            root.insertAdjacentHTML('beforeend', PallasartV2.messages.account_start);

            PallasartUtils.showModal('#promoteModal');
        } else {
            PallasartV2.getStarted();
        }

        if (PallasartV2.skip_to_review && PallasartV2.slsord) {
            PallasartV2.cache.popups.push('get_started');
            PallasartV2.cache.popups.push('choose_style');
            PallasartV2.showSection('review', false, true);
        }
    },

    getStarted: function() {
        PallasartV2.disableBack();

        if (PallasartV2.cache.get_started) {
            PallasartV2.cache.get_started = false;
        }

        if ((PallasartV2.cache.popups.indexOf('get_started') === -1) && !PallasartV2.slsord) {
            PallasartV2.cache.popups.push('get_started');

            if (('get_started' in PallasartV2.messages) && PallasartV2.messages.get_started && PallasartV2.messages.get_started.disabled !== 1) {
                PallasartUtils.createModal(
                    PallasartV2.messages.get_started.content.replace(
                        'MODEL_NAME',
                        PallasartV2.cache.plan ? PallasartV2.cache.plan.name : ''
                    ),
                    false,
                    false,
                    false,
                    'bs-popup-dark',
                    false,
                    PallasartV2.messages.get_started.button_1
                );
            }
        }
    },

    chooseStyle: function() {
        if ((PallasartV2.cache.popups.indexOf('choose_style') === -1) && PallasartV2.styles) {
            PallasartV2.cache.popups.push('choose_style');

            if (('choose_style' in PallasartV2.messages) && PallasartV2.messages.choose_style) {
                let styles = PallasartOptions.styles();

                if (styles !== false) {
                    PallasartV2.editOption('interior', 0);
                }

                PallasartUtils.createModal(
                    PallasartV2.messages.choose_style.content.replace(
                        'MODEL_NAME',
                        PallasartV2.cache.plan ? PallasartV2.cache.plan.name : ''
                    ),
                    false,
                    false,
                    false,
                    'bs-popup-dark',
                    false,
                    PallasartV2.messages.choose_style.button_1
                );
            }
        }
    },

    placeholderImage: function() {
        let image = document.createElement('img');

        if ((PallasartV2.cache.plan !== false) && PallasartV2.cache.plan.picture) {
            image.src = PallasartV2.cache.plan.picture;
        } else {
            image.src = 'https://hayden-homes-com-smartedit-production-or.s3.us-west-2.amazonaws.com/App/Models/Asset/resources/000/000/889/hd/Timberline%20Sign%20Elev%20I.jpg';
        }

        image.alt = PallasartV2.kova.Plan.Name;

        PallasartParadigm.wrapper.innerHTML = '';
        PallasartParadigm.wrapper.append(image);
    },

    prepareContractor: function() {
        let root = PallasartUtils.getRoot();
        let wrapper = root.querySelector('#kova-stage .bs-widget-wrapper .bs-column-last');

        let contractor = wrapper.querySelector('.bs-widget-contractor');
        if (!contractor) {
            contractor = document.createElement('a');
            contractor.classList.add('bs-widget-contractor');
            contractor.classList.add('bs-btn');
            contractor.classList.add('bs-btn-orange');
            contractor.setAttribute('role', 'button');
            contractor.innerText = 'Collapse';
            contractor.setAttribute('onclick', 'PallasartV2.contractStage();');
            wrapper.append(contractor);
        }
    },

    showReview: function() {
        PallasartV2.contractStage(false);
        PallasartV2.toggleContractor(true);
        PallasartParadigm.wrapper.classList.add('bs-d-none');

        let root = PallasartUtils.getRoot();
        let stage = root.querySelector('#kova-stage');
        if (stage) {
            stage.classList.remove('bs-stage-exterior');
            stage.classList.remove('bs-stage-interior');
            stage.classList.add('bs-stage-review');
        }

        let review = document.getElementById('kova-review');

        if (review) {
            review.classList.add('bs-show');
        }
    },

    hideReview: function() {
        let review = document.getElementById('kova-review');

        if (review) {
            review.classList.remove('bs-show');
        }
        PallasartParadigm.wrapper.classList.remove('bs-d-none');
    },

    showComplete: function() {
        PallasartV2.hideReview();
        PallasartV2.contractStage(false);
        PallasartV2.toggleContractor(true);

        let root = PallasartUtils.getRoot();
        let stage = root.querySelector('#kova-stage');

        if (stage) {
            let wrapper = stage.querySelector('.bs-widget-wrapper');
            if (wrapper) {
                wrapper.classList.add('bs-hide');
            }
        }

        let complete = document.getElementById('kova-complete');

        if (complete) {
            complete.classList.add('bs-show');
        }
    },

    hideComplete: function() {
        let root = PallasartUtils.getRoot();
        let stage = root.querySelector('#kova-stage');

        if (stage) {
            let wrapper = stage.querySelector('.bs-widget-wrapper');
            if (wrapper) {
                wrapper.classList.remove('bs-hide');
            }
        }

        let complete = document.getElementById('kova-complete');

        if (complete) {
            complete.classList.remove('bs-show');
        }
    },

    prepareStage: function() {
        let root = PallasartUtils.getRoot();
        root.classList.add('bs-preparing');

        let stage = root.querySelector('#kova-stage');
        if (!stage) {
            stage = document.createElement('div');
            stage.setAttribute('id', 'kova-stage');
            stage.classList.add('bs-widget-stage');
            root.append(stage);
        } else {
            stage.innerText = '';
        }

        let toolbar = stage.querySelector('#kova-toolbar');
        if (!toolbar) {
            toolbar = document.createElement('div');
            toolbar.setAttribute('id', 'kova-toolbar');
            stage.append(toolbar);
        } else {
            toolbar.innerText = '';
        }
        toolbar.classList.add('bs-widget-toolbar');
        PallasartV2.toolbar = toolbar;

        let wrapper = stage.querySelector('.bs-widget-wrapper');
        if (!wrapper) {
            wrapper = document.createElement('div');
            wrapper.classList.add('bs-widget-wrapper');
            stage.append(wrapper);
        } else {
            wrapper.innerText = '';
        }

        let columns = wrapper.querySelector('.bs-widget-columns');
        if (!columns) {
            columns = document.createElement('div');
            columns.classList.add('bs-widget-columns');
            wrapper.append(columns);
        } else {
            columns.innerText = '';
        }

        let first = wrapper.querySelector('.bs-column-first');
        if (!first) {
            first = document.createElement('div');
            first.classList.add('bs-column-first');
            columns.append(first);
        } else {
            first.innerText = '';
        }

        let last = wrapper.querySelector('.bs-column-last');
        if (!last) {
            last = document.createElement('div');
            last.classList.add('bs-column-last');
            columns.append(last);
        } else {
            last.innerText = '';
        }

        let review = wrapper.querySelector('#kova-review');
        if (!review) {
            review = document.createElement('div');
            review.setAttribute('id', 'kova-review');
            review.classList.add('bs-widget-overview');
            review.classList.add('bs-widget-review');
            last.append(review);
        } else {
            review.innerText = '';
        }

        let configurator = stage.querySelector('#kova-configurator');
        if (!configurator) {
            configurator = document.createElement('div');
            configurator.setAttribute('id', 'kova-configurator');
            first.append(configurator);
        } else {
            configurator.innerText = '';
        }
        configurator.classList.add('bs-widget-configurator');
        PallasartV2.wrapper = configurator;

        let panellum = last.querySelector('#kova-panellum');
        if (!panellum) {
            panellum = document.createElement('div');
            panellum.setAttribute('id', 'kova-panellum');
            last.append(panellum);
        } else {
            panellum.innerText = '';
        }
        panellum.classList.add('bs-widget-panellum');
        PallasartParadigm.wrapper = panellum;

        if (!PallasartV2.slsord) {
            let styles = last.querySelector('#kova-styles');
            if (!styles) {
                styles = document.createElement('div');
                styles.setAttribute('id', 'kova-styles');
                last.append(styles);
            } else {
                styles.innerText = '';
            }
            styles.classList.add('bs-widget-styles');
            styles.classList.add('bs-d-none');
            PallasartV2.styles = styles;
        }

        let disclaimer = last.querySelector('#kova-disclaimer');
        if (!disclaimer) {
            disclaimer = document.createElement('div');
            disclaimer.setAttribute('id', 'kova-disclaimer');
            last.append(disclaimer);
        } else {
            disclaimer.innerText = '';
        }
        disclaimer.classList.add('bs-widget-disclaimer');
        PallasartV2.disclaimer = disclaimer;

        let complete = wrapper.querySelector('#kova-complete');
        if (!complete) {
            complete = document.createElement('div');
            complete.setAttribute('id', 'kova-complete');
            complete.classList.add('bs-widget-complete');
            stage.append(complete);
        } else {
            complete.innerText = '';
        }
    },

    cleanupStage: function() {
        // document.getElementById('app').classList.remove('hidden');
        document.querySelector('#app > .global-header-wrap').classList.remove('hidden');
        document.querySelector('#app > #main').classList.remove('hidden');
        document.querySelector('#app > .global-footer').classList.remove('hidden');

        let root = PallasartUtils.getRoot();

        let children = root.children;
        for (const child of children) {
            child.remove();
        }

        PallasartV2.prepareStage();
        PallasartV2.resetCache();

        // let tokens = window.location.pathname.split('/');
        //
        // if (tokens.length > 1) {
        //     tokens.pop();
        //
        //     if (PallasartV2.slsord) {
        //         tokens.pop();
        //     }
        //     window.location.assign(window.location.protocol + '//' + window.location.hostname + tokens.join('/'));
        // } else {
            window.location.hash = '';
            window.location.reload();
        // }
    },

    setupStage: function() {
        PallasartUtils.toggleLoading();
        PallasartV2.refreshToolbar();
        PallasartV2.refreshDisclaimer();
        PallasartV2.prepareContractor();

        window.addEventListener('resize', function() {
            PallasartV2.resizeStyles();
        });
        screen.orientation.addEventListener('change', function() {
            PallasartV2.resizeStyles();
        });

        if (PallasartV2.lot) {
            PallasartV2.fetchLotDetails(PallasartV2.lot, function() {
                if (PallasartV2.latest_options) {
                    PallasartV2.handleOptions(PallasartV2.latest_options);
                }
            });
        }

        if (PallasartV2.slsord) {
            PallasartV2.fetchSlsOrdDetails(PallasartV2.slsord, function() {
                if (PallasartV2.latest_options) {
                    PallasartV2.handleOptions(PallasartV2.latest_options);
                }
            });
        }

        PallasartV2.triggerKova();
    },

    triggerKova: function() {
        PallasartV2.kova.getInitialSelections();
        PallasartV2.kova.addOptionListFeature(
            'kova-configurator',
            'kova-template',
            {},
            function(data) {
                PallasartV2.latest_options = data;

                let root = PallasartUtils.getRoot();
                let submit = root.querySelector('#welcome-submit');

                if (submit) {
                    submit.removeAttribute('disabled');
                    let spinner = submit.querySelector('.bs-widget-spin');

                    if (spinner) {
                        spinner.remove();
                    }
                }

                if (PallasartParadigm.endpoint === null) {
                    if (PallasartUtils.objectPropertyExists(data.SelectedOptions, 'craftsman') && (data.SelectedOptions['craftsman'] == 'craftsman||')) {
                        PallasartParadigm.setNewCredentials();
                    } else {
                        PallasartParadigm.setOldCredentials();
                    }
                }

                if (PallasartOptions.styles() === false) {
                    PallasartV2.styles = null;
                }

                PallasartV2.handleOptions(data);
                PallasartV2.refreshToolbar();

                PallasartV2.cache.floorplans = [];

                for (const floorId of Object.keys(data.Plan.Floors)) {
                    if (data.Plan.Floors[floorId].Description.toLowerCase().indexOf('exterior') === -1) {
                        PallasartV2.kova.postGenerateFloorPlan(data.Plan.Floors[floorId].Index, 800, 800, function(floorindex, response) {
                            if (PallasartUtils.objectPropertyExists(response, 'Url')) {
                                PallasartV2.cache.floorplans.push({
                                    index: data.Plan.Floors[floorId].Index,
                                    caption: data.Plan.Floors[floorId].Description,
                                    url: response.Url
                                });
                            } else if (PallasartUtils.objectPropertyExists(response, 'FloorPlan')) {
                                PallasartV2.cache.floorplans.push({
                                    index: data.Plan.Floors[floorId].Index,
                                    caption: data.Plan.Floors[floorId].Description,
                                    url: response.FloorPlan.Url
                                });
                            }
                        });
                    }
                }
            }
        );
    },

    isConfiguratorReady: function() {
        let root = PallasartUtils.getRoot();
        let configurator = root.querySelector('#kova-configurator');

        return (configurator.childElementCount > 0);
    },

    retryConfiguratorOptions: function() {
        if (!PallasartV2.isConfiguratorReady() && PallasartV2.latest_options) {
            PallasartV2.handleOptions(PallasartV2.latest_options);
        }
    },

    handleOptions: function(data) {
        PallasartV2.cache.counter = PallasartV2.cache.counter + 1;
        let root = PallasartUtils.getRoot();

        if (!PallasartV2.cache.style && PallasartV2.styles && PallasartV2.slsord) {
            let styles = PallasartOptions.styles();

            if (styles) {
                for (let style of Object.keys(styles)) {
                    if (styles[style]['Selected']) {
                        PallasartV2.selectStyle(style, false);
                        break;
                    }
                }
            }
        }

        PallasartUtils.toggleLoading(false);
        PallasartV2.showSection(PallasartV2.cache.current.section);

        let tooltips = PallasartV2.wrapper.querySelectorAll('[data-bs-toggle="bs-tooltip"]');
        if (tooltips) {
            for (const tooltip of tooltips) {
                new bootstrap.Tooltip(tooltip, {
                    container: root
                });
            }
        }

        if (data.Plan) {
            PallasartV2.handlePricing(
                PallasartV2.totalPrice(data.Plan.Prices.TotalPrice.Value),
                PallasartV2.cache.lot && !PallasartV2.slsord ? PallasartV2.cache.lot.LotPremium : 0
            );
        }

        if (data.Options && PallasartV2.cache.vizualize) {
            PallasartParadigm.cache.options = data.Options;
            PallasartParadigm.loading();

            if (PallasartParadigm.config === null) {
                PallasartParadigm.alternatives(data.Options);
            } else {
                PallasartParadigm.question(data.Options);
            }
        }

        let singles = PallasartV2.wrapper.querySelectorAll('.singlechoice input');
        for (const single of singles) {
            single.addEventListener('click', function(e) {
                e.stopPropagation();

                if (single.hasAttribute('data-optionid')) {
                    PallasartParadigm.cachePosition();

                    let option = PallasartOptions.getAssembledOption(single.getAttribute('data-optionid'));
                    if (option && PallasartUtils.objectPropertyExists(option['Choices'], single.getAttribute('data-optionid'))) {
                        PallasartV2.cache.vizualize = option['Choices'][single.getAttribute('data-optionid')]['Vizualize'];
                    } else {
                        PallasartV2.cache.vizualize = 1;
                    }

                    PallasartUtils.toggleLoading();
                    PallasartV2.cache.current.option = single.getAttribute('data-optionid');

                    let parent = single.closest('.bs-carousel-item');
                    if (parent) {
                        PallasartV2.cache.current.section = parent.getAttribute('data-section');
                        PallasartV2.cache.current.location = PallasartUtils.parseNumeric(parent.getAttribute('data-location'));
                        PallasartV2.cache.current.category = PallasartUtils.parseNumeric(parent.getAttribute('data-category'));
                    }

                    PallasartV2.kova.optionOnChange(single, function () {
                        PallasartUtils.toggleLoading(false);
                        PallasartV2.showSection(PallasartV2.cache.current.section, true);
                        PallasartV2.gotoOption(PallasartV2.cache.current.section, PallasartV2.cache.current.location, PallasartV2.cache.current.category, PallasartV2.cache.current.option);

                        PallasartUtils.destroyBanner();
                        if (!single.hasAttribute('checked')) {
                            let parent_element = single.closest('.bs-choice[data-popup-text]');

                            if (parent_element) {
                                PallasartUtils.createBanner(parent_element.getAttribute('data-popup-text'));
                            }
                        }
                    }, function() {
                        PallasartUtils.toggleLoading(false);
                        PallasartUtils.destroyBanner();
                    });
                }
            });
        }

        let multis = PallasartV2.wrapper.querySelectorAll('.multichoice input');
        for (const multi of multis) {
            multi.addEventListener('click', function(e) {
                e.stopPropagation();

                if (multi.hasAttribute('data-optionid')) {
                    PallasartParadigm.cachePosition();

                    let option = PallasartOptions.getAssembledOption(multi.getAttribute('data-optionid'));
                    if (option && PallasartUtils.objectPropertyExists(option['Choices'], multi.getAttribute('data-choiceid'))) {
                        PallasartV2.cache.vizualize = option['Choices'][multi.getAttribute('data-choiceid')]['Vizualize'];
                    } else {
                        PallasartV2.cache.vizualize = 1;
                    }

                    PallasartUtils.toggleLoading();
                    PallasartV2.cache.current.option = multi.getAttribute('data-optionid');

                    let parent = multi.closest('.bs-carousel-item');
                    if (parent) {
                        PallasartV2.cache.current.section = parent.getAttribute('data-section');
                        PallasartV2.cache.current.location = PallasartUtils.parseNumeric(parent.getAttribute('data-location'));
                        PallasartV2.cache.current.category = PallasartUtils.parseNumeric(parent.getAttribute('data-category'));
                    }

                    PallasartV2.kova.choiceOnChange(multi, multi, function () {
                        PallasartUtils.toggleLoading(false);
                        PallasartV2.showSection(PallasartV2.cache.current.section, true);
                        PallasartV2.gotoOption(PallasartV2.cache.current.section, PallasartV2.cache.current.location, PallasartV2.cache.current.category, PallasartV2.cache.current.option);

                        PallasartUtils.destroyBanner();
                        if (!multi.hasAttribute('checked')) {
                            let parent_element = multi.closest('.bs-choice[data-popup-text]');

                            if (parent_element) {
                                PallasartUtils.createBanner(parent_element.getAttribute('data-popup-text'));
                            }
                        }
                    }, function() {
                        PallasartUtils.toggleLoading(false);
                        PallasartUtils.destroyBanner();
                    });
                }
            });
        }

        let quantities = PallasartV2.wrapper.querySelectorAll('.quantitychoice input');
        for (const quantity of quantities) {
            quantity.addEventListener('change', function(e) {
                e.stopPropagation();

                if (e.target.getAttribute('max') && (e.target.value > e.target.getAttribute('max'))) {
                    e.target.value = e.target.getAttribute('max');
                    PallasartUtils.createModal('The maximum allowed is ' + e.target.getAttribute('max'), false);
                } else if (quantity.hasAttribute('data-optionid')) {
                    PallasartParadigm.cachePosition();

                    let option = PallasartOptions.getAssembledOption(quantity.getAttribute('data-optionid'));
                    if (option && PallasartUtils.objectPropertyExists(option['Choices'], quantity.getAttribute('data-optionid'))) {
                        PallasartV2.cache.vizualize = option['Choices'][quantity.getAttribute('data-optionid')]['Vizualize'];
                    } else {
                        PallasartV2.cache.vizualize = 1;
                    }

                    PallasartUtils.toggleLoading();
                    PallasartV2.cache.current.option = quantity.getAttribute('data-optionid');

                    let parent = quantity.closest('.bs-carousel-item');
                    if (parent) {
                        PallasartV2.cache.current.section = parent.getAttribute('data-section');
                        PallasartV2.cache.current.location = PallasartUtils.parseNumeric(parent.getAttribute('data-location'));
                        PallasartV2.cache.current.category = PallasartUtils.parseNumeric(parent.getAttribute('data-category'));
                    }

                    PallasartOptions.setQuantity(
                        quantity.getAttribute('data-section'),
                        quantity.getAttribute('data-location'),
                        quantity.getAttribute('data-category'),
                        quantity.getAttribute('data-optionid'),
                        quantity.value
                    );

                    PallasartV2.kova.qtyOnChange(quantity, quantity.value, function () {
                        PallasartUtils.toggleLoading(false);
                        PallasartV2.gotoOption(PallasartV2.cache.current.section, PallasartV2.cache.current.location, PallasartV2.cache.current.category, PallasartV2.cache.current.option);
                        PallasartUtils.destroyBanner();

                        if (quantity.value) {
                            let parent_element = quantity.closest('.bs-choice[data-popup-text]');

                            if (parent_element) {
                                PallasartUtils.createBanner(parent_element.getAttribute('data-popup-text'));
                            }
                        }
                    });
                }
            });
        }

        let stagehomes = PallasartV2.wrapper.querySelectorAll('.stage_home input');
        for (const stagehome of stagehomes) {
            if (PallasartParadigm.stage_home === true) {
                stagehome.checked = true;
            }

            stagehome.addEventListener('click', function(e) {
                e.stopPropagation();

                for (const mystagehome of stagehomes) {
                    mystagehome.checked = stagehome.checked;
                }

                PallasartUtils.toggleLoading();
                PallasartParadigm.stage_home = stagehome.checked;
                PallasartParadigm.question(data.Options);
            });
        }

        let scrolls =  PallasartV2.wrapper.querySelectorAll('.bs-simplebar');
        for (const scroll of scrolls) {
            new SimpleBar(scroll, {
                autoHide: false,
            });
        }
    },

    contractStage: function(force) {
        let root = PallasartUtils.getRoot();

        let stage = root.querySelector('#kova-stage');
        if (stage) {
            let wrapper = stage.querySelector('.bs-widget-wrapper .bs-column-last');

            let contractor = wrapper.querySelector('.bs-widget-contractor');

            if (stage.classList.contains('bs-contracted') || (force === false)) {
                stage.classList.remove('bs-contracted');

                if (contractor) {
                    contractor.innerText = 'Collapse';
                }
            } else if (!stage.classList.contains('bs-contracted') || (force === true)) {
                stage.classList.add('bs-contracted');

                if (contractor) {
                    contractor.innerText = 'See All Options';
                }
            }

            if (PallasartParadigm.instance) {
                setTimeout(function() {
                    PallasartParadigm.resizeViewer();
                }, 1000);
            }
        }
    },

    toggleContractor: function(state) {
        let root = PallasartUtils.getRoot();

        let stage = root.querySelector('#kova-stage');
        if (stage) {
            let wrapper = stage.querySelector('.bs-widget-wrapper .bs-column-last');

            let contractor = wrapper.querySelector('.bs-widget-contractor');
            if (contractor) {
                if (state === true) {
                    contractor.classList.remove('bs-d-none');
                } else {
                    contractor.classList.add('bs-d-none');
                }
            }
        }

        let summary = root.querySelector('.bs-widget-summary');
        if (summary) {
            if (state === true) {
                summary.classList.remove('bs-d-none');
            } else {
                summary.classList.add('bs-d-none');
            }
        }
    },

    handlePricing: function(price, premium) {
        let amount = PallasartUtils.parseNumeric(price) + premium;
        let total = PallasartV2.wrapper.querySelector('#kova-amount-total');

        total.innerText = '$' + PallasartUtils.formatPrice(amount);
        let extra = PallasartV2.wrapper.querySelector('#kova-amount-extra');

        let extrasTotal = PallasartOptions.extraTotal();
        if (extrasTotal > 0) {
            extra.innerText = 'See $' + PallasartUtils.formatPrice(extrasTotal) + ' in options';
            extra.classList.add('bs-active');
            extra.replaceWith(extra.cloneNode(true));
            extra = PallasartV2.wrapper.querySelector('#kova-amount-extra');
            extra.addEventListener('click', function(e) {
                e.preventDefault();
                PallasartV2.extraOptions(amount, extrasTotal, PallasartOptions.extra());
            });
        }

        if (PallasartV2.cache.plan) {
            if (!PallasartV2.cache.loan || (PallasartV2.cache.loan > amount)) {
                PallasartV2.cache.loan = amount * 0.2;
            }

            if (PallasartV2.cache.interest == 0) {
                PallasartV2.zillowRate(
                    PallasartV2.cache.plan.zip,
                    amount,
                    amount - PallasartV2.cache.loan,
                    function(rate, interest) {
                        if (rate > 0) {
                            PallasartV2.cache.rate = rate;

                            if (PallasartV2.cache.interest == 0) {
                                PallasartV2.cache.interest = interest;
                            }

                            let est = PallasartV2.wrapper.querySelector('#kova-amount-est');
                            est.innerText = '$' + PallasartUtils.formatPrice(rate);
                            est.addEventListener('click', function(e) {
                                e.preventDefault();
                                PallasartV2.estOptions(amount);
                            });
                            est.parentNode.classList.remove('bs-d-none');
                        }
                    }
                );
            } else {
                let rate = PallasartV2.cache.interest / 100 / 12;
                let loan = amount - PallasartV2.cache.loan;
                let payment = Math.round(loan * ((rate * Math.pow(1 + rate, 360)) / (Math.pow(1 + rate, 360) - 1)));

                if (payment > 0) {
                    PallasartV2.cache.rate = payment;

                    let est = PallasartV2.wrapper.querySelector('#kova-amount-est');
                    est.innerText = '$' + PallasartUtils.formatPrice(payment);
                    est.addEventListener('click', function(e) {
                        e.preventDefault();
                        PallasartV2.estOptions(amount);
                    });
                    est.parentNode.classList.remove('bs-d-none');
                }
            }
        }
    },

    refreshToolbar: function() {
        if (typeof _ === 'undefined' || !PallasartV2.toolbar) {
            return false;
        }

        let template = _.template(
            document.getElementById('kova-toolbar-template').innerHTML
        );

        let section = '';
        let steps = 0;
        let step = 0;
        let demo = false;

        if (('demo' in PallasartV2.messages) && PallasartV2.messages.demo) {
            demo = PallasartV2.messages.demo;
        }

        if (PallasartV2.cache.plan) {
            if ((PallasartV2.cache.current.section === 'exterior') || (PallasartV2.cache.current.section === '')) {
                section = 'Exterior';
            } else if (PallasartV2.cache.current.section === 'interior') {
                section = 'Interior';
            }

            steps = PallasartV2.totalSteps(PallasartV2.cache.current.section);
            step = PallasartV2.totalMarkedAsCompleted(PallasartV2.cache.current.section);

            PallasartV2.toolbar.innerHTML = template({
                image: PallasartV2.cache.plan.picture,
                model: PallasartV2.cache.plan.name,
                levels: PallasartV2.cache.plan.story,
                beds: PallasartV2.cache.plan.bedrooms,
                baths: PallasartV2.cache.plan.bathrooms,
                sqft: PallasartV2.cache.plan.sqf,
                community: PallasartV2.cache.plan.community,
                lot: PallasartV2.cache.lot,
                city: PallasartV2.cache.plan.city.length ? PallasartV2.cache.plan.city : PallasartOptions.getLocationCity(),
                state: PallasartV2.cache.plan.state,
                section: section,
                step: step,
                steps: steps,
                demo: demo
            });
        } else {
            PallasartV2.toolbar.innerHTML = template({
                image: '',
                model: '',
                levels: '',
                beds: '',
                baths: '',
                sqft: '',
                community: '',
                lot: PallasartV2.cache.lot,
                city: PallasartOptions.getLocationCity(),
                state: '',
                section: section,
                step: step,
                steps: steps,
                demo: demo
            });
        }
    },

    refreshDisclaimer: function() {
        if (('disclaimer' in PallasartV2.messages) && PallasartV2.messages.disclaimer && (PallasartV2.cache.impersonate === false)) {
            let wrapper = document.createElement('div');
            wrapper.classList.add('bs-disclaimer');
            wrapper.innerHTML = PallasartV2.messages.disclaimer.content;

            let button = document.createElement('button');
            button.setAttribute('type', 'button');
            button.setAttribute('aria-label', 'Close');
            button.setAttribute('onclick', 'PallasartV2.closeDisclaimer()');
            button.classList.add('bs-btn-close');

            PallasartV2.closeDisclaimer();

            if (PallasartV2.disclaimer) {
                PallasartV2.disclaimer.append(wrapper);
                PallasartV2.disclaimer.append(button);
            }
        }
    },

    closeDisclaimer: function() {
        if (PallasartV2.disclaimer) {
            PallasartV2.disclaimer.innerText = '';
        }
    },

    previousSectionPane: function(section) {
        if (PallasartV2.cache.current.category > 0) {
            PallasartV2.editOption(section, PallasartV2.cache.current.location);
        } else {
            let slide = PallasartV2.wrapper.querySelector('#pane-' + section + '-' + PallasartV2.cache.current.location);

            if (slide && !slide.classList.contains('bs-active')) {
                PallasartV2.editOption(section, PallasartV2.cache.current.location);
            } else {
                PallasartV2.showSection(section, true);
            }
        }
    },

    showSection: function(section, silent, toggle) {
        let root = PallasartUtils.getRoot();
        let stage = root.querySelector('#kova-stage');
        if (stage) {
            stage.classList.remove('bs-stage-exterior');
            stage.classList.remove('bs-stage-interior');
            stage.classList.remove('bs-stage-review');
        }

        if (section === '') {
            section = 'exterior';
        }

        PallasartUtils.destroyBanner();
        PallasartV2.contractStage(false);
        PallasartV2.toggleContractor(true);

        if (toggle === true) {
            let element = PallasartV2.wrapper.querySelector('.bs-column-sidebar');
            if (element) {
                element.classList.add('bs-toggled');
            }

            element = PallasartV2.wrapper.querySelector('.bs-column-options');
            if (element) {
                element.classList.add('bs-toggled');
            }

            element = PallasartV2.wrapper.querySelector('.bs-widget-mobile-head');
            if (element) {
                element.classList.add('bs-toggled');
            }
        }

        if ((section === 'review') && !PallasartV2.cache.style && PallasartV2.styles && !PallasartV2.slsord) {
            PallasartV2.showSection('interior');
            PallasartV2.editOption('interior', 0);
            return;
        }

        if ((section !== 'exterior') || (PallasartV2.cache.counter > 1)) {
            PallasartUtils.showTooltips('#options-' + section, '.tooltip-trigger');
        } else {
            PallasartUtils.hideTooltips('.tooltip-trigger');
        }

        if ((section !== PallasartV2.cache.current.section) || (silent === true)) {
            let buttons = PallasartV2.wrapper.querySelectorAll('.bs-widget-sidebar button');
            if (buttons) {
                for (const button of buttons) {
                    if (button.classList.contains('bs-' + section)) {
                        button.classList.add('bs-active');
                    } else if (button.classList.contains('bs-active')) {
                        button.classList.remove('bs-active');
                    }
                }
            }

            let panes = PallasartV2.wrapper.querySelectorAll('.bs-column-options .bs-collapse');
            if (panes) {
                for (const pane of panes) {
                    if (!pane.classList.contains('colors-list')) {
                        if (pane.classList.contains('bs-' + section)) {
                            Collapse.getOrCreateInstance(pane).show();
                        } else if (pane.classList.contains('bs-show')) {
                            Collapse.getOrCreateInstance(pane).hide();
                        }
                    }
                }
            }

            let lists = PallasartV2.wrapper.querySelectorAll('.bs-column-options .bs-list');
            if (lists) {
                for (const list of lists) {
                    list.classList.remove('bs-d-none');
                }
            }

            let details = PallasartV2.wrapper.querySelectorAll('.bs-column-options .bs-details');
            if (details) {
                for (const detail of details) {
                    detail.classList.add('bs-d-none');
                }
            }

            if ((section !== 'interior') && PallasartV2.styles) {
                PallasartV2.styles.classList.add('bs-d-none');
            }

            if (section === 'exterior') {
                PallasartV2.hideReview();

                if (stage) {
                    stage.classList.add('bs-stage-exterior');
                }

                if ((silent !== true) && (PallasartV2.cache.current.section !== '')) {
                    PallasartV2.getStarted();
                }

                let exterior = PallasartV2.wrapper.querySelector('.bs-column-options #options-exterior');
                if (exterior) {
                    exterior.classList.add('bs-show');
                    Collapse.getOrCreateInstance(exterior).show();
                }

                PallasartParadigm.scene('Exterior');
            } else if (section === 'interior') {
                PallasartV2.hideReview();

                if (stage) {
                    stage.classList.add('bs-stage-interior');
                }

                if (silent !== true) {
                    PallasartV2.chooseStyle();
                }

                let interior = PallasartV2.wrapper.querySelector('.bs-column-options #options-interior');
                if (interior) {
                    interior.classList.add('bs-show');
                    Collapse.getOrCreateInstance(interior).show();
                }
            } else if (section === 'review') {
                PallasartV2.review();

                if (stage) {
                    stage.classList.add('bs-stage-review');
                }
            }

            let options = PallasartV2.wrapper.querySelector('.bs-widget-options');
            if (options) {
                options.classList.remove('bs-show-details');
            }

            if ((section === 'interior') && !PallasartV2.cache.style && PallasartV2.styles) {
                PallasartV2.editOption('interior', 0);
            }

            PallasartV2.cache.current.section = section;

            PallasartV2.refreshToolbar();
        }
    },

    hideSection: function() {
        let element = PallasartV2.wrapper.querySelector('.bs-column-sidebar');
        if (element) {
            element.classList.remove('bs-toggled');
        }

        element = PallasartV2.wrapper.querySelector('.bs-column-options');
        if (element) {
            element.classList.remove('bs-toggled');
        }

        element = PallasartV2.wrapper.querySelector('.bs-widget-mobile-head');
        if (element) {
            element.classList.remove('bs-toggled');
        }

        let lists = PallasartV2.wrapper.querySelectorAll('.bs-column-options .bs-list');
        if (lists) {
            for (let list of lists) {
                list.classList.remove('bs-d-none');
            }
        }

        let details = PallasartV2.wrapper.querySelectorAll('.bs-column-options .bs-details');
        if (details) {
            for (let detail of details) {
                detail.classList.add('bs-d-none');
            }
        }
    },

    editOption: function(section, location_index, category_index) {
        if (PallasartV2.styles) {
            PallasartV2.styles.classList.add('bs-d-none');
        }
        PallasartUtils.destroyBanner();

        let parent = PallasartV2.wrapper.querySelector('#options-' + section);
        let list = parent.querySelector('.bs-list');
        let details = parent.querySelector('.bs-details');
        let carousel = parent.querySelector('.bs-carousel');

        if ((section === 'interior') && PallasartV2.styles) {
            let styles = PallasartOptions.styles();

            if (styles !== false) {
                if (!PallasartV2.cache.style) {
                    location_index = 0;
                    category_index = 0;
                    PallasartV2.cache.current.section = 'interior';
                    PallasartV2.cache.current.location = 0;
                    PallasartV2.cache.current.category = 0;
                }

                let isFirstNext = false;

                if (carousel && (location_index === false)) {
                    let firstPane = carousel.querySelector('.bs-carousel-item.bs-active');
                    if (firstPane.getAttribute('data-pane') === '0') {
                        isFirstNext = true;
                    }
                }

                if (isFirstNext) {
                    PallasartV2.showSection('interior', true, true);
                }

                if (!PallasartUtils.isMobileView() && ((location_index === 0) || isFirstNext)) {
                    let locations = parent.querySelectorAll('.bs-categories.locations > li > a');
                    locations[0].classList.add('bs-completed');

                    PallasartV2.markAsCompleted(section, location_index, 0);
                    PallasartV2.refreshToolbar();
                    PallasartV2.chooseStyles();
                    return;
                }
            }
        }

        if (list) {
            list.classList.add('bs-d-none');
        }

        if (details) {
            details.classList.remove('bs-d-none');

            let options = PallasartV2.wrapper.querySelector('.bs-widget-options');
            if (options) {
                options.classList.add('bs-show-details');
            }
        }

        if (carousel) {
            let panes = carousel.querySelectorAll('.bs-carousel-item');
            let active = carousel.querySelector('.bs-carousel-item.bs-active');
            if (!active) {
                let first = carousel.querySelector('.bs-carousel-item');
                first.classList.add('bs-active');

                PallasartV2.handleEditOption(first);
            }

            let instance = Carousel.getOrCreateInstance(carousel);
            carousel.removeEventListener('slid.bs.carousel', PallasartV2.handleEditOption);
            carousel.addEventListener('slid.bs.carousel', PallasartV2.handleEditOption);

            if (location_index === false) {
                let index = 0;
                let activePane = 0;

                for (const pane of panes) {
                    if (pane.classList.contains('bs-active')) {
                        activePane = index;
                        continue;
                    }

                    index++;
                }

                if ((section === 'interior') && PallasartV2.styles && !PallasartUtils.isMobileView()) {
                    if (activePane !== 1) {
                        instance.prev();
                    }
                } else {
                    if (activePane === 0) {
                        PallasartV2.cache.current.location = 0;
                        PallasartV2.cache.current.category = 0;
                        PallasartV2.previousSectionPane(section);
                    } else {
                        instance.prev();
                    }
                }
            } else if (location_index === true) {
                instance.next();

                let index = 0;

                for (const pane of panes) {
                    if (pane.classList.contains('bs-active')) {
                        if (index === (panes.length - 1)) {
                            if (section === 'exterior') {
                                PallasartV2.showSection('interior', false, true);
                                return;
                            } else if (section === 'interior') {
                                PallasartV2.showSection('review', false, true);
                                return;
                            }
                        }
                    }

                    index++;
                }
            } else if ((location_index !== -1) && (typeof category_index !== 'undefined')) {
                for (const pane of panes) {
                    if (pane.getAttribute('id') === ('pane-' + section + '-' + location_index + '-' + category_index)) {
                        instance.to(pane.getAttribute('data-pane'));
                        break;
                    }
                }
            } else if (location_index !== -1) {
                let skippable = PallasartV2.wrapper.querySelector('#pane-' + section + '-' + location_index) ? false : true;

                for (const pane of panes) {
                    if ((!skippable && (pane.getAttribute('id') === ('pane-' + section + '-' + location_index))) || (skippable && (pane.getAttribute('id') === ('pane-' + section + '-' + location_index + '-0')))) {
                        instance.to(pane.getAttribute('data-pane'));
                        break;
                    }
                }

                if (skippable) {
                    PallasartV2.markAsCompleted(section, location_index, 0);
                    PallasartV2.refreshToolbar();
                }
            }
        }
    },

    handleEditOption: function(event) {
        let target = event;

        if (PallasartUtils.objectPropertyExists(event, 'relatedTarget')) {
            target = event.relatedTarget;
        }

        let section = target.getAttribute('data-section');
        let location_index = target.getAttribute('data-location');
        let category_index = target.getAttribute('data-category');

        PallasartV2.cache.current.section = section;
        PallasartV2.cache.current.location = 0;
        PallasartV2.cache.current.category = 0;

        if (parseInt(location_index) >= 0) {
            PallasartV2.cache.current.location = parseInt(location_index);
        }

        if (parseInt(category_index) >= 0) {
            PallasartV2.cache.current.category = parseInt(category_index);
        }

        let parent = PallasartV2.wrapper.querySelector('#options-' + section);
        let locations = parent.querySelectorAll('.bs-categories.locations > li > a');
        let location_caption = false;

        if (location_index !== null) {
            for (const location of locations) {
                if (location.getAttribute('data-location-index') == location_index) {
                    location.classList.add('bs-completed');
                    location_caption = location.getAttribute('data-location');
                }
            }
        }

        if (category_index !== null) {
            let pane = PallasartV2.wrapper.querySelector('#pane-' + section + '-' + location_index);
            if (!pane) {
                pane = PallasartV2.wrapper.querySelector('#pane-' + section + '-' + location_index + '-0');
            }

            let categories = pane ? pane.querySelectorAll('.bs-categories.categories > li > a') : [];

            PallasartV2.markAsCompleted(section, location_index, category_index);
            PallasartV2.refreshToolbar();

            if (categories.length) {
                let category_caption = false;

                for (const category of categories) {
                    if (category.getAttribute('data-category-index') == category_index) {
                        category.classList.add('bs-completed');
                        category_caption = category.getAttribute('data-category');
                    }
                }

                if ((typeof category_caption !== 'undefined') && (category_caption !== false)) {
                    let scene = PallasartOptions.categoryScene(category_caption);

                    if (scene && PallasartParadigm.state && (scene !== PallasartParadigm.state.currentScene.displayName)) {
                        PallasartParadigm.scene(scene);
                        return true;
                    }
                }
            }
        }

        if (locations.length && (typeof location_caption !== 'undefined') && (location_caption !== false)) {
            let scenes = PallasartOptions.locationScenes(location_caption);

            if (scenes && PallasartParadigm.state && (scenes[0] !== PallasartParadigm.state.currentScene.displayName)) {
                PallasartParadigm.scene(scenes[0]);
            }
        }
    },

    gotoOption: function(section, location_index, category_index, option, highlight) {
        if (section) {
            PallasartV2.showSection(section, true);
            PallasartV2.editOption(section, location_index, category_index);
        }

        let element = PallasartV2.wrapper.querySelector('.bs-column-sidebar');
        if (element) {
            element.classList.add('bs-toggled');
        }

        element = PallasartV2.wrapper.querySelector('.bs-column-options');
        if (element) {
            element.classList.add('bs-toggled');
        }

        element = PallasartV2.wrapper.querySelector('.bs-widget-mobile-head');
        if (element) {
            element.classList.add('bs-toggled');
        }

        if (option) {
            let element = PallasartV2.wrapper.querySelector('#' + option);

            if (element) {
                element.scrollIntoView();
            }

            if (highlight === true) {
                PallasartV2.enableReviewReturn();
            }
        }
    },

    prevOption: function(section) {
        PallasartV2.editOption(section, false);
    },

    nextOption: function(section) {
        let parent = PallasartV2.wrapper.querySelector('#options-' + section);
        let list = parent.querySelector('.bs-list');
        // let details = parent.querySelector('.bs-details');
        // let carousel = parent.querySelector('.bs-carousel');

        if (list.classList.contains('bs-d-none')) {
            PallasartV2.editOption(section, true);
        } else {
            PallasartV2.editOption(section, -1);
        }
    },

    markAsCompleted: function(section, location_index, category_index) {
        if (!PallasartUtils.objectPropertyExists(PallasartV2.cache.completed, section)) {
            PallasartV2.cache.completed[section] = {};
        }

        if (!PallasartUtils.objectPropertyExists(PallasartV2.cache.completed[section], parseInt(location_index))) {
            PallasartV2.cache.completed[section][parseInt(location_index)] = [];
        }

        if (PallasartV2.cache.completed[section][parseInt(location_index)].indexOf(parseInt(category_index)) === -1) {
            PallasartV2.cache.completed[section][parseInt(location_index)].push(parseInt(category_index));
        }

        PallasartV2.cache.current.section = section;

        if (parseInt(location_index) >= 0) {
            PallasartV2.cache.current.location = parseInt(location_index);
        }

        if (parseInt(category_index) >= 0) {
            PallasartV2.cache.current.category = parseInt(category_index);
        }
    },

    isMarkedAsCompleted: function(section, location_index, category_index) {
        if (!PallasartUtils.objectPropertyExists(PallasartV2.cache.completed, section)) {
            return false;
        }

        if (!PallasartUtils.objectPropertyExists(PallasartV2.cache.completed[section], parseInt(location_index))) {
            return false;
        }

        if (typeof category_index !== 'undefined') {
            return PallasartV2.cache.completed[section][parseInt(location_index)].indexOf(parseInt(category_index)) !== -1;
        }

        return true;
    },

    unmarkAsCompleted: function(section, location_index, category_index) {
        if (!PallasartUtils.objectPropertyExists(PallasartV2.cache.completed, section)) {
            return false;
        }

        if (!PallasartUtils.objectPropertyExists(PallasartV2.cache.completed[section], location_index)) {
            return false;
        }

        let found = PallasartV2.cache.completed[section][location_index].indexOf(category_index);
        if (found !== -1) {
            PallasartV2.cache.completed[section][location_index].splice(category_index, 1);
        }
    },

    totalMarkedAsCompleted: function(section) {
        let total = 0;

        if (PallasartUtils.objectPropertyExists(PallasartV2.cache.completed, section)) {
            for (let location of Object.keys(PallasartV2.cache.completed[section])) {
                total += PallasartV2.cache.completed[section][location].length;
            }
        }

        return total;
    },

    totalSteps: function(section) {
        let steps = 0;

        if (section === 'exterior') {
            if (PallasartOptions.cache.assembled && PallasartUtils.objectPropertyExists(PallasartOptions.cache.assembled, 'Exterior')) {
                for (let location of Object.keys(PallasartOptions.cache.assembled['Exterior'])) {
                    // steps += Object.keys(PallasartOptions.cache.assembled['Exterior'][location]).length
                    for (let category of Object.keys(PallasartOptions.cache.assembled['Exterior'][location])) {
                        if (PallasartOptions.isCategoryVisible(PallasartOptions.cache.assembled['Exterior'][location][category])) {
                            steps++;
                        }
                    }
                }
            } else if (PallasartOptions.options && PallasartUtils.objectPropertyExists(PallasartOptions.options['map'], 'Exterior')) {
                for (let location of Object.keys(PallasartOptions.options['map']['Exterior'])) {
                    steps += Object.keys(PallasartOptions.options['map']['Exterior'][location]).length
                }
            }
        } else if (section === 'interior') {
            if (PallasartOptions.cache.assembled && PallasartUtils.objectPropertyExists(PallasartOptions.cache.assembled, 'Interior')) {
                for (let location of Object.keys(PallasartOptions.cache.assembled['Interior'])) {
                    // steps += Object.keys(PallasartOptions.cache.assembled['Interior'][location]).length
                    for (let category of Object.keys(PallasartOptions.cache.assembled['Interior'][location])) {
                        if (PallasartOptions.isCategoryVisible(PallasartOptions.cache.assembled['Interior'][location][category])) {
                            steps++;
                        }
                    }
                }
            } else if (PallasartOptions.options && PallasartUtils.objectPropertyExists(PallasartOptions.options['map'], 'Interior')) {
                for (let location of Object.keys(PallasartOptions.options['map']['Exterior'])) {
                    steps += Object.keys(PallasartOptions.options['map']['Exterior'][location]).length
                }
            }

            if (PallasartV2.styles) {
                steps += 1; //because "Choose Your Style" is hard-coded
            }
        }

        return steps;
    },

    masonry: function(selector) {
        let selected = selector.getAttribute('data-selectedid');
        let deselected = selector.getAttribute('data-deselectedid');

        if (selector.checked) {
            if (selected) {
                document.getElementById(selected).click();
            }
        } else {
            if (deselected) {
                document.getElementById(deselected).click();
            }
        }
    },

    estOptions: function(total) {
        let message = '<div class="bs-mb-3"><label for="estimate-down" class="bs-form-label bs-fs-6">DOWN PAYMENT</label><div class="bs-input-group"><span class="bs-input-group-text bs-text-orange">$</span><input type="number" class="bs-form-control" id="estimate-down" name="down" value="' + (total * 0.2) + '" step="1" min="0" max="' + total + '"></div></div><div class="bs-mb-3"><label for="estimate-rate" class="bs-form-label bs-fs-6">INTEREST RATE</label><div class="bs-input-group"><span class="bs-input-group-text bs-text-orange">%</span><input type="number" class="bs-form-control" id="estimate-rate" name="rate" value="' + PallasartV2.cache.interest + '" step="0.1" min="0.1"></div></div><div id="estimate-button" class="bs-mb-3 bs-text-center"><button type="button" class="bs-btn bs-btn-orange" onclick="PallasartV2.estOptionsSubmit(this, ' + total + ')">Calculate Monthly Payment</button></div><div id="estimate-result" class="bs-d-none"><div class="bs-mb-3 bs-text-center bs-fs-5">Est. monthly payment: <strong id="estimate-amount"></span></strong></div><div class="bs-mb-3 bs-text-center"><button type="button" class="bs-btn bs-btn-link bs-me-2" onclick="PallasartV2.estOptionsReset()">Reset</button><button type="button" class="bs-btn bs-btn-orange bs-ms-2" data-bs-dismiss="bs-modal">Done</button></div></div>';

        if (('estimated' in PallasartV2.messages) && PallasartV2.messages.estimated) {
            message += PallasartV2.messages.estimated.content;
        }

        PallasartUtils.createModal(message, '', false, false, 'bs-popup-light bs-popup-estimate');
    },

    estOptionsSubmit: function(button, total) {
        let down = document.getElementById('estimate-down');
        let interest = document.getElementById('estimate-rate');
        let value = Number(down.value);
        let interest_amount = Number(interest.value);

        if ((value < 0) || (value > total)) {
            down.focus();
        } else if ((interest_amount < 0.1) || (interest_amount > 100)) {
            interest.focus();
        } else if (PallasartV2.cache.plan) {
            button.append(PallasartUtils.createSpinner(true));

            let rate = interest_amount / 100 / 12;
            let loan = total - value;
            let payment = Math.round(loan * ((rate * Math.pow(1 + rate, 360)) / (Math.pow(1 + rate, 360) - 1)));

            PallasartUtils.destroySpinner(button);

            document.getElementById('estimate-button').classList.add('bs-d-none');
            document.getElementById('estimate-result').classList.remove('bs-d-none');

            if (payment > 0) {
                PallasartV2.cache.rate = payment;
                PallasartV2.cache.interest = interest_amount;
                PallasartV2.cache.loan = value;
                document.getElementById('estimate-amount').innerText = '$' + PallasartUtils.formatPrice(payment);

                let est = PallasartV2.wrapper.querySelector('#kova-amount-est');
                est.innerText = '$' + PallasartUtils.formatPrice(payment);

                let root = PallasartUtils.getRoot();
                let estimates = root.querySelectorAll('.est-monthly-payment');
                if (estimates) {
                    for (const estimate of estimates) {
                        estimate.innerText = '$' + PallasartUtils.formatPrice(payment);
                    }
                }
            } else {
                document.getElementById('estimate-amount').innerText = 'unknown';
            }

            // PallasartV2.zillowRate(
            //     PallasartV2.cache.plan.zip,
            //     total,
            //     total - value,
            //     function(rate, interest) {
            //         PallasartUtils.destroySpinner(button);
            //
            //         document.getElementById('estimate-button').classList.add('bs-d-none');
            //         document.getElementById('estimate-result').classList.remove('bs-d-none');
            //
            //         if (rate > 0) {
            //             PallasartV2.cache.rate = rate;
            //
            //             if (PallasartV2.cache.interest == 0) {
            //                 PallasartV2.cache.interest = interest;
            //             }
            //
            //             PallasartV2.cache.loan = value;
            //             document.getElementById('estimate-amount').innerText = '$' + PallasartUtils.formatPrice(rate);
            //
            //             let est = PallasartV2.wrapper.querySelector('#kova-amount-est');
            //             est.innerText = '$' + PallasartUtils.formatPrice(rate);
            //
            //             let root = PallasartUtils.getRoot();
            //             let estimates = root.querySelectorAll('.est-monthly-payment');
            //             if (estimates) {
            //                 for (const estimate of estimates) {
            //                     estimate.innerText = '$' + PallasartUtils.formatPrice(rate);
            //                 }
            //             }
            //         } else {
            //             document.getElementById('estimate-amount').innerText = 'unknown';
            //         }
            //     }
            // );
        }
    },

    estOptionsReset: function() {
        document.getElementById('estimate-button').classList.remove('bs-d-none');
        document.getElementById('estimate-result').classList.add('bs-d-none');
    },

    extraOptions: function(total, options, extras) {
        let message = '<div class="bs-first"><strong>Base Price</strong><em>+&nbsp;$' + PallasartUtils.formatPrice(total - options) + '</em></div>';
        let i = 0;

        for (const section in extras) {
            if (section === 'Exterior') {
                message += '<div class="bs-group"><strong>Exterior</strong><a role="button" data-bs-toggle="bs-collapse" href="#collapse-short-' + i + '" class="bs-down" onclick="PallasartUtils.toggleClass(this, [\'bs-down\', \'bs-up\'])">&nbsp;</a></div>';
                message += '<div class="bs-collapse" id="collapse-short-' + i + '">';
                i++;
            }

            for (const location in extras[section]) {
                for (const category in extras[section][location]) {
                    if (section !== 'Exterior') {
                        message += '<div class="bs-group"><strong>' + category + '</strong><a role="button" data-bs-toggle="bs-collapse" href="#collapse-short-' + i + '" class="bs-down" onclick="PallasartUtils.toggleClass(this, [\'bs-down\', \'bs-up\'])">&nbsp;</a></div>';
                        message += '<div class="bs-collapse" id="collapse-short-' + i + '">';
                        i++;
                    }

                    for (const choice of extras[section][location][category]) {
                        message += '<div class="bs-extra"><strong>' + choice['text'] + '</strong><em>+&nbsp;$' + PallasartUtils.formatPrice(choice['price']) + '</em></div>';
                    }

                    if (section !== 'Exterior') {
                        message += '</div>';
                    }
                }
            }

            if (section === 'Exterior') {
                message += '</div>';
            }
        }

        message += '<div class="bs-last"><strong>TOTAL</strong><em>$' + PallasartUtils.formatPrice(total) + '</em></div>';

        PallasartUtils.createModal('<div class="bs-widget-extras">' + message + '</div>', 'Options Price Summary', false, false, 'bs-popup bs-popup-extra');
    },

    zillowRate: function(zip, value, loan, oncomplete) {
        if (PallasartV2.working || !zip) {
            return false;
        }

        PallasartV2.working = true;

        const url = new URL('https://mortgageapi.zillow.com/getCurrentRates'),
            query = {
                partnerId: 'RD-NTGCRFG',
                'queries.1.propertyBucket.location.zipCode': zip,
                'queries.1.propertyBucket.propertyValue': parseInt(value),
                'queries.1.propertyBucket.loanAmount': parseInt(loan)
            };

        Object.keys(query).forEach(key => url.searchParams.append(key, query[key]));

        fetch(
            url,
            {
                method: 'get',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        ).then((response) => {
            PallasartV2.working = false;

            if (response.ok) {
                return response.json();
            }

            return Promise.reject(response);
        }).then((response) => {
            if (PallasartUtils.objectPropertyExists(response, 'rates')) {
                let rate = response['rates']['1']['rate'] / 100 / 12;
                let payment = 0;

                if (rate) {
                    payment = Math.round(loan * ((rate * Math.pow(1 + rate, 360)) / (Math.pow(1 + rate, 360) - 1)));
                }

                if ((typeof oncomplete != 'undefined') && (oncomplete != null)) {
                    oncomplete(payment, response['rates']['1']['rate']);
                }
            }
        }).catch((reason) => {
            // console.log(reason);
        });
    },

    totals: function() {
        if (!PallasartV2.kova) {
            return false;
        }

        let total = PallasartUtils.parseNumeric(PallasartV2.totalPrice(PallasartV2.kova.Plan.Prices.TotalPrice.Value));
        let rate = PallasartV2.cache.rate;
        let loan = PallasartV2.cache.loan;
        let options = PallasartOptions.extraTotal();
        let earnest = Math.round(total * 0.02) + Math.round(options * 0.1);
        let down = Math.round(total * 0.2) - earnest;

        return {
            total: total,
            rate: rate,
            loan: loan,
            options: options,
            earnest: earnest,
            down: down
        }
    },

    saveModal: function() {
        if (PallasartV2.cache.remember_save) {
            if (PallasartV2.cache.save === 'home') {
                PallasartV2.saveHome(false);
            } else {
                PallasartV2.saveProgress(false);
            }
        } else if (('save' in PallasartV2.messages) && PallasartV2.messages.save) {
            let root = PallasartUtils.getRoot();
            let existing = root.querySelector('#saveModal');

            if (!existing) {
                root.insertAdjacentHTML('beforeend', PallasartV2.messages.save);
            }

            PallasartUtils.showModal('#saveModal');
        }
    },

    rememberSave: function(element) {
        PallasartV2.cache.remember_save = element.checked;
    },

    saveProgress: function(button) {
        PallasartV2.saveHome(button, true);
    },

    chooseStyles: function() {
        if (PallasartV2.styles) {
            let styles = PallasartOptions.styles();

            if (styles) {
                let template = _.template(
                    document.getElementById('kova-styles-template').innerHTML
                );
                let message = (('styles' in PallasartV2.messages) && PallasartV2.messages.styles) ? PallasartV2.messages.styles : false;

                PallasartV2.styles.innerHTML = template({
                    content: message ? message.content : false,
                    button_1: message ? message.button_1 : false,
                    button_2: message ? message.button_2 : false,
                    styles: styles
                });
                PallasartV2.styles.classList.remove('bs-d-none');
            }
        }
    },

    selectStyle: function(style, selector) {
        PallasartUtils.hideTooltips('.tooltip-trigger');
        PallasartV2.cache.style = style;

        if (PallasartV2.styles) {
            PallasartV2.styles.classList.add('bs-d-none');
        }

        let checkbox = false;

        if ((typeof selector !== 'undefined') && (selector !== false)) {
            let parent = selector.closest('.bs-parent');
            if (parent) {
                checkbox = parent.querySelector('input[type="checkbox"]');
            }
        }

        if (checkbox) {
            checkbox.checked = true;
            checkbox.setAttribute('checked', 'checked');

            PallasartUtils.toggleLoading();
            PallasartV2.cache.current.option = checkbox.getAttribute('data-optionid');
            let selected = PallasartOptions.getSelectedStyle();

            if (checkbox.hasAttribute('data-optionid') && selected && (selected['ID'] !== style)) {
                PallasartV2.kova.choiceOnChange(checkbox, checkbox, function () {
                    PallasartUtils.toggleLoading(false);
                    PallasartV2.gotoOption(PallasartV2.cache.current.section, PallasartV2.cache.current.location, PallasartV2.cache.current.category, false);
                    PallasartV2.editOption(PallasartV2.cache.current.section, true);
                    PallasartUtils.clearChildren(document, '.tooltip-triggered');
                });
            } else {
                PallasartV2.kova.postStateChange(PallasartV2.kova.selectedFloorIndex, function () {
                    PallasartUtils.toggleLoading(false);
                    PallasartV2.gotoOption(PallasartV2.cache.current.section, PallasartV2.cache.current.location, PallasartV2.cache.current.category, false);
                    PallasartV2.editOption(PallasartV2.cache.current.section, true);
                    PallasartUtils.clearChildren(document, '.tooltip-triggered');
                });
            }
        }
    },

    viewStyle: function(id) {
        if (PallasartV2.styles) {
            PallasartUtils.hideTooltips('.tooltip-trigger');
            let style = PallasartOptions.getStyle(id);

            if (style) {
                let template = _.template(
                    document.getElementById('kova-style-template').innerHTML
                );
                let message = (('style' in PallasartV2.messages) && PallasartV2.messages.style) ? PallasartV2.messages.style : false;

                PallasartV2.styles.innerHTML = template({
                    button_1: message ? message.button_1 : false,
                    button_2: message ? message.button_2 : false,
                    style: style
                });
            }
        }
    },

    resizeStyles: function() {
        if ((PallasartV2.cache.current.section === 'interior') && (PallasartV2.cache.current.location === 0) && PallasartV2.styles) {
            if (PallasartUtils.isMobileView()) {
                PallasartV2.styles.classList.add('bs-d-none');
                PallasartV2.editOption('interior', 0);
            } else {
                if (PallasartV2.styles.innerText === '') {
                    PallasartV2.chooseStyles();
                }

                PallasartV2.styles.classList.remove('bs-d-none');
                PallasartV2.showSection('interior', true, true);
            }
        }
    },

    review: function() {
        PallasartV2.retryConfiguratorOptions();
        PallasartV2.showReview();

        let template = _.template(
            document.getElementById('kova-review-template').innerHTML
        );

        let root = PallasartUtils.getRoot();
        let review = root.querySelector('#kova-review');

        let title = '';
        let content = '';
        let deposit_due = '';
        let note = '';
        let button_1 = '';
        let button_2 = '';
        let button_3 = '';
        let hint = '';

        let deposit = 0;

        if (PallasartV2.slsord) {
            deposit = (PallasartUtils.parseNumeric(PallasartV2.totalPrice(PallasartV2.kova.Plan.Prices.TotalPrice.Value))) * 0.02;
        } else {
            let extrasTotal = PallasartOptions.extraTotal();
            deposit = (PallasartUtils.parseNumeric(PallasartV2.kova.Plan.Prices.BasePrice.Value) + (PallasartV2.cache.lot ? PallasartV2.cache.lot.LotPremium : 0)) * 0.02 + (extrasTotal * 0.1);
        }

        if (('review_selections' in PallasartV2.messages) && PallasartV2.messages.review_selections) {
            title = PallasartV2.messages.review_selections.title;
            content = PallasartV2.messages.review_selections.content;
            deposit_due = PallasartV2.messages.review_selections.subtitle ? PallasartV2.messages.review_selections.subtitle.replaceAll('DUE_AMOUNT', PallasartUtils.formatPrice(deposit)) : '';
            note = PallasartV2.messages.review_selections.note;
            button_1 = PallasartV2.messages.review_selections.button_1;
            button_2 = PallasartV2.messages.review_selections.button_2;
            button_3 = PallasartV2.messages.review_selections.button_3;
        }

        if (('deposit_amount' in PallasartV2.messages) && PallasartV2.messages.deposit_amount) {
            hint = PallasartV2.messages.deposit_amount.content;
        }

        let styles = PallasartOptions.styles();

        review.innerHTML = template({
            title: title,
            content: content,
            deposit_due: deposit_due,
            note: note,
            button_1: button_1,
            button_2: button_2,
            button_3: button_3,
            options: PallasartOptions.extra(true),
            lot: PallasartV2.cache.lot,
            total: PallasartUtils.parseNumeric(PallasartV2.totalPrice(PallasartV2.kova.Plan.Prices.TotalPrice.Value)) + (PallasartV2.cache.lot && !PallasartV2.cache.slsord ? PallasartV2.cache.lot.LotPremium : 0),
            category_increment: (styles === false ? 0 : 1),
            hint: hint
        });

        if (hint) {
            PallasartUtils.showTooltips('#kova-review', '.tooltip-trigger');
        }
    },

    complete: function() {
        PallasartV2.showComplete();

        let template = _.template(
            document.getElementById('kova-complete-template').innerHTML
        );

        let root = PallasartUtils.getRoot();
        let complete = root.querySelector('#kova-complete');

        let title = '';
        let content = '';
        let note = '';
        let subtitle = '';
        let button_1 = '';
        let button_2 = '';

        if (('buy' in PallasartV2.messages) && PallasartV2.messages.complete) {
            title = PallasartV2.messages.complete.title;
            content = PallasartV2.messages.complete.content;
            note = PallasartV2.messages.complete.note;
            subtitle = PallasartV2.messages.complete.subtitle;
            button_1 = PallasartV2.messages.complete.button_1;
            button_2 = PallasartV2.messages.complete.button_2;
        }

        complete.innerHTML = template({
            title: title,
            content: content,
            note: note,
            subtitle: subtitle,
            button_1: button_1,
            button_2: button_2,
        });

        let video = complete.querySelector('video');
        if (video) {
            let wrap = complete.querySelector('.bs-wrap-inside');
            video.addEventListener('ended', function() {
                video.remove();
                wrap.classList.add('bs-video-ended');
            });

            video.play();
        }
    },

    walkthrough: function() {
        PallasartV2.hideReview();

        let root = PallasartUtils.getRoot();
        let stage = root.querySelector('#kova-stage');
        if (stage) {
            stage.classList.remove('bs-contracted');
            stage.classList.remove('bs-stage-exterior');
            stage.classList.remove('bs-stage-interior');
            stage.classList.remove('bs-stage-review');

            let wrapper = stage.querySelector('.bs-widget-wrapper');
            if (wrapper) {
                let columns = wrapper.querySelector('.bs-widget-columns');
                if (columns) {
                    columns.classList.add('bs-options-highlight');

                    let first = wrapper.querySelector('.bs-column-first');
                    if (first) {
                        let configurator = stage.querySelector('#kova-configurator');
                        if (configurator) {
                            configurator.classList.add('bs-d-none');
                        }

                        let rooms = first.querySelector('#kova-rooms');
                        if (!rooms) {
                            rooms = document.createElement('div');
                            rooms.setAttribute('id', 'kova-rooms');
                            rooms.classList.add('bs-widget-rooms');
                            first.append(rooms);
                        } else {
                            rooms.innerHTML = '';
                        }

                        let template = _.template(
                            document.getElementById('kova-walkthrough-template').innerHTML
                        );

                        let title = '';
                        let button_1 = '';
                        let button_2 = '';

                        if (('get_started' in PallasartV2.messages) && PallasartV2.messages.walkthrough) {
                            title = PallasartV2.messages.walkthrough.title;
                            button_1 = PallasartV2.messages.walkthrough.button_1;
                            button_2 = PallasartV2.messages.walkthrough.button_2;
                        }

                        rooms.innerHTML = template({
                            locations: PallasartOptions.locations(),
                            title: title,
                            button_1: button_1,
                            button_2: button_2,
                        });

                        let btn = rooms.querySelector('.parent .bs-btn');
                        if (btn) {
                            btn.click();
                        }

                        let scrolls =  rooms.querySelectorAll('.bs-simplebar');
                        for (const scroll of scrolls) {
                            new SimpleBar(scroll, {
                                autoHide: false,
                            });
                        }
                    }
                }
            }
        }
    },

    walkthroughScene: function(selector, scene) {
        // let parent = selector.closest('.parent');
        // let children = parent.querySelectorAll('.bs-fw-bold');
        //
        // if (children) {
        //     for (const child of children) {
        //         child.classList.remove('bs-fw-bold');
        //     }
        // }
        //
        // selector.classList.add('bs-fw-bold');
        PallasartParadigm.scene(scene);

        // PallasartUtils.createBanner('Current Location: ' + (scene.toLowerCase().substring(0, 8) === 'primary ' ? (scene.substring(8) + ' 1') : scene), true);
        PallasartUtils.createBanner('Current Location: ' + selector, true);
    },

    deleteOption: function(optionId, choiceId, group_index) {
        let selector = '';

        if (optionId === choiceId) {
            selector = "input[data-optionid='" + optionId.replaceAll("'", "\\'") + "']";
        } else {
            selector = "input[data-optionid='" + optionId.replaceAll("'", "\\'") + "'][data-choiceid='" + choiceId.replaceAll("'", "\\'") + "']";
        }

        let root = PallasartUtils.getRoot();
        let input = root.querySelector(selector);

        if (input) {
            if (('remove_option' in PallasartV2.messages) && PallasartV2.messages.remove_option) {
                let paragraph = document.createElement('p'),
                    cancel = document.createElement('button'),
                    agree = document.createElement('button');

                paragraph.classList.add('bs-text-center');
                paragraph.classList.add('bs-mt-3');
                paragraph.classList.add('bs-mb-0');

                cancel.classList.add('bs-btn');
                cancel.classList.add('bs-btn-link');
                cancel.classList.add('bs-btn-modal');
                cancel.classList.add('bs-mx-3');
                cancel.setAttribute('type', 'button');
                cancel.setAttribute('aria-label', 'Close');
                cancel.setAttribute('data-bs-dismiss', 'bs-modal');
                cancel.innerText = PallasartV2.messages.remove_option.button_2.length ? PallasartV2.messages.remove_option.button_2 : 'Cancel';
                paragraph.append(cancel);

                agree.classList.add('bs-btn');
                agree.classList.add('bs-btn-orange');
                cancel.classList.add('bs-mx-3');
                agree.setAttribute('type', 'button');
                agree.innerText = PallasartV2.messages.remove_option.button_1.length ? PallasartV2.messages.remove_option.button_1 : 'Yes, Delete';
                agree.addEventListener('click', function(e) {
                    e.preventDefault();
                    e.stopPropagation();

                    PallasartUtils.destroyModal();
                    PallasartUtils.toggleLoading(true);

                    PallasartV2.kova.unsetOption(input, function () {
                        PallasartUtils.toggleLoading(false);
                        PallasartV2.showSection('review', true, true);
                        PallasartV2.review();

                        let collapsible = root.querySelector('#collapse-' + group_index);
                        if (collapsible) {
                            Collapse.getOrCreateInstance(collapsible).show();
                        }
                    }, function() {
                        PallasartUtils.toggleLoading(false);
                        PallasartV2.showSection('review', true, true);
                        PallasartV2.review();

                        let collapsible = root.querySelector('#collapse-' + group_index);
                        if (collapsible) {
                            Collapse.getOrCreateInstance(collapsible).show();
                        }
                    });
                });
                paragraph.append(agree);

                let content = document.createElement('div');
                content.innerHTML = PallasartV2.messages.remove_option.content;
                content.append(paragraph);

                PallasartUtils.createModal(
                    content,
                    '',
                    false,
                    false,
                    'bs-popup-light bs-popup-header-margin',
                    'bs-modal-dialog'
                );
            }
        }
    },

    enableReviewReturn: function() {
        PallasartV2.cache.highlight_option = true;

        let root = PallasartUtils.getRoot();
        let stage = root.querySelector('#kova-stage');

        if (stage) {
            stage.classList.remove('bs-contracted');

            let wrapper = stage.querySelector('.bs-widget-wrapper');

            if (wrapper) {
                let columns = wrapper.querySelector('.bs-widget-columns');

                if (columns) {
                    columns.classList.add('bs-options-highlight');
                }

                let last = wrapper.querySelector('.bs-column-last');
                if (last) {
                    let back = document.createElement('a');
                    back.classList.add('bs-widget-review-return');
                    back.innerText = 'Done with changes? Back to Review Selections';
                    back.addEventListener('click', function() {
                        PallasartV2.backToReview();
                        PallasartV2.showSection('review', false, true)
                        PallasartV2.review();
                        back.remove();
                    });
                    last.append(back);
                }
            }
        }
    },

    backToReview: function() {
        PallasartUtils.destroyBanner();

        let root = PallasartUtils.getRoot();
        let stage = root.querySelector('#kova-stage');

        if (stage) {
            stage.classList.add('bs-stage-review');
            let wrapper = stage.querySelector('.bs-widget-wrapper');
            if (wrapper) {
                let columns = wrapper.querySelector('.bs-widget-columns');

                if (columns) {
                    columns.classList.remove('bs-options-highlight');
                }

                let first = wrapper.querySelector('.bs-column-first');
                if (first) {
                    let configurator = stage.querySelector('#kova-configurator');
                    if (configurator) {
                        configurator.classList.remove('bs-d-none');
                    }

                    let rooms = first.querySelector('#kova-rooms');
                    if (rooms) {
                        rooms.remove();
                    }
                }
            }
        }
    },

    flyer: async function() {
        if (PallasartV2.cache.customer === false) {
            PallasartV2.customerPopup(PallasartUrl.register + '?quote=1');
            return false;
        }

        PallasartUtils.toggleLoading();

        const result = await fetch(
            PallasartUrl.customer_info,
            {
                method: 'get',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }
        );

        const response = await result.json();
        PallasartUtils.toggleLoading(false);

        if (response.hasOwnProperty('account') && response.account) {
            let lead = {},
                fields = [],
                interestedField = {},
                formField = {},
                communityField = {};

            lead['NameFirst'] = response.account.fname;
            lead['NameLast'] = response.account.lname;
            lead['EmailHome'] = response.account.email;
            lead['PhoneHome'] = response.account.phone;
            lead['PrefContactType'] = 'Email';

            interestedField['ID'] = 'Text_LeadRating';
            interestedField['Value'] = response.account.interested;
            fields.push(interestedField);

            formField['ID'] = 'Text_WebForm';
            formField['Value'] = 'Form - Design your home';
            fields.push(formField);

            communityField['ID'] = 'Int_CommunityRID';
            communityField['Value'] = PallasartV2.kova.communityrid;
            fields.push(communityField);

            lead['CustomFields'] = fields;

            if (PallasartV2.kova.lotrid) {
                lead['LotRID'] = PallasartV2.kova.lotrid;
            }

            PallasartUtils.toggleLoading(true);

            PallasartV2.kova.saveLead(lead, async function (result) {
                if(result && result.Url && (result.Url !== null)) {
                    let data = new FormData();
                    data.append('quote[version]', '2');
                    data.append('quote[fname]', lead['NameFirst']);
                    data.append('quote[lname]', lead['NameLast']);
                    data.append('quote[email]', lead['EmailHome']);
                    data.append('quote[phone]', lead['PhoneHome']);
                    data.append('quote[interested]', interestedField['Value']);
                    data.append('quote[communityrid]', PallasartV2.kova.communityrid);
                    data.append('quote[modelrid]', PallasartV2.kova.modelrid);
                    data.append('quote[lotrid]', PallasartV2.kova.lotrid);
                    data.append('quote[slsordrid]', PallasartV2.kova.slsordrid);
                    data.append('quote[url]', result.Url);
                    data.append('quote[leadrid]', result.Lead.LeadRID);
                    data.append('quote[options]', window.btoa(unescape(encodeURIComponent(JSON.stringify(PallasartV2.kova.getDefaultRequestParams(true))))));
                    let params = new URLSearchParams(data);

                    fetch(
                        PallasartUrl.flyer,
                        {
                            method: 'post',
                            headers: {
                                'Accept': 'application/json, text/plain, */*',
                                'Content-Type': 'application/x-www-form-urlencoded',
                                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                            },
                            body: params
                        }
                    ).then((response) => {
                        PallasartUtils.toggleLoading(false);

                        if (response.ok) {
                            return response.json();
                        }

                        return Promise.reject(response);
                    }).then((response) => {
                        if (response.hasOwnProperty('error')) {
                            PallasartUtils.createModal(
                                response.error,
                                '',
                                false,
                                false,
                                'bs-popup-light bs-popup-header-margin',
                                'bs-modal-dialog'
                            );
                        }

                        if (response.hasOwnProperty('success')) {
                            if (('flyer' in PallasartV2.messages) && PallasartV2.messages.flyer) {
                                Pallasart.pseudoConfirmation('instant-quote-thank-you');
                                PallasartV2.complete();

                                PallasartUtils.createModal(
                                    PallasartV2.messages.flyer.content,
                                    '',
                                    false,
                                    false,
                                    'bs-popup-light bs-popup-header-margin',
                                    'bs-modal-dialog'
                                );
                            }
                        }
                    }).catch((reason) => {
                        // console.log(reason);
                    });
                } else {
                    PallasartUtils.toggleLoading(false);
                    PallasartUtils.createModal(
                        'Cannot generate flyer!',
                        '',
                        false,
                        false,
                        'bs-popup-light bs-popup-header-margin',
                        'bs-modal-dialog'
                    );
                }
            });
        } else {
            PallasartV2.customerPopup(PallasartUrl.login + '?quote=1');
        }
    },

    saveHome: function(button, progress, caption, reserved) {
        PallasartUtils.hideTooltips('.tooltip-trigger');
        PallasartUtils.destroyBanner();
        if (PallasartV2.cache.remember_save) {
            PallasartV2.cache.save = (progress ? 'progress' : 'home');
        }

        if ((PallasartV2.cache.customer === false) && (PallasartV2.cache.impersonate === false)) {
            PallasartV2.customerPopup(PallasartUrl.customer_login + '?save_' + (progress ? 'progress' : 'home') + '=1');
            return false;
        }

        if (button) {
            if (button.classList.contains('submitting')) {
                return false;
            }

            button.setAttribute('data-title', button.innerText);
            button.innerText = 'Saving...';
            button.classList.add('submitting');
        } else if (reserved !== true) {
            PallasartUtils.toggleLoading();
        }

        let data = new FormData();

        if (PallasartV2.cache.home) {
            data.append('home[original_id]', PallasartV2.cache.home);
        }

        if (PallasartV2.cache.home && progress) {
            data.append('home[id]', PallasartV2.cache.home);
        }

        if ((typeof caption !== 'undefined') && (caption !== false) && !progress) {
            data.append('home[caption]', caption);
        }

        data.append('home[community_id]', PallasartV2.community);
        data.append('home[model_id]', PallasartV2.model);
        data.append('home[lot_id]', PallasartV2.lot);
        data.append('home[slsord_id]', PallasartV2.slsord);
        data.append('home[communityrid]', PallasartV2.kova.communityrid);
        data.append('home[modelrid]', PallasartV2.kova.modelrid);
        data.append('home[lotrid]', PallasartV2.kova.lotrid);
        data.append('home[slsordrid]', PallasartV2.kova.slsordrid);
        data.append('home[model_name]', PallasartV2.kova.Plan.Name);
        data.append('home[options]', window.btoa(unescape(encodeURIComponent(JSON.stringify(PallasartV2.kova.getDefaultRequestParams(true))))));
        data.append('home[url]', PallasartUtils.currentUrl());

        if (PallasartV2.cache.plan !== false) {
            data.append('home[community_name]', PallasartV2.cache.plan.community);
            data.append('home[city]', PallasartV2.cache.plan.city.length ? PallasartV2.cache.plan.city : PallasartOptions.getLocationCity());
            data.append('home[state]', PallasartV2.cache.plan.state);
            data.append('home[zip]', PallasartV2.cache.plan.zip);
            data.append('home[bedrooms]', PallasartV2.cache.plan.bedrooms);
            data.append('home[bathrooms]', PallasartV2.cache.plan.bathrooms);
            data.append('home[sqf]', PallasartV2.cache.plan.sqf.replace(',', ''));
            data.append('home[picture]', PallasartV2.cache.plan.picture);
        }

        if (PallasartV2.cache.lot !== false) {
            data.append('home[lot_name]', PallasartUtils.lotName(PallasartV2.cache.lot['Name']));
        }

        data.append('home[completed]', JSON.stringify(PallasartV2.cache.completed));
        data.append('home[quantities]', JSON.stringify(PallasartOptions.cache.quantities));

        let total = PallasartUtils.parseNumeric(PallasartV2.totalPrice(PallasartV2.kova.Plan.Prices.TotalPrice.Value));
        let options = PallasartOptions.extraTotal();
        let premium = (PallasartV2.cache.lot && !PallasartV2.cache.slsord ? PallasartV2.cache.lot.LotPremium : 0);

        data.append('home[base_price]', total - options);
        data.append('home[options_amount]', options);
        data.append('home[lot_premium]', premium);

        if (reserved === true) {
            data.append('home[reserved]', 1);
        }

        let params = new URLSearchParams(data);

        fetch(
            PallasartUrl.save_home + '?save_' + (progress ? 'progress' : 'home') + '=1' + (PallasartV2.cache.impersonate ? ('&impersonate=' + PallasartV2.cache.impersonate) : ''),
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                },
                body: params
            }
        ).then((response) => {
            if (button) {
                button.innerText = button.getAttribute('data-title');
                button.classList.remove('submitting');
            } else if (reserved !== true) {
                PallasartUtils.toggleLoading(false);
            }

            if (response.ok) {
                return response.json();
            }

            return Promise.reject(response);
        }).then((response) => {
            if (reserved !== true) {
                if (PallasartUtils.objectPropertyExists(response, 'error')) {
                    PallasartUtils.createModal(response.error);
                } else if (PallasartUtils.objectPropertyExists(response, 'html')) {
                    PallasartUtils.createModal(response.html, true, false, false, 'bs-popup-light bs-popup-save');
                } else if (PallasartUtils.objectPropertyExists(response, 'success')) {
                    if (PallasartUtils.objectPropertyExists(response, 'home')) {
                        PallasartV2.cache.home = response.home;
                    }

                    PallasartUtils.createModal(
                        response.success,
                        true,
                        PallasartUtils.objectPropertyExists(response, 'reload'),
                        PallasartUtils.objectPropertyExists(response, 'cleanload'),
                        'bs-popup-light bs-popup-save'
                    );
                } else if (PallasartUtils.objectPropertyExists(response, 'reload')) {
                    window.location.reload();
                } else if (PallasartUtils.objectPropertyExists(response, 'cleanload')) {
                    window.location.href = PallasartUtils.currentUrl();
                }
            }
        }).catch((reason) => {
            // console.log(reason);
        });
    },

    submitSaveHome: function(selector) {
        PallasartV2.saveHome(false, false, document.getElementById('save-caption').value.trim());
        return false;
    },

    renameHome: function(button, url) {
        let input = button.parentNode.querySelector('[contenteditable]');

        if (input) {
            if (input.innerText.trim() === input.getAttribute('data-original')) {
                input.focus();
                return false;
            }

            if (button.classList.contains('submitting')) {
                return false;
            }

            button.classList.add('submitting');
            PallasartUtils.toggleLoading();

            let data = new FormData();
            data.append('home[caption]', input.innerText.trim());
            let params = new URLSearchParams(data);

            fetch(
                url,
                {
                    method: 'post',
                    headers: {
                        'Accept': 'application/json, text/plain, */*',
                        'Content-Type': 'application/x-www-form-urlencoded',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                    },
                    body: params
                }
            ).then((response) => {
                button.classList.remove('submitting');
                PallasartUtils.toggleLoading(false);

                if (response.ok) {
                    return response.json();
                }

                return Promise.reject(response);
            }).then((response) => {
                if (PallasartUtils.objectPropertyExists(response, 'error')) {
                    PallasartV2.createModal(response.error, false);
                }

                if (PallasartUtils.objectPropertyExists(response, 'success')) {
                    input.setAttribute('data-original', input.innerText.trim());
                }
            }).catch((reason) => {
                // console.log(reason);
            });
        }
    },

    deleteHome: function(button, url) {
        if (button.classList.contains('submitting')) {
            return false;
        }

        button.classList.add('submitting');
        PallasartUtils.toggleLoading();

        fetch(
            url,
            {
                method: 'post',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/x-www-form-urlencoded',
                    'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').getAttribute('content')
                }
            }
        ).then((response) => {
            button.classList.remove('submitting');
            PallasartUtils.toggleLoading(false);

            if (response.ok) {
                return response.json();
            }

            return Promise.reject(response);
        }).then((response) => {
            if (PallasartUtils.objectPropertyExists(response, 'error')) {
                PallasartV2.createModal(response.error, false);
            }

            if (PallasartUtils.objectPropertyExists(response, 'success')) {
                PallasartV2.cache.home = false;
                let parent = button.closest('.bs-home');
                let parentWrap = button.closest('.bs-homes');

                if (parent) {
                    parent.remove();
                }

                if (!parentWrap.children.length) {
                    let note = document.createElement('p');
                    note.innerText = 'You have no saved homes.';

                    parentWrap.parentElement.append(note);
                    parentWrap.remove();
                }
            }
        }).catch((reason) => {
            // console.log(reason);
        });
    },

    loadHome: function(url, stopPropagation) {
        fetch(
            url + ((url.indexOf('?') === -1) ? '?' : '&') + 'url=' + encodeURIComponent(PallasartUtils.currentUrl()),
            {
                method: 'get',
                headers: {
                    'Accept': 'application/json, text/plain, */*',
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        ).then((response) => {
            if (response.ok) {
                return response.json();
            }

            return Promise.reject(response);
        }).then((response) => {
            if (PallasartUtils.objectPropertyExists(response, 'home')) {
                if ((response.home.url !== PallasartUtils.currentUrl()) && (stopPropagation !== true)) {
                    window.location.assign(response.home.url + (response.home.url.includes('?') ? '&' : '?') + (PallasartUtils.objectPropertyExists(response, 'impersonate') ? 'impersonate=' + response.impersonate + '&' : '') +'load_home=' + response.home.id);
                } else {
                    if (!PallasartV2.kova) {
                        PallasartUtils.destroyModal();
                        PallasartV2.prepareStage();
                        PallasartV2.init(
                            {
                                communityRID: response.home.community_rid,
                                modelRID: response.home.model_rid,
                                lotRID: response.home.lot_rid,
                                salesOrderRID: response.home.salesorder_rid,
                            },
                            false,
                            function() {
                                PallasartV2.displayHome(
                                    response.home,
                                    PallasartUtils.objectPropertyExists(response, 'impersonate') ? response.impersonate : false
                                );
                            }
                        );
                    } else {
                        PallasartV2.displayHome(
                            response.home,
                            PallasartUtils.objectPropertyExists(response, 'impersonate') ? response.impersonate : false
                        );
                    }
                }
            }

            if (PallasartUtils.objectPropertyExists(response, 'error')) {
                PallasartUtils.createModal(response.error);
            } else if (PallasartUtils.objectPropertyExists(response, 'success')) {
                PallasartUtils.createModal(
                    response.success,
                    false,
                    PallasartUtils.objectPropertyExists(response, 'reload'),
                    PallasartUtils.objectPropertyExists(response, 'cleanload')
                );
            } else if (PallasartUtils.objectPropertyExists(response, 'reload')) {
                window.location.reload();
            } else if (PallasartUtils.objectPropertyExists(response, 'cleanload')) {
                window.location.href = PallasartUtils.currentUrl();
            }
        }).catch((reason) => {
            // console.log(reason);
        });

        return false;
    },

    displayHome: function(home, impersonate) {
        PallasartUtils.destroyModal();
        PallasartV2.resetCache();
        PallasartV2.cache.home = home.id;
        PallasartV2.cache.popups.push('get_started');
        PallasartV2.cache.popups.push('choose_style');

        if (home.completed) {
            PallasartV2.cache.completed = JSON.parse(home.completed);
        }

        if (home.quantities) {
            PallasartOptions.cache.quantitiesCopy = JSON.parse(home.quantities);
        }

        if (impersonate !== false) {
            PallasartV2.cache.impersonate = impersonate;
        }

        PallasartV2.init(
            {
                communityRID: (home.community_rid ? home.community_rid : 0),
                modelRID: (home.model_rid ? home.model_rid : 0),
                lotRID: (home.lot_rid ? home.lot_rid : 0),
                salesOrderRID: (home.salesorder_rid ? home.salesorder_rid : 0),
                communityID: (home.community_id ? home.community_id : 0),
                modelID: (home.model_id ? home.model_id : 0),
                lotID: (home.lot_id ? home.lot_id : 0),
                salesOrderID: (home.salesorder_id ? home.salesorder_id : 0)
            },
            (home.options ? home.options : false),
            true
        );
    },

    disableBack: function() {
        if (window.history && window.history.pushState) {
            PallasartV2.disable_back = true;
            window.history.pushState({}, document.title, PallasartUtils.currentPath() + '#visualizer');
            window.addEventListener('popstate', function(e) {
                if (PallasartV2.disable_back) {
                    e.preventDefault();
                    e.stopPropagation();

                    if (('go_back' in PallasartV2.messages) && PallasartV2.messages.go_back) {
                        let root = PallasartUtils.getRoot();
                        root.insertAdjacentHTML('beforeend', PallasartV2.messages.go_back);

                        PallasartUtils.showModal('#backModal');
                    }

                    return false;
                }
            });
        }
    },

    disclosure: function(state) {
        if ((('disclosure_' + state) in PallasartV2.messages) && PallasartV2.messages['disclosure_' + state]) {
            let disclosure = PallasartV2.messages['disclosure_' + state];

            PallasartUtils.createModal(
                (disclosure.content ? disclosure.content : '') + '<iframe src="' + disclosure.image + '" width="100%" height="400"></iframe><p class="bs-text-center bs-mt-3 bs-mb-0"><button type="button" class="bs-btn btn-lg bs-btn-modal" data-bs-dismiss="bs-modal">' + (disclosure.button_1 ? disclosure.button_1 : 'I Agree') + '</button></p>',
                disclosure.title
            );
        }

        return false;
    },

    exit: function() {
        if (('exit_app' in PallasartV2.messages) && PallasartV2.messages.exit_app) {
            let root = PallasartUtils.getRoot();
            root.insertAdjacentHTML('beforeend', PallasartV2.messages.exit_app);

            PallasartUtils.showModal('#exitModal');
        }
    },

    totalPrice: function(value) {
        if (PallasartV2.slsord && PallasartV2.cache.slsord && PallasartV2.cache.slsord.PriceTotal) {
            return PallasartV2.cache.slsord.PriceTotal;
        }

        return value;
    },

    renderingMissing: function() {
        if ((PallasartV2.cache.popups.indexOf('rendering_missing') === -1)) {
            PallasartV2.cache.popups.push('rendering_missing');

            if (('rendering_missing' in PallasartV2.messages) && PallasartV2.messages.rendering_missing) {
                PallasartUtils.createModal(
                    PallasartV2.messages.rendering_missing.content,
                    false,
                    false,
                    false,
                    'bs-popup-dark',
                    false,
                    PallasartV2.messages.rendering_missing.button_1,
                    'bs-modal-popup-alt'
                );
            }
        }
    },

    renderingUnavailable: function() {
        if (('rendering_unavailable' in PallasartV2.messages) && PallasartV2.messages.rendering_unavailable) {
            PallasartUtils.createModal(
                PallasartV2.messages.rendering_unavailable.content,
                false,
                false,
                false,
                'bs-popup-dark',
                false,
                PallasartV2.messages.rendering_unavailable.button_1,
                'bs-modal-popup-alt'
            );
        }
    },

    substituted: function(removed, added) {
        let id = 'bs-modal-popup-substitution';

        PallasartUtils.destroyModal(id);

        let modal = document.createElement('div'),
            dialog = document.createElement('div'),
            content = document.createElement('div'),
            body = document.createElement('div'),
            action = document.createElement('button');

        modal.classList.add('bs-modal');
        modal.classList.add('bs-fade');
        modal.classList.add('bs-popup-light');
        modal.classList.add('bs-popup-substitution');

        modal.setAttribute('id', id);
        modal.setAttribute('tabindex', '-1');
        modal.setAttribute('aria-hidden', 'true');
        modal.setAttribute('data-bs-backdrop', 'static');
        modal.setAttribute('data-bs-keyboard', 'false');

        dialog.classList.add('bs-modal-dialog');
        dialog.classList.add('bs-modal-dialog-centered');
        dialog.classList.add('bs-modal-lg');

        content.classList.add('bs-modal-content');

        action.classList.add('bs-btn-close');
        action.setAttribute('type', 'button');
        action.setAttribute('aria-label', 'Close');
        action.setAttribute('data-bs-dismiss', 'bs-modal');

        body.classList.add('bs-modal-body');

        let container = document.createElement('div'),
            row = document.createElement('div'),
            left = document.createElement('div'),
            right = document.createElement('div'),
            leftHeadline = document.createElement('h6'),
            rightHeadline = document.createElement('h6');

        container.classList.add('bs-container-fluid');
        row.classList.add('bs-row');

        left.classList.add('bs-col-12');
        left.classList.add('bs-col-sm-6');
        left.classList.add('bs-bg-gray');
        left.classList.add('bs-py-3');

        right.classList.add('bs-col-12');
        right.classList.add('bs-col-sm-6');
        right.classList.add('bs-py-3');

        leftHeadline.classList.add('bs-fw-bold');
        leftHeadline.innerText = 'Unavailable: ' + removed.Text;
        left.append(leftHeadline);

        if ((removed['OptionId'] === 'PT-EXT') && removed.SubstitutionText) {
            let leftText = document.createElement('div');
            leftText.classList.add('bs-mb-2');
            leftText.innerHTML = removed.SubstitutionText;
            left.append(leftText);
        } else if (removed.InfoText) {
            let leftText = document.createElement('div');
            leftText.classList.add('bs-mb-2');
            leftText.innerHTML = removed.InfoText;
            left.append(leftText);
        }

        if ((removed['OptionId'] === 'PT-EXT') && removed.SubstitutionImage) {
            let leftImage = document.createElement('img');
            leftImage.src = removed.SubstitutionImage;
            left.append(leftImage);
        } else if (removed.InfoImage) {
            let leftImage = document.createElement('img');
            leftImage.src = removed.InfoImage;
            left.append(leftImage);
        }

        rightHeadline.classList.add('bs-fw-bold');
        rightHeadline.innerText = 'Substituted With: ' + added.Text;
        right.append(rightHeadline);

        if ((added['OptionId'] === 'PT-EXT') && added.SubstitutionText) {
            let rightText = document.createElement('div');
            rightText.classList.add('bs-mb-2');
            rightText.innerHTML = added.SubstitutionText;
            right.append(rightText);
        } else if (added.InfoText) {
            let rightText = document.createElement('div');
            rightText.classList.add('bs-mb-2');
            rightText.innerHTML = added.InfoText;
            right.append(rightText);
        }

        if ((added['OptionId'] === 'PT-EXT') && added.SubstitutionImage) {
            let rightImage = document.createElement('img');
            rightImage.src = added.SubstitutionImage;
            right.append(rightImage);
        } else if (added.InfoImage) {
            let rightImage = document.createElement('img');
            rightImage.src = added.InfoImage;
            right.append(rightImage);
        }

        row.append(left);
        row.append(right);
        container.append(row);

        body.append(container);
        body.append(action);

        content.append(body);
        dialog.append(content);
        modal.append(dialog);

        let root = PallasartUtils.getRoot();
        root.append(modal);

        let popup = new bootstrap.Modal(document.getElementById(id));
        popup.show();

        return popup;
    },

    floorplans: function() {
        if (PallasartV2.cache.floorplans.length) {
            const naturalCollator = new Intl.Collator(undefined, {numeric: true, sensitivity: 'base'});
            PallasartV2.cache.floorplans.sort((a, b) => naturalCollator.compare(a.index, b.index));

            let columns = document.createElement('div');
            columns.classList.add('bs-row');
            columns.classList.add('bs-justify-content-center');

            for (let i = 0; i < PallasartV2.cache.floorplans.length; i++) {
                let column = document.createElement('div');
                column.classList.add('bs-col-sm-6');

                if (PallasartV2.cache.floorplans[i].caption.length) {
                    let caption = document.createElement('h5');
                    caption.classList.add('bs-text-center');
                    caption.classList.add('bs-fw-bold');
                    caption.classList.add('bs-text-primary');
                    caption.innerText = PallasartV2.cache.floorplans[i].caption;
                    column.append(caption);
                }

                let image = document.createElement('img');
                image.src = PallasartV2.cache.floorplans[i].url;

                column.append(image);
                columns.append(column);
            }

            PallasartUtils.createModalFromElement(columns, true);
        } else {
            PallasartUtils.createModal(
                'There are no floorplans available. Try again later.',
                false,
                false,
                false
            );
        }
    }
};
